import React, { useState, useEffect } from "react";
import axios from "axios";
import pako from "pako";

import Inbetween from "./Inbetween";

import { CookieBanner } from "@palmabit/react-cookie-law";
//import { Helmet } from "react-helmet";

import ReactGA from "react-ga4";
//import { initGA } from "./ga-utils";

//ReactGA.initialize("G-YC142WEB05");
//ReactGA.send("pageview"); // can change message to whatever I like (I think)

//import logo_svg from "./logo.svg";

//const baseURL = "https://papersrepo.herokuapp.com/api/"; // https://papersrepo.herokuapp.com/api/ , http://localhost:5000/api
//const papersURL = "https://papersrepo.herokuapp.com/paper/";
//const testURL = "https://papersrepo.herokuapp.com/test/";

const herokuOrLocal = true;
var baseURL = "";
var papersURL = "";
//var allPapersURL = "";

if (herokuOrLocal === true) {
  baseURL = "https://examoo.physicsfox.org/api/"; // https://papersrepo.herokuapp.com/api/ , http://localhost:5000/api
  papersURL = "https://examoo.physicsfox.org/paper/";
  //allPapersURL = "https://papersrepo.herokuapp.com/allpapers/";
} else {
  baseURL = "http://localhost:5000/api/"; // https://papersrepo.herokuapp.com/api/ , http://localhost:5000/api
  papersURL = "http://localhost:5000/paper/";
  //allPapersURL = "http://localhost:5000/allpapers/";
}

function Main() {
  /*
	const location = window.location.pathname; // gets current url
	console.log('loc: ' + location);
	var loc_path = location; // '/gcse/maths/aqa'
	var loc_parts = loc_path.split('/'); // ['', 'gcse', 'maths', 'aqa']
	*/

  const [pathNavBar, setPathNavBar] = useState("/"); // for remembering url of exam page (when going away and back again.)

  // ---=== [1] ===---
  // ------ GET ALL DJANGO SERVER DATA (excluding papers from S3) ------

  const [qualData, setQualData] = useState(null);
  const [colourData, setColourData] = useState(null);
  const [subjData, setSubjData] = useState(null);
  const [examBoardData, setExamBoardData] = useState(null);
  const [paperTypeData, setPaperTypeData] = useState(null);

  const [testData, setTestData] = useState(null);
  const [paperData, setPaperData] = useState(null);
  //const [allPaperData, setAllPaperData] = useState(null);

  /*
	useEffect(() => {
		document.title = "BAD TITLE"
	}, []);
	*/

  useEffect(() => {
    // useEffect is for updating "side effects" on every render. (a side effect is a function that relies on variables outside of it own vars)
    // Common side effects include updating browser page title and getting data.
    // By default, will run everytime the page is re-rendered.
    // Add ", [count]" at end of useEffect to only update when 'count' updates.
    // Therefore ", []" never updates after initial render.

    // Some effects have additional code for 'cleanup phase' - something to do with the effect returning a function at the end

    axios
      .get(baseURL + "qualifications")
      .then(function (response) {
        setQualData(response.data);
        //console.log('qualdata INSIDE:')
        //console.log(qualData); // returns null *here*, but NOT after useEffect!
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    axios
      .get(baseURL + "colours")
      .then(function (response) {
        setColourData(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    axios
      .get(baseURL + "subjects")
      .then(function (response) {
        setSubjData(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    axios
      .get(baseURL + "examboards")
      .then(function (response) {
        setExamBoardData(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    axios
      .get(baseURL + "papertypes")
      .then(function (response) {
        setPaperTypeData(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    // Below is just for testing. Not sure why its necessary
    // !! probably because of '|| !paperData' below. Can just delete it?

    /* NEWDATA 6/4/22

		axios.get(papersURL+"uk/gcse/maths/aqa/")
			.then(function (response) {
				setPaperData(response.data);
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
		*/

    /*
		const {dataaa} = await axios.get("https://examoo.s3.eu-west-2.amazonaws.com/eg4comp.gz", { responseType: 'arraybuffer', 'decompress': true })
						.then(function (response) {
							setPaperData(response.data);
						})
						.catch(function (error) {
							// handle error
							console.log(error);
						});
		*/

    /*
		const fetchhh = async () => {
			const result = await axios.get("https://examoo.s3.eu-west-2.amazonaws.com/eg4comp.gz", { responseType: 'arraybuffer', 'decompress': true })
		
			setPaperData(result.data);
			console.log('got the papers.');
		};

		fetchhh();
		*/

    const urls = [
      "https://examoo.s3.eu-west-2.amazonaws.com/bigpaperfile.gz", // big1comp.gz // txttestcomp.gz
    ];

    async function exec(i = 0) {
      //console.group('json file: ', i); // creates a 'group' of info in the console
      try {
        // fetch file with CORS enabled
        const res = await fetch(urls[i], {
          mode: "cors",
        });
        // convert to arrayBuffer for further processing
        const buf = await res.arrayBuffer();
        // or get blob using `await res.blob()`
        // and convert blob to arrayBuffer using `await blob.arrayBuffer()`

        //console.log('input size: ', buf.byteLength, 'bytes');

        // decompress file
        const outBuf = pako.inflate(buf);
        //console.log('output size: ', outBuf.byteLength, 'bytes');

        // convert arrayBuffer to string
        const str = new TextDecoder().decode(outBuf);
        //console.log('json string', str);

        // print json object
        const jsonobj = JSON.parse(str);
        console.log("json object", jsonobj);

        // ADD NEW AQA PAPERS HERE
        // if id includes 'aqa', remove
        // Add new objs (generated from files)

        const jsonPapersRemoveAqa = jsonobj.papers.filter(
          (obj) =>
            !(
              obj.id.includes("aqa") &&
              !obj.id.includes("synergy") &&
              !obj.id.includes("art-design") &&
              !obj.id.includes("english-lang") &&
              !obj.id.includes("english-langlit")
            ),
        );
        console.log("json object", jsonPapersRemoveAqa.length);

        // const extraPapers = [
        //   {
        //     id: "papers/uk/gcse/history/aqa",
        //     pprtypes: [
        //       {
        //         pprtype: "1-AB",
        //         "yr-months": [
        //           {
        //             id: "papers/uk/as/biology/aqa/1/20-nov/",
        //             month: "November",
        //             yr: "2024",
        //             papers: [
        //               {
        //                 name: "qp",
        //                 url: "https://examoo.s3.eu-west-2.amazonaws.com/papers/uk/as/biology/aqa/1/20-nov/qp.PDF",
        //               },
        //             ],
        //           },
        //         ],
        //       },
        //     ],
        //   },
        // ];

        const extraPapers = [
          {
            id: "papers/uk/as/spanish/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/as/spanish/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/112bbdce46e3290964b754772febae92db63c748.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca684eab87198aa23cbcd70a6ae5021988d09ba4.pdf",
                      },
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c58bd29d38ccf2f0f063db3e2ea04d5456e6aba4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e198b563c4a6fe7a8d24c27e0403b5ea9dadb76c.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f473f2a216aecfd0644ea45e6cf0351cfc2b945.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c235b2689417e8db61bcf5ee72bdc7297bf00f04.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8fe8d8aeb69f28f35eda3dc4f21685f7e1b8c79.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e33e294933a7a10230e1031b55b615efcef5837e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6989fb072d5a39a734a562239f5a427db84ea36.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e8fbbb0a2aa7d41ba03231d708bbce57218187b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e71e5baac7c5f9e71b033c9f267aa0f4c376621d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc1f616c7b2f4d02123f12874ad90b70fcff759e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9dd183266db1209cf6edc1ae3b65208aac156bea.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2f69dbf11f9aa82e8dbccbf1844433f913ba8f2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64bb6b6a7b72a4b2acffa29f268ac543886bd47c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6339594e8eafa7f5dd688454145d7a1a30ad46e3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75ec1bdf7d1a40ac2bf635dd4bd5fd7db44b06e2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fd9a7f94ecc971d1f6eb1d1e91b110ddb1f1dc2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8710dbd7287f2b07b3b1490e3aa829e6a6441a70.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0701a2e0769fc527a0faf0f2ea8910c18c1b9da2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/spanish/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab72f8f37569174fd04bf8b6bacebe9edea782a1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e49d4fe6419a8dd959614bfb620baa62b32fffd3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b859cdef6da9fd29aa2f5fcfcdabdd737b13ea07.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0d439d1529e38eb10004eb2fac37a6a1363fa86.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfa443b1cb1a241115848e8c51d2b37d5d8bed93.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6901a56c6e7c8d9e0e0bc8313d3baea269fb7c9e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/505f7d6749fb032f85ba6430fcaf6c93c4c01efc.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4518525c81e30078840ca134d9a5f81e677af3c7.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbad1a916faecad431ec894892abe6f94da6c542.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2346b68f5f7e868016e7fb88f56e5b712ab5b2f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a1e989ebbebf95e55c375141679de58d7b25ee2.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/964f2cbddaf5c6da7d450a63bdf5fc0319751ba3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5229e2ff6a9138d4536f8a7a778ba706d846696.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/baec8ded4beae0695c8924f3cab3863a4a98df73.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5806373712f947f9137af493e0c4443f8259b321.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7af533ef28a858ccbe4adfec3a7ff7040d1059ef.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/spanish/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e475424beb1eef5600023c5a56bca01f88516e3f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c03842404ce08197683f49c2d7b61ed16667cec9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3c27a834e7eed17ee16144e446a834c16679f98.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59f8aa651cad2df5d982d5fede63c00f0f2cbb69.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9d99af3f5570caf7a120ea348f67168b42fe4df.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/963bf5b5372cc212d6724782a087c2d2c7cd7eaa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7436d9596b79396459709880ed0180ad5678dc26.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f95686dc6c6ba522fd40791440a26cfde278c2de.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab10b3af71e2674eeecdbe667538311a433459ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/spanish/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4503aecb4c3d83315a57efc12fa41746b046632.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54bee35e850c8c0344c533df30357b47c6b33ad5.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/spanish/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/spanish/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/538256c2419352199082802e14e60191e85b2d25.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02058eaf440ba5c5e8983ac42611437ce1ff835e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b51e3952e670f51501a6e943ff6bb5d8386d407.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef3968b9a643af1afa5d310bd9209e6f3ce9cd24.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/129979e4e73e42948039fd0c28baf7b1781c9add.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c639df78aed48a43dff1390662fcb103c181b8f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb71749f533dc4bfc7878cce6348b957e5010186.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/858579ad7f61791e674c1dce7fa10c32f3ce429c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57100c8a62ac274889e257d118d7695827bc7879.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ac7f6172b5aa91777ba4d92ea10405a2c256c6e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f80fabb2ebda64b21ab871f8a6ef7ca5841349b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d256626a40c7e95779a180a3c15528bc641db9fe.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9dd94d0fb29d1bff3e5e4fd151593f17965bb64b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39c0ed16a83044b2e2f5169f4f1dac4f2cca317c.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aeeac27f387dedf6177b23b4b158cc454c6406cb.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf807338849d0c5d3eeea59af0dc048066e3f6dc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/838e4c17b240137e0953198c5279de59dd298a56.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/459444c73638ee4e0950db358f0bf31fb2b715b5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e77cba2dae5ea2fed31af42fe5534f5f8453b91.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0139a508ae23da0d0787d689493d94e71dfed26e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7d5dbb16b2522ababb369a8bb7b136c83ac4ce6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/spanish/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98321f9f6a9be12a0c398f5fd7aec200227e0f34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9050f210a390318df5ab827b2d2293e44f8f2946.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44222132cb80c6dcbdde8ce84d988f17ea0daeb9.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c53be5cc4ccef98860c87abb517e62c5fcf26063.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a7d2e69f8d5083da5a6fce4687cae86890b4bde.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6a2574f49c80fe0332b2bdc1c722045a5a4ac6d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe7ddaaf313c4e44f0202b3b908bd5a050132c47.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c20f78964fab7a061f97c2e06c14f5c12cac286.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/756bd258e0171bbc3eb34294316ba20316c7c30d.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e6669a1362738d3f41bc0b92630d966b66db981.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6472b8b507713fa9b01cad5088bfb1eb90603844.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46ed2ff75357ade59b68cfa1fb764047412fc75e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fa6b5f73ff7138d07c488e7b3f5ab4dd6cbf9b8.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bcae9a99ecb35add9c30ddb6c54d0499a476cd8.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ca58d8f6e9ba575be84681699added886776b4c.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fafeed7deeb1fbfc227ef71753a1736879add1a9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/294dda34d069dfd7ac6dfe183105aefb61b73909.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a426cd898053aad6a1881aec534871501dc5f9a5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c785ada24600e8566147639576cc926055816840.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffc4147571ca209b59c77b6161fc020be942c80b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebd7ee44745f565dfc17701b766b3537cb6a9282.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd3f7649419b76b2f1bd9a4679d8b0720f17f933.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86d6faf9f15a31dc6ce39a12b4c578869685f506.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/spanish/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/675a0f499d647b1b915ff7de5ff388997b30bf9f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f697ae149a508cff6afa4db5a4e6ceefb24fffc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62cd696263132d54ef7b86cadca951f790df0f39.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/504428de680e0da103c1b2b6017343b11f6b5cec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cd6502a42675bab3bcf80466ba88940dc2d5e03.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/602a48844bc332fd1ad3591ef7b2dbb047b69fb8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbf13cad8463ad693766c469dcacf44fafe63d80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/231008c42eb92716cb47bea41906511684bc9731.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/spanish/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41561d4d148b6ebc6ef861bd050d4891fd54a3cd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58f34711caab892fbc5030576ceb2e9480bc6ec4.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/french/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/french/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b13efd6d7ed45603166e52e7ced6b0ec2300ad1.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b862569b13b4bc1bd4b4264858b7919dce51a72f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b66db28bdfe4a4d87e44203f12cbe86dbb78549f.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90609b46ade99b38c01b5ee0b904fb16ac1dcbda.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3b6f1d80db5d0fe99e865747626a6414d8367f0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e170d04279af98da74c433db00a82586b4c748a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd68778f10f5d94e0d01219631738720c9bf91b9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/601a3f69a3bfcf00ea3f41506be1fc49ab2cc106.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9bbea802c4c34b1317711fbedfb56f0f061e4682.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/278f82e8a2f009918c63a9d84eacd87b973b341c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/109ecd87f0990d3485ab4e0ff0ed2fc00971a70c.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d4f2659d3eba01beeaacf31e4fdaea96c8c2a1e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/429932852f5a884f2dab7abb492430a0dbea0fd8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef8e8ed050344a3d41ed09339b026249ef3946ff.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93e134057e8748f22d600c32a28b14098371c0cf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05a2ca6fcde3cd60d93bfed4c70061bdd1ed93c4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a636f62ef7cc9b549e26efccca6b835c87d10b0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c98145dabb7c8d8ea356b029f4d114d8acbaf9d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d68b7b96980e28bf1e012371678f028b5b996a64.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08b4e0214e1f4a9146611a5e8f7b76da081099dc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bd7dece3ae55d352dc7b42d951130c4bd1045c1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff74027769b7e60ad1047a23bbd89e3a973c7b28.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/178bad86a7ea759e7e7cf6196016fafa512879c0.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d099e3042d1ff76d8099dccf84885aeb12001bc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27282ccf07c24c2cd1290d05323cadf7978a6b03.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d03a284b81ac96dae529836fe4da26d4278e863.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b9eabc4f2bf21b743e137bd5606c6f3c782b919.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/french/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62d95d86036f82387047255a1ea6e7179eaaaae4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/665a8cb1a9e26bf450401b4b691c229381fcd44f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/322d64b0064a73f858d431f7f153ed1ba6d34c47.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0323de196da855b23439300baf1389962ee624af.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bd14ae91de79057b77537e6a12cd00c7a0de4f5.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b36cae597a67b0304df4808d3c8d6bc25e40097.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68b64e038b3be1ec4868a69c79bf76ac8432bc6d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa33548ed82f39f0bc770c0586e7fc922c82c81b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7da84b6b1c51a856f0bb77f28987df565636bca.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6dc41522c3f29c8c97ee66a21ef8209a688728ed.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3f8663ba38dfe7e1e2a734b75b0938afe6aef75.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/818ab3ee4f37446676e0a846b8154fb2c40d6af7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86e5b50d5632edce071f6534eaee81c433e95731.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/800cbb75e6adcd846c2414bf7aed25a6d3447d77.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a57b54a6cb9b8fc087a7020a85fd36d4d5c8abdd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fbbc79063866e817d89e1232635984dd762401f.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93f68feaca497eb5a96ba38fe6137b5dab67e74a.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7aa920fde9c258da6e5242baf37d19f88e3394b.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b667b43b773a3cb4a346df462b25ed31694e9062.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f2fcc229919cb7736391a49d02b80dc63d91090.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e20d5a184ea1c702494edbd65c7d76b69f2508db.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a617bc625aa87277085caae731ac8f4f38d0e082.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/191b2d5e61bfbf908d51852abe359b34f35c0e68.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/706c944607d9e301ae82920c7b336e22024eeab2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/696bc0ebdab103192018e42b93fb9e30bfc59fe8.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d0beb78adcaad5684b9dc874ee59aa495b5c2a6.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20fc5e970c386db2f06f1433c16f0b012c4001c2.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/french/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c41adefccc7fc0beb6a88dd187a4e2214c6de9f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/945f476ccfc84151e189194a11bcab1a2012a01f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55f5297cc8a77d091958d433d0c6afc3d54bee56.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b959c045b5a64f0735be7be5475409ca5281cd8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49087d786b04dc22e83237c41052446e8974e907.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec343ff7308d9a1f9090c07f8ce7e37b31bef7d9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3415bf052e958e765eb4e2449104e7403389ea28.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24d9aa41adc4aa5995351870e2753b46caf663f1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a1cd73ea50e71d0e0ec1d649ffd15ecb35ea6c7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0812d239c801d2a08da184e602432fe75ced09a2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ee5d2240a1f3566afc077b120af2f05d708f4fb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/french/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c410b8c331c94ccb22fd8ed3b6b49e78052043ef.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df0f84c7be35360a55975cc864bdab430b94b89a.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/french/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/as/french/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/53ecc772a5777ad8a9c3fbf31c0fedc84270041e.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a8c36bb7ed7e5b849e0400f0bcf36bf71da4ff0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3725ce8815bce707e1e3d47fbf6596cf7ebc62ab.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff9fd0ddb0e140290acea228bc11de895d0fcb19.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/144a4c5ea577e78cf32bf0025062fa605ae661c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3b77052bebddb52119bf296f4892baeb6cb98f7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b49928f2bcc4dcf2bfed85b9bb2500186463153.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19728a3752d57e6a4e5bae8dda9cf94f90dcc810.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea2caad042653831404270c9a72aeb2be3f64776.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a12abaa08edc3e9599bd4295a70a5ef81a37b0a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33b940887de35746b7f1e85f957de7aa0fbb02ad.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93c4415e25f25271fcff964f0fac42c2221614b0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0f6700ebafc7ebbe3a18932f002867ce49bb016.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25bfd4d255f67edb656ed621a0cc945ba2269305.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7aa5e52e658a639b63a82e7dfcab36f00816efee.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49c64c4003895087c14cd5ce51fb18f4cad09262.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d421a8548c045eb0d5367a48e74dfcfd9b773ff2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/760d275e268b31b1d143f7ac25c225d7a68c89a2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33c602a28ea3f556937ef8d8a8b8b5e0a001fb82.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ec13d3daf07b96c9108c11de328a7363bb11555.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/french/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cd958621d85f96ea6fe2798fad4270a8da1aed14.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/304659b227f09822fc91b5168dac9ff6443d8a36.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03615477f40a31eeabc3d150c4f78348e65c1a2f.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8417bdfaf211aeb0d7769c8ffad2222598209a1.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7793ccac453f4216c67b9d2d6bce9d3d15b2e34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5d47a20ce68aba01f558416a748db3a8a1f23cf.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14b5fc9349ad8754276681d89a7e6e8110f9a146.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49cafa97ac458b74b5a736e0703d79b9b4ba78ab.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1ee3c64117e7307d78290aa6db325166a3bc342.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df156a8cc7f1e19f5a7511ed5eaff38a994607f5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e66c2199f31cee4c7d840872b2a865b4c20fd42f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69eb51ab8abf5edde52f22345e3a953f533a9916.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b73de7266f9a629f914affdd454e97f50ed62fde.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ed3b0666e22602d5b4ef9ac8594349850ab2e9c.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f9ecd6346746199318160388c6b47fda330db6f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/french/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae35ec74e66460591585c9b8a88257a475b5cc25.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ee7ca48a66970140080f2f108da1f01b1e29790.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/125ce3c0cbdb0fcf8846f764f4f57926300b592e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73ec155945024b758b83c29037a4a4db5703e4f4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21099c7249533fcad8d7fbabcbc087dfc0d2a1a8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/959c0de831cf0d76e0ef897e99f611145f5f12d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2454a8ef6256ae58072b7891d04bb31580bfc22e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/024761008ab3d9899d77e12ca0a9a2b6278efab3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9abfcf7656850de868c1eb78983aa0da0c254859.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/french/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25e1e375cdd015ef7309bf72eda50eee7cca7bc6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dd9d5c33fa9824afab64416ec9a1b8f3d52299c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/german/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/as/german/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d2e4a9a97c433bdd6cd7d310ecd3b222461db5b.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df1f51e98aed042a6c6b4a41cec2fdd763801c5c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26d99d6a63b58db28ec65d50fc226ff2825ac6d0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0d9e886edd6727a67658fb83326d16d89d9df2a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb63b8be3bf3776d8db6a277f9ea49e7d00061f4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82c1e789b948ed25b23a711dc4a56e897616fceb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a545f75b27ce942f9441a073db3b75478d6b360.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9612c0aa5f74384f8c67cf20c089075263d2abcf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8507bb7d0e8b9b073dfa438a8cbaf8ce290a7c06.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/468e4ebdf8e515fb90d99fb096da31a0301e7019.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c92f2384a43e9ded9ccd418695fe5172143acdb8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8c5b2616ce7827c5ec7a250bb914c655b44eacc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8508538aaa0e32eca6da734c405e3672ca943bf0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bce56819744c07fdead6a20d5b3955c77470e65e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12c4f37681c386f3c664b723556fdb38e132cf64.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b288b47bf99788b04931f2babfbf3d1ec46d3f4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df5698e7b810c07fe73610d9707885f5bc583284.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8f8c1b2b5a65785149bcc4f31e92b2a178b86d2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/german/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6251d4dccc1a8b5309d58584ae819ebcbbfa7e0d.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5837985f33228fcf0c9996501a0cb8295c0c1dc1.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db66b5030ca84c5511063af3d239b491f30d64a3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/749968262a866852cf24684c99019c8cd2e3c245.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d16d2a0a853f5781361ee9331c2817f62e25d730.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20d03fa76fb8e4a5c6d32c69d7ceb3ff2c5d7d98.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0541f0e1d103284e7406fb0b4494aa7936065101.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8734c99eefeb01f7fed6b0ca6028f88a20123416.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0c29ab0821e284e13901a16db0e3cb2984c4357.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e4de4f8035f99ad8728cdc79c931bc6b50dbb11.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0e83e06241b0c3edd85d7fe659663aa1c23a8c6.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/63d35d69cf74c2d1283c83a56d9b03013b9e70de.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/703e8a3cc8e012fe5dbe860f32c551d216d1339f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84a5b6836f12fb641ba0e98575aeb24bc6ffe108.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d72cfc205b511a1034b875c6cf3f6493cf605979.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7c92759313ddc61788b53ac3f659a2c4ae4e16c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/german/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98a72a82c39178e9dd5e09e1fcba6beac3ae6aab.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5143ac9251eaeec31917f4dc6740a1b915fcefcc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ff32764684dc5f3278f9372a0e04f7b622b64ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef988ed98038bf0bfd4ddf422a6ae05fc4d775e7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21bdc9dd12d6bee0b4c939f0ff6aebf695661e4b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35a2979076905864e46adec8be93672699225ed8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc61ae295f93c82876f4eac5f109a2b4fe3d5e1a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cadd41b0915bf1a462e4b748afd63dbd389720bf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3560bd55425c98b673a2959802ab10891aa37056.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/german/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c5abcd9700a8a14f38c71a92dbfe4c1d075c929.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e4145a3a9d5fed3087713f6061dea8f43d9f339d.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/german/aqa",
            pprtypes: [
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/german/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ceaf3bbcd81a453d5139f770a27f41375f67f95.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0590817be682b425c82a59b65b8967dadba4197d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d986ef63772ee5bd5cafcc1f8a78663defcdbdba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/baa246817b915a433a3fde5995b90f99dec73889.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d20211ca4c5d7086082623c26b4192782ba8cebf.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/503249980b545f7d84258b8fee882dce33efad17.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8345e5275ae3e2ba35cee7c734827f2b75781d60.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92382c8faccee2d16cb60df04cce1000dca28147.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a6c0eac07efde2bbe017fc91f26d5d5d7fecaf9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e000360c1ac81ce403236ac6afc85bed90b1b18.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2fa9e086832ce0822346a92867c17712ad9602e2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf0c2a14d4e376a758e2a5f946f2e956ab1e2dc0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f924ccdad0fdb93027ba578f6ae5699fb0db52d0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aba662fed3386d587f978761169cbc66e7a85818.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/749723e1fc266f2c5eb4c63000c1570829f358ab.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa164f2c637bf717bc3b42afb14b9c8858f3d50e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/401497eb5060c23e9b8e71d04a60cddf2cfade17.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7222ba609f1fcf31ebad030149cdd65d45b2f718.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d18ee19d408bbe1340af3a634159c22f27f382a3.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa68c3243d31df32bb570084a0037d6c8471eccf.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d01fc6a7847b152871bb2e81d78766c1ba7ed1f7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/german/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/266cd3e4351bdaae22739600142100cf0e53ca7d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f88e8af4591189dccc52302dbc727d996839af08.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dec6502c545b809bbe8d4e66eba74bc7e826404e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/555dc7e4bbb86d7a8427b0b0517bc4f7acb9c079.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1731d0027a93b93f6c550e8e5f0c57bcda0456c8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fa2e17905586878bb12b3634695b97e90a47892.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07e7595440aef88c526c6371b2085cfb5e0633be.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a00fddc1f30d6b96570e0af34b070493550fb7e4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cca0d401668499098ddce1dc0bdf19fd8774c26b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/german/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/101d5412dabad3f9c83094ca1adcf32dff9022fb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b4a8344b6b1167b9164ac847372e07f54abc6f5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd5f0d1cab69d546086b436186290a4c1ac00403.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d83c3034fca2fb00e128e883f66b5b980ff19ce8.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eade74c8e5fe5524c2615559b98a49caa17b3d38.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f342c7474d5c7cd7e395f066447dd51ad017c983.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c5aa4d496e032c8b3c9c9b9a7c000e6424d7444.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/355bf5a32512c28606794c52756fde584362a6b5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d60e4ca6cc51a3e4ad27795f5de7df50911456d.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18376d74da9243c5650b8e45689d5331bedad6e2.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26deb79dc232d23b539e91b5c38d00daad55d76f.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35ce5ac1612fea6e6090d410a83fcfd3c0cc3657.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5ab450d5bb00c0acaa91d3358f558fd615b1546.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3fb2cbbeddfc69f169b408414ecf5a69be448b3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87b46d23b5ab08190edf6dbe09e6a99ade2f1c03.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/german/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2928e681139f6b83c2d693abe80628e338ef84c2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a41c31a645cd4bd8dc29c89565f1c4e0d031973e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1012992259dff96210f82892bec43aecc1704ea1.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9518b31c1f2b7122bb9d49705e08e5b46c783a1.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/023ad2e96c7749461806e74fda1222b7277dccad.zip",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/rs/aqa-a",
            pprtypes: [
              {
                pprtype: "/13",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//13/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0339ed81d9cd49663a1ac9d556875831cd99b24.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0312522d0d72395a602ed3a6560ee3d27742916e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/11",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//11/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc9373e586b203386ec047e77cf667c591154a13.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47384b17ae1407dde4033e3600e3250ff4f3a4a6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/12",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//12/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b97d5afe48a151798cdcb99ffe01363698a40376.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56fca9d8387aa0c3b3070100b6c6f36f01029de2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/2-A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//2-A/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ded2780e3d99b1ac9033a3c7bf38c0c27b39eeb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5bcec89967bac72569df625ad4f90c8b8cc6d97.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/15",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//15/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7a4e49ecc9131df74de40b9dc97e0e55d3bedb4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cce415a3807d264587401ad54d103db5792ea9e7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/16",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//16/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/148daa650a7c9394a862fdd6d13f4feecd04b0b0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/661595d3023779eaddb389ef4a914996580b7656.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/14",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//14/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f0ec6c4d157af1d3f148150dbeef91ff7e20734.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/680a5a9b89c1cfebf75623cfa1e63ba907c5a446.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/17",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//17/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0f2d09d54430f4da1dbf8b8d0546a5dd4003dc7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/113ece0ad4ad9cca0e8bbb03741d0163f8a59ec8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/2-B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a//2-B/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4dd9d22541b806a5818d846d68dc8b5bf0dc7ccd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f39e6ce9498be551baab1de08f18130b0004cf18.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "13",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/13/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d1bd7ee364cb7ce0dd767759ba74968feacd1a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64d1b51f1bea5a12a117a222ebb8c4ab1426a228.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/13/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca985272cb3fce64e31f311bd77771519da1addb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/865f087c3321b7e3e1a6caacd1971765180a3368.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/13/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33c3b4e98c564dc8a7c97b3339e48b03d8aa5901.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d69fdfff5932792b4ecf7dd97df612701bccb5d3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/13/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/292b01fc86a6c3d4717f339791686d4b02ce14f8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d6d9a477493246139b6395881e4e6eba07d5bce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/13/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e09f9bfac409a299000de2feda3c5ed28a2ca95.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34feccd332e28b94ff5d6dcaf8e4cc4208b2ea0f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea518b285b863252714347657e131ca908cb6660.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1149d8982ff51714cb4e3c864657320770e32bb7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "15",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/15/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97def0be5689ef1fcd8bce9253235db0c851f424.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9205f8b516ecd5400860f107bc2bd2a00155fdde.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/15/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed42f219fb56af6ca3185fca271beaa9492ee744.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17f26417f9b477c663b9ddc293d7038cfe709208.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/15/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/982b77c75a25e007de16ce4bb60d1dba3c2bbc9d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e4aa6704f6ee2a0cca5ed09ca079631bc2a79ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/15/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5621817a1d2c4912101b83c3c250318446b37e9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/866f3078e8c29b735d44ef2bdf393e156ce5e3d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/15/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58dd82e344aec19271ede1b80855f7462b4bd317.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffb8351231fc551297653b70d7249282e65d136b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ec4cb9063d609826dbfc78b00835eda80c2256c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5aec078e67241ad5081ab35d44613ada54e5ff4c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "16",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/16/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29610b8b5078454ee91a86e28500bfa7d039b21b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49002d7dbae8c4631effaff38009c8c7959fd8f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/16/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e45e409e461b698e6c2a4d8ff23e980043385734.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cfd9197652fe51457b9bd76ec07115c22932a17.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/16/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/161ca6bf776727aab83561390c4c0499e9941005.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5460505ae79e963670aff6b41d05a6b6cb2bdd3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/16/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3f43b9e0682fd60cfee08456f3e83fc397493ff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e5e0fb8b251e65135ee083bc82cbddf486756d4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/16/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f49a05af885702e30d0ec08b4eb3b53b68c725f7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dae68a393df74879f8668007e147e03a88eaa64.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79e5bfd527978b6bd7c5b9ea7868219df73ac784.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7dfa003a0908225d9a8a73eaa415b2a63c6b30e6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a615552440ae5092434e590be130a3f3e5d73135.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d081d3a988289a4835d92ff5595648c96357ea20.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b43fc703547a331d4a4c75353933f2b0fa2eb2c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1b546f3b0122782256f5cd204a26771502c9d6d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/583ff0e8f4ef38d96482096297ed84392b06b004.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/520994fa430984ba358168b87e5d5d4d7bc51612.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/601b3415d097f228689468df8bcb858d5e9c24d5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44aed056bcec59d63d71976dfa73d9b3b8d53be7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "11",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/11/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1058ab5b42799e6929c41628e8b33e09af863c7d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85e2fafaed1dbf01aae8b4f110301b5d210a78f3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/11/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/941293ddd9a96daf8a9992444fe6b2d9f558af49.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bfd32bc7c4a70487f8b62a970f111905a6524e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/11/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50da9afbac8f3f8117f4febc87f0e1d22c490416.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e68063bdc2bd22141cfc686406504507374744a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/11/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/603e5ad30135a974bd0741ea5e1e9f01a8041c3a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c84fcc5005463e968d39d7ba364a3f03323b1f87.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/11/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87c44807bf92a0dabcb293b0f8908ce1671c65ee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a47911a17a1b8e0aa52483daad7516054693943d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15aeea26610d37ad566200488d79f08a564c4c3c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff40ada0922832c5aa3e9d6723b3720909f8a11c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f94d265f0bded9bc249aea0dd5277a36751963e1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a700de3d8e1152f188eb9a3d418c6c6101ef975.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a730a849dc927e0a041d8b9b2c3d64de910fbd6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/198e410c93d6274206801a1b1d830df60cde2225.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13050f3703b74e5e7c281272fbc70d0c450a7488.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fadfd6bd144e1e9e1f0a339005fa5f939ea6553.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be19d6f95768b228a85bd9aa20998ebfeeffa066.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf0d2696cee97b20e31063b67e58e2f6a4057ac1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "14",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/14/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b209cc0661226d5c62a83ef453f8f4d087d07bec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd684a504238bb1ca274c439546be8748ac7392a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/14/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb46911a473a0d077792af0654b49b05d0da6fad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec3c1301119dd1cb9f6553662b4526a64d813d62.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/14/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/654ad4aa9a915dd382caa2976342a3e787fa713d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce5af552ddd1b0dd24d3b6163b065d6042d5285a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/14/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bcb8c36f249a42dae7230a946e3525a5a6af51d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34505e97ebd5361f428934a5fa133d64df0aac25.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/14/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bdae7c9edee18786801c726ac5e0c95f2c1f21fd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f63a52fe1b1a67f9e9cdf79a668841abbf25452.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/769ea98d76468f2dd4ecd7f24b0f64b74e21c2a1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/964fb3426d314a65569d0445deb04f0edf3e4214.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "12",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/12/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad182d34ee1ec936ceec134f127f8eaee39251b0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b1559eb46325e1b69a9e94b69ebb7555cb12b96.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/12/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/648991dbc840ab86586915f82f2c122d8bdfc0ac.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1929581c125b9e1d6d39bb19600147587e983aa2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/12/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/755fd9629f7ebebaa0291305a04b631911b92801.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec6f7a34d71b3a8dfcbff9bf2d7e1badda7a4b52.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/12/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f34de148a1ac73dfc34c731e1cccfae22c5ce20.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3b8e1e4ea12839da206c89b25203675b5f790f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1bbacbf5ae730f06c32e11de4dc08d967360c841.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8879d77e3e57b92c574f5bc5402cad9581a18bf8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "17",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/17/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b334c1bb3317c93cc28faa09d1855df12c819d75.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df172bf07a048c9aea7d7afb3de53b0fc5227f35.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/17/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb072689220b9db9c025f3095f10f9b190e07ba3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/779c1b8f593eeb4db30143de7b4e026aa4f5cee5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/17/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84f77214a9a9e59ad47c463da767834cdb42a4c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b874f2e3e93fae3c9ce6880da046c5be77736301.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/17/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ab75897630858763d22f2302f23219bfbaac7fb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4991d8148ef0a255f0177d4525ddc3f2576faae1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-a/17/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1bcdb432d82dcae1567c28d148ffefa8a3fc783.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2237d39c37bad7630e97b568cb835065c9de3a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/878335e6bf8be20d38f901265374b781ff26794a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f9d19726b315a64cb2d51da9f608af1f3e2dfd6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e77b27e9391cc099d2ff34dbdb07eda405a479ea.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/781a49181987f2bbde67d17f8a6bead5ebae3467.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/968a1b57e70d1dad47fa737532ce955479e7ad1e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/221e74a7f0d6cb0ab12dd2f6abb7c7ced90fb87f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-a/B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/209247f758954dc3f3d5e71e0edb417d0be57cd7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45277cdcbefff202e64b965ed1a0e0e58503a7f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c2058c59e9b2cfc363853f8d7bc821dc1bbb4ef.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/851650551d911b3307e6952d4609f49f460eee3c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/rs/aqa-short",
            pprtypes: [
              {
                pprtype: "/5",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short//5/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/568eb56ad1246f4e38c40286223c8af3b5850a36.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e4896d9212a3ad17d36af5b15737b8685b549ee.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short//4/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e38f14ccfc734fb2846e315642f402444231f48b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a6af537801817d1dc489699e6024d54ef9f8af9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short//3/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed0f67b2e3b69b42112975eb38d57eae3b7338ea.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fcd0740d3e4648918d2f5f003cc5af99bbd4b77.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short//1/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70bedf95e551855dd57f7920f4f8292723cc74c6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c36aace583cf4086ac07e4126e3cf2150725e5ef.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short//2/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3616fd930af0b09c806c688ae6a9980c3db1686d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70e3d0a4d44a17452f341562e8340efd4104fdbe.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short/4/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fafff9726cc7b7c8a7e4cdebd07ad0f321ebfd5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c8a2f7d411b50d3bec1f8b3d09b718a72bc0f85.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/4/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79e8cddfa2fa54d8d02cf6d19f298f5af835a03f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f538332bbba54d6da0b13886e8c7724163901bf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/4/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1f485f40349a615c040a6cb2c0746b1b8f6e450.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bedb2fe7f6f9da007f974b054ec139eb980a0f71.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6c5332c095a27a2a1077b4932d0fbbb6d4aa35a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb1cba2ef88bcd9c117634d9746270ec306f7387.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a2240b80a49684e1eb8d875d587a8a80629eaa7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9904d95bdaefbf3bdca927054af7797fe37633d9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "5",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short/5/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15533e66a6bc585983115ee80215021774eca497.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/638e5f5207df4d3ee4a3abc77eaa7f287bcb056d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/5/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b0c2fa702bebb7e25fe269f000d741a331834d2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55ca740a81aa95fccd3d6253a62a78d7b6bb52c4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/5/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f741e13a4bf0e79166062f5637075106a0b9051c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb0db3c94c43078150b118f1ab4660e7660ffd2e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/5/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59c81bee483a3230defac8b134cb0f3c740fc6b3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e1a2a9770e144688acc19acce52a31de0e41a20.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/5/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0a05ce7a4bc19075fe978acb97cd508eeeda068.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/823520a51ecdd62675cdc109e7a2576f1b7399e1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41e7385518901dae1a6dcff1f91ae134db5d7e3e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c734f74c1a95186e80da3dae766feed20020f7c9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86dd3489b1891844deb84a65dc7b3915732c1e99.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d46d373f181161e26e66cdb3f1f85aa96251f5a9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09267b4e8f9876790ae80c3d75107b4f364f31b6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/762449d5dddc1011d751047c3dc6ac789186cc73.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3051b6605bfafd28143bb84d3c8a05c5da2dc105.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1943e359f1030b7f4bb6568bd86049cb80f403b5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a35b2c9408d05043a6b52cae8182990f587a4a9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c55ba75dd91b97d4f384864ddd29d9d933a4eeb.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4c13c5e78768ed19d01cd025a7ea68d34d8a0ea.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50d49e040d8b382150926649aa7735a5eabfc187.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f87e463fbfe81a16022e8cfe5a3285707be6a518.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc89bc33a5ba3182ec052574cc73082632d488ec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f24c2d0615082bffbdae9178b5916bf64897a6ac.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4bb1c4d61deeccfdf70385916753287ef50d63b0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5de62c0b2cefe810a692f931cf0459ae341c0260.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6c365ceadcab2a794e1e074c937213ec8cdf2bd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebcc97fa1dd73c0062507c4ac9f2634747c7e3d7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/291f85fa04e1a8339fc0c4af09df8c4a47c390f3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-short/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4f4939f7280ea3a404500aa53bb4b2206f1de7b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1249215338b75c3dd0a0da839e872eb469ba59c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/deb9fb18d824bd86198d116b6f717534aabf5819.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dec0dbf122c4d4f2666ef0ea48aadc3670bb3767.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b866b135726dfe1bf6373fc0fcf3f3ca613093ae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23ccde526a36c4d949ac38793295ee8dbdca5725.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-short/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/567496d2f24122148428fc3dc926946624c9ab32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fca34a8b594897476887c4856722016af3eb6357.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/english-lit/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e6b4c6fe9c3819a911aa944c62d8109ea8b61c3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/78e0e54a6051a0048523e6e15a123dbb46e31905.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f55d9f498261132baf0bcbd55fd4b2cedcd90a5c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73abcae6e343614849e2f0e0d6e6dd9f1b84bbca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b73cd556fec6104526542160c1e5226b6eac162.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cda034854f717f29d8ee892acfa9513d6ba63ba.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2a832fb902029ec6a6513d2afc3c7a0cff80cb1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/730c09b039540e9cb9635075e7f9081efb0e9356.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aeaafff5bd36defd716aac19f1516c41ac3e77b7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b6ad6d5656c8f43735703b17c9ca2c17e76b436.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d6929143d53d47650e853d5dc7999d5cd7b4c5a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5f594eba63b43e4cab478d123ec33603d30953a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be17489dade9adb799a08da10c5ada3d3bacf17d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61fde51f4ce55e28ed1d4564a0a977d18b7260fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79a1317ed85a28da2ac00d062104c6da7db00dc0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fac86b7e7420be81ec642271ec548a427f75f122.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cdc59b9291a5a21b44f660c492ba22e3d48ee414.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/208c0283fbbd17b850b2b70868c97c0483449c8a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2040d8a8c6385a987f789a206f0bfeefa2ac223a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7889d195f0e45f05fa586ca024a9a873b3705072.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f42d7a3a3081260d46a13258e346b79ffd80c88.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e9887369bfa0b63178ee201ae57c43d33fa15cf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/231a9021c8b7e061a421c6ab26ee79c1e693a075.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7e851228d12cfa75b37e30db10195ce3561d9ae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/337b7924f9c654c9fa3eddf3037ac4931d82326f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1338ec75c040af16d616f02ef7ec9926f5dd7543.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f82f11d077bf4bc94c2eb073d68f145542a4356.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ae5577db64f289c41e1853931a24e2baece0f22.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f33c8cc15a12834a91a04fc68f5cbbed2e19679.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/616058dd3701ed670ce5a6b53e43be964bf8b041.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a34d2b9f0c940e9e3c5cbe721c065951648b59d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d93b6d58130aa93b8cce96ba8fb5b302f7df632f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca43cb4336daa0820ad2976f6a4899b9bc7f6d48.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb6dbb8251d51d68c42c9d9ab798324d5d782c38.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c6b3190644e8fe887df95aac8709d6815996a9a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/860070a61e9ad263f2600dca8388c0035d86f4a6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a29d350cb4a02457911336282fe50f31ac34dd25.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1c4318f6182c0a78ecb3032ef372ba034e97c5e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6627251a69f6772ab747da14b6eb5dcd9701ae5d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06a1f8526d000ba281779c1e5d15da64fbce958b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ff85b5ce863c73d11022613dd5fcb37d8bac90d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03f761e92d700e28198b3b0762a003f0e801a4e9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cba0d80891811a1661036c848681c8c4351b4cd8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87cd50200dab948260c64919cf98d5b5d411b093.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81f858bbcacde1898015f88a8b3fdfec08453a75.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/947e2457145ee9e0e9646b895a28a51bbb8ed516.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9022b3a06fbc1dab509f153b3b778abc5d7976b6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0cecbb7ec83d4ba2708fd2d740cd91bcc2f7677.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ae8460f91c1fda32ccd9dead9640d20f72d35c4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/562a2dfc018cb7913a124ff5f3cbeff9c89ab007.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2a4f4fa44926aaf1d77a157b7e021ed88a051a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/088f1d29581d4f95247dd385157d4e0222938c39.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5f6dd0c6c3237ad3572d8a6460cd95821178f82.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e883910f723eecc6b61b6414bd77768c5fa9156.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fdf666bd9b9d1b9710bd33a2aef9b403687c8a08.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42b64be016c2a58de5d459d3dc62dc2d50d71f11.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f82c772639437bdead549ed1810cc675a2e2748.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4c50499018a167e1886ddf0a1858fa0906f7bb7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d79737a46423e524b7c84ed72ae39efaeb6ad90b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3081c824ce983ffb7d4e0dc07143cc3366e640a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee1d1c6b8fc38c895a6b712001bce6cae52e1299.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5962911f2aa62143c7d0f04b604a333fe6b136d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbbe9c7a9a7acf3e8e20cde3c57e3936793a329e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a83435e98a5c21dce4ae7ae6caab03614734eac.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/923c7c652589d4719b9db4e10ed29069e1386763.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/005dc71cfeb6eb70884b06c134d066bd1b53ec84.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-N",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-N/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f763f714e755438391080081adb86c4490b89ef7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-N/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea2f51225b6a7cfc53850da63b98cb30a7630d10.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-M",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-M/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/327607b422df524854fc242875baa451667c2d31.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-M/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6939771a56c481354cf299d6b1ac6f1bd3bebaac.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-P",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-P/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd866221b22fb66115a5d1c46315903e8c421181.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/english-lit/aqa/1-P/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6a4f0bd9a052bd79a99cabb656909d378bc365a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "/1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/english-lit/aqa//1/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d389749c44fc94820ebd17f1804fd51de1830327.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/science/aqa-trilogy",
            pprtypes: [
              {
                pprtype: "P1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a84b4dfab2bf60404621638058e3b8cfdc811ed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e72174fd3f7d9fae984ea429ac7f43f2f796833b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/53ad6a26485e7c9c5caf5c3411d3ed99e0a11ea3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaba11a510ac813b2e97e0c016a870f54d7c7cb9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba272ec600b88dfcfc4b23aa4b2f6f42cf24c3cf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91a8b3a41b88897573e9b507c676fb0c5d1a237f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c55c64ce6fbc907dd4e1386642347cf157f700a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77abd3d9eb118dedf76405bcbff33c88329c4e01.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cbd6fc355f0c2a0f089f00af56a64d945e62645.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a4cb1808a635f5c056bb17126c2526a47378fde.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ccf9745b3c44efeb5d979aa69031e87bb979073.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3df3202af9f445646968d46e283527fd8aba903a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a894d51fe40d8d6ce631d031e13928e2e74a9d38.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9e10f6c348efe3081189ffe7f4510da908620bc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "B1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d3e0f85c203c68f4b056f828bab7010be91ec14.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e31a1a687925134f27784ee606401ff4bf7dafd4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/799b6708084fc1dbc7cd44fbe714f0eb4334478a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bce219c2e860bd8488e37880703862ec7edd29c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96954d60b16f92618f61930f23e573bd5bc34850.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/327beba8f011469d605c1ae3fb684eaea84979c2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e97767125f79cc3f5f21511fe9e8dfbbced66fc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7e1c7e042ed5c909a2e86150cc83706539e5501.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d8ea9573982436126b44df0b34760c91ef7cb5d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7be6bc2b67b8e52e04897dfeebf13d2082840d9d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/721df445a5243120449fb3dd14fd31fa2554e972.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32d2a1938e9e200bb1164f6354f456513341c477.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97f6654b8733a2701cba8a9db798f98cdc3a1dbb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05ac00cd347f18c758afcd70bc2b3a570d56291d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "B1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/936323a2270f53f49ab862438d162b66c546bfa5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/442d64cb2019ba3c7d27b78aefc9685bbc1597b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d606d03d6f80f3efd0804ed73755a40b47ea8c44.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10d35a565fbb6f40581134253b8cf35bc265a183.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b2d02c32b2d5b07e3913b3c981181bf0b47c8d6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/618825357451efb937be5ef58faf19d7e373d3e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f41de1e6e6509785b492fa0b47b91bc13485806f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4760abe397b45bf93b09ea0bce1033cd63dc8cd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ed0c2d076d3c04cc2e01c7ef8315b748d8f1333.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77037ca9cde84149f1174b4909e0f43ff44f75ea.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afe4c169d2ce96e8b9322b0a58f93fb4cd3fb076.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba4c248b3c51639967664e956d36e2ebdaefde89.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c846a2b1bc2cc90d820a67f46fc9093a588607b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc737de8b113826d93357d9f1075ede9831fd194.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/412d899006b62c9668ec41818f0ccbf892ed7d0f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aba87d20de08cac78a814aaf769678aa33d2ddb2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d04d15f8698babd21b5ff1d8060ec45f94d5143e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e987f5326c26cc7a492c5ccb60d634574cbaddc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e274eb423681359abc606df3c4f05e3b302dad7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f22f5afb2ad19c159c50162ac3abb79232615ca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cd959a9001fdc1920b5539abe77c019f4f8c5d2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e162af89b21f261094f0eda4d8001ab57b64a0f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9425f674c6f7eaa59fcb98f22692447f3dd1c3d2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/066ff879d480308086cbe3cea3b1922ba033189d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7901e77f28a349542512650d40aedf2462fd8aa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a88372d6c80ecb27fede06edd19cb90220d07b11.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f8bd169dfc64f9e5feac4cd776153ff18d6b17f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0dbf64943734d0afffe5110a7232db301a58420f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9bd186a74db444c4a5dde4f22fd2d47bf9f3199.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8199f4626b838aa349c6fa3e5c4bfa90594123f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e92aba23a47db644043d90d9868373e9195679d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54b6befbd25c74daf33c740e261dd68c913e98ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/644ba32bba82ff1d62d7550ec11700aee49eada4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a5d70c9119c00b7d3e4322d2a59105f8e955021.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea6324ca45ad9231b64eacfe965aa152dd75b2cd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17b010417f39d745c0b9616aa6ea43b7376ff576.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac346c22d1d8e93d8288d3c17503148c722abfdb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d75180f7fe02c8e23d72cc5594136eb6b89ab94.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2f07125677d4db67412f2f903d6ab49bbdf2fa2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc0c8c844f5dad348c03f7493f09d77e22285931.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64e470935a0d6b05f716ab5c877221fb7955ef0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68768cc68956980a33be77f881d8b04d8584a27c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a712a2bba26541a7f07dd9fc1285980a38f4b1e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcd60099c73a2a5c4f29229f68961e9a8f78df09.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9ff1feffc6002f38bee165fb8dfa3ed1368a41b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eafb61982f3fd5703b37564f8b411b55902002df.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a915ecb7f66573bdd740c507c35fefa8e1b69d9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccd8c27cb916a1f518a64baa4d12ddc889df5c33.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79b12f00bdd2d3937bae8a0ddc6da8763fba7300.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3d6a8b6dedd66cbe36d9cbe808dd49c499c3419.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2716839f7b6fe83f6680a1a68f5d705a7c7164a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a124f614e967008b76eed4af8b2f81e70c9ac6b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "P2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7eafc896cb4b1a383af7eac591fcb7c753f3cd2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e2fe0ed4db0ab732d0a74ccde6bba73b4a3850b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3f850f424afe9593401338e482f6faf32e7ab69.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c9f721f1cfdd2aad12bab0ce48381941f1813fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23ff0482c6e2bc63f03ebe84cd1f75c5d646a7c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1664e705b363e7e38ffb8cb52b09bc9148aac32.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a95099d0ed4575ab1353cab146890d192d94ded.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e2bb88d9fab95d5a43ded30c9caf4a7670a7882.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d29cf05ec3a905ad443a77014a6ce234c40183d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e8bc7e0604ae78cbf2c329008d9e7c44508516b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97f1d201c9a5539c54c32417177f744cfb45dd82.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0055f8f1d01dad14f4d7ea73bc56fa7dece322a5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "B2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0daee5053c8241ad0a166e4f413ccdc361086b12.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9ff0e5cd9ffcd15b41ab9772f431ff7ac99d464.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bae7e15087eacaa9765c45ff5c4787cef97aab5b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29ed2b7cb94e86020470df1c7ecff98c7154a68d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/757a37d993cd88adf3a78312fd0b53357e898aca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/858dd66bf501361632f2a0d1ddd55983705ecac4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/145d95e26af7a3aaf922651054006b09d40528a2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/297154f1bec71831c2f78b0c3e0e3c9040c41b7a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/53d2a9a6d55ec3f215e0f53245b5e5a96dc0ca88.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2cac0da2142fe5a73267f00c98064f6a8d0f6d47.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/95b0b41e5dab2c1c6c4f648a724158529edc322f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3036fbc8ffc9537def10daa102ecbbc280b34adc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/282181702dbf9c207c25427b6b7b289b5ea821c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/249582f30c3ff8adc8245b178df4cd57c23a2d40.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "P1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15e37eb2c19dd8e01efb652824d804c3ac2027e2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5495eb919017d83c2dd5b2252e7de769a1a6145b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e525de23755e6bd3752036bed9c81942f2e7984d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34ad9a3f2178fb65bcdb8a52d3dfc74cd19d4632.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7433c9314dae899d6df762de6f73eb0dd07d181d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef36a2ed88352f5cb60811da8b73ee7b834e0239.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2282a969b76d3c5797cbff5158399016df070696.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1140303f78f9b9cc62cddcb73c6eacb41ee0a470.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ad3c9b46513caa70e678d411ee5bc6868ff3979.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f695fa647609d8e1e3e2480907c4e1d9814949f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24579d8104a03f067c74c68f3a27ba8ce4582e32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7a82fd58b00e15df582e64080b1a17852f08b47.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "P2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/410a68110b8f76bb93edba3e40bd586fba95d85f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3da11954d27125c53abe07a4d912f8f299a22f0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13e72f72496fdfdd9a5d004ddd13685edff4d464.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6b7094159b07d4bd86f90f59c421c35c2a9ab7f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20075ba9748cbbd5bdc0ebf44b86cb5b42b5b583.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d168da103027ecb51df4abcde8964c633acc67b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/355bae0c0f8d5c31eca81d05e3115377e98a4fed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a69b134671e7bc3b801417acd83c0ff2f26842c5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7e263d8dffeaad477f0523cc0eba410cc309758.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b089c9e56d8872b032a80f0c014e3d45266ff691.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "B2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/309999e70d3fe015a8066a2ecf0636c22ce17b63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42691c042b3021a065592666bc40c6ad6ba0e179.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82d75ebade1390880c7b8a478ea8d6067307dbbb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f938299db677f027c534f9584a0d8ad120dc3fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9b0a66cec824b70a4b3dfa37d8d35b835ef9636.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/826c41e7c3442ab2f505022284daea854df2a7ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7513eb6377e4281e1e0ec4856a52286675541047.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a9a3c68348aca1d03c24a6a376fefa415b81fe6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/B2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5c216ffd6450aec78300c9166d79dd2537a721f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c38befe7729fd28d0908164f2a4b5b48109633a5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50e147ef6079fe030b5f3ccb6230eb17a3430c9d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ba36d1296b8b00debdbca594f8e502c14b703ea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e089a833684bf969dab49a1decb7ab9e4e38c0b9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44ae6709f293a7a2c909d8378f91a6a50a318a16.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4f88a2c2b422f8353263bcfd918d77c92421c9e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/745ee9fbd1ada20c458ebb058b2e171dccae1b58.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d215ae7ef0e6383fcc27bf829231bc41627e33f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccd222c936a76b46787ef63f59621d2bd4b4073d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee4fe8d887440747fae63609d4801ad81ea749da.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae3480eed74f5298a6e92b2fb84f773472a817e7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C1F; 8464C1H;8464C2F;8464C2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1F; 8464C1H;8464C2F;8464C2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3c2a06775a7e667dc81e8806c0be937e70a9b75.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1F; 8464C1H;8464C2F;8464C2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44e2bf4cf1b997a3ffe82e9ca8f81d27346e7334.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1F; 8464C1H;8464C2F;8464C2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/779fdabda2e0ec59c0f2509d4355dae476fc9a23.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1F; 8464C1H;8464C2F;8464C2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98d7febf6582029d7b006aff677c66e34482e63b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C1F; 8464C1H;8464C2F;8464C2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/418f38277a5b168adfee731c99f9a22d96099c45.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "P1F; 8464P1H;8464P2F;8464P2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5e3867afad41126429fb2c995168bf8d3258db4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5348e6babccb01247caf19e1e226a479fd75664a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/24-jun/",
                    yr: "2024",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/062bcdf840057c395ba2ae0f97622adb06be5060.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbe26fa32c790ee71a08701df82749718d32bb5b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f82acf29bff38957ca36432d651c9b34f533a9f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62c5ea270b83ba0bd1fc9d140933695fee78a32a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/P1F; 8464P1H;8464P2F;8464P2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5abd249f27365afc0117e0b42640632fbf1fafa3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "C",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-trilogy/C/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ea740e8840e748a8cadcfd3016a1d129d253a9c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/maths/aqa",
            pprtypes: [
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc9ef8262b581fcc2228663a1afda68985a45db0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b60d379dab28d26a1082c46e2ed156d13cfb5b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a568c445c074f80296169acf2de563ae436fb65.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d1490ad7913d4bbda52f9efbdb11f8211dd5d1b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c9490140150b5dfaaf70e7717848c6f247f5fe4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8f31e0f8fab53627fe4ba714c4c93ae032406ec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a85c1d819ee5025ed9477f0435f83ddc0277504.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49379fdd39ff4aedf606f9c03d1a65f34dfd9218.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e5f921d675d6ffc3ec2117ff6e207910af8c999.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02e04b52da8b6086835b39eb701daccd2a7eb3ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3be1e9f9bfaa8b66e07e3f8e4d98fbdee903328e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49a36a052575c1cda7dc14b481bf33de449ed035.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3096f345fb709cbfd667b143f17878f6a6a173df.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ab2602b7ab73787fe0ddee6c1bc08fea7e54322.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/934df8ce8457b5109768d1fa0dfcb7ce8e65c4c2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aeaab35b86510acc15778194174262cdefe0baad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/703d358f67a7d3a7c30801a2deed77c91b56230d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82e57d46d4dc0195aec1b59014003e2b801aa292.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c41027f151010ab75b521610c6e8fecbbee76fc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cfec963d5c3ba34e956e06ab2550eb4c6554257.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3f16520af6a011ec31e13d7e4a028a0c55291e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab7c20829c47e4f3cacf374c34e8e99f1b3a459d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5c20fa28549df8545520436f9e5bbddb05c0020.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0edae3ebb85b7d1d7dedd23b9cf7239e4a8aae08.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/996f5bf66602c75af199a51b311a715e7be2ce45.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a3ec9b75542c32de244c5a1e247d6328dfd4c45.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b00d8db3bf1d470e9a90d8b3a01fdc220ab7e297.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da90138ff9331b0e07354413c1e6e7e8cacf9a33.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9aa629bfa165acd2c8853ab31ed1d3bb1ddc8f6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/352b0314ca7f77ade26f13ce0e0d136622f74da7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1170ee44760aa53249c184343b19e67944c49a52.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/510a0105dec2ae0440be1720a5a95d68d8731de1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/282c0330f1050b5b4c34a193251b601962f29a34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f1b2e87049a6f3f896128672cca828136ed8b35.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b429174169effa582d6d1bf9aea89777ea0e7eb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccb1fee34025f26bcae54f8d48d48d765c3cc6b3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5e0a043128c88f2207268ce3b5e995905529258.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68c9e4aafcea069a64ab48a433b0c044e8c46a0f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c15a597637a2c807245dc25ab30120894f50c7a8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d7d52de25f2dac6b435761dc79c715b00ee6d98.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99a3931b39e9cf52a447ef919480237b7a290cac.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1569576d751e66c252884e12c7a038582f95b425.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ae308cbc54f1e990c4db19d36f9d318ec1d7f6c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e4ab5cca4ffe7d9341321f74cb0060efe6ade04.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5471a6c71d40879d30ebb8f6c6b428cc62c3f587.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fac1801df96e6c5a92ed8dd9c7ad9577948a063.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bef417f4581cde58fc61fa8107924c95c3594de1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b50c174c4af315cb2471f3efaef5c3fc36242f3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77cf62e3fa6270385639feca1ff7c42320eab8ea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e313191abb58473515793a29696ea5fadf8e28b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e17475fb6b787562e517ce3d604138f0f1ee8bf1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/754c551ee329aa5a60955ecde285ef5f0e92fd23.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c6667faddf19096569fdf920b8c4999d6b2d38e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecbcb5dc34e6c09a92fa22b37ea3b8e6e4cc91e7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b143c352c6250bc22c1853ce9afb994a0a76d0b1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db08a517b90c7ec329a87db0528b46e7a4f22480.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f908f38f3f839d2a88ac98e76707b6b7834a726.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/137d8768a10e4ba50ba02b8eb396f9ddcfd7f803.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a68ae9d9d9381c866c3e1bbfc1aa631624cf6267.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04d21cd4c6c7a1e6a062d1a26c5f77bcbc1e8062.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d95baef269d7520e87614d7647e6fafe0563ae53.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34880c070e2e87a6efd7b5cb22f4cc90018f2c7d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a494f1c4d1b1c534ca87accb8460a49e615d935a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fb82817c7a895260b124d0448826799d601ae3b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f965f9f2b4239a47f18cecc0f34e63db7facf91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f16498029882bd4dcfc679843ec2e2f69ca4d55.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fdf19dab12ef2d9155534d6eb06ababd77bfbb18.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e44dc2324592361b3f59886c4a167306fa10fb06.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36ed30179363d33a2a732cafc7d61794189c183e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22ee767590cc37ca3c3646812c3165c957465669.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8498af11aa5a0e55c4b63b32141ebf3e3a7d2b23.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbce71e4d83f43005e6d56dcb258abd4d031e451.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/241681bc0e8a1969519157853e497ed411ff2b13.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fc7c99c7684827f8e52d7122d9fa792bde75d2d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8860e40f7b35177463d854ce4c09972fc9d780b8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76c93da832c2697bd4d5b7c16550081fb72896ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3cc9b83d2d2b88d75df4c7eef5fab57c336f540.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/203cf2a76ca2d44a51fb3d79de251b661e37c41e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df7baabd0328da3b26c2dbf6059394d4aaecef81.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a57c04bbe4d0976027ed903fc6a6fc8713030f47.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a873cf81be471d8c479c47fa1b927a36ae1e2ad9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1ca12a7a3ea0252af3aae7ac26539d8168a617f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fc16fccc18fcc8298c9333ea01f75092f58d89a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/078fcabf3ef0711ae29488ed33e68d9a67e3f1d9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d6f2469ad1cfb930154ea649d0bd4c75d3731a6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38efa74942b0eef2e1aaafd2241046d5b04f4562.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d84b7dbd0b490f4c348b7cf95592c236d79cd4e0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/246006cd02bf3948d20fd1a5ac680a96c4c35738.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fb86cf08d4ed451ee161e1d5df02a6546349bf6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4d6865bee889bc901abc23d0a0203316cc7f3f1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e7650144d947a3467d66c3e77a6d7cba8a2de4d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbad6d11f318d1f9ff2249759f202814236bef11.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a7324fda32ef84262aa1ea1265f834cb000df20.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14b8a5e4ab245167d37d331e6bf63e6a57224a40.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e299d5a5e6af50c99c6e1ac0460d399687465678.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8cefce96fed14f5eb67597f73804212c789561b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a76caa90dafb0d74cf1fe5d598b48f419a46ad54.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc6e3cece85c3abca27895174979efdfac26f51f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4104c1d5bbe5d4734cefdb74bd99f4683d243565.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3cd0a79f4e2bd5ec12d173ef687bf08a89a80a2b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b5ed7da4764483bedf80805b0259743df7a437b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81741a8ff019d57b838d629bdaa25370bada9185.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c5d588264fa3be7bfc2f672756a6b2b7ad59b93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75c0bee7e5ca8ff6384d062e224fccf46654ea02.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d01b533e2061a2ee76088bc6e95c0f424cc8bec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56ba25cd3c3eff6b775a762576fc6ce34e933bdb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee9363205c664aedface88207634c1f8c67568ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6eeb3206ff8dc7a475a0237bae85a7c868a1704.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbdfff1b711b560a43148dc71eba49f16e7301d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30b1ba09703f20b13c482a23139eed7bad4e2b45.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b898953e9618c67b3da125b53f048cbf9efa18a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2cf40acbe1a7c12fa6418dfebbf941f4f884797e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7cd29aff3945c012d17bf9f24ebc6fac5b2eb14.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1e2ee02c0231b42dbca2a3c59f3e47ccde0e94c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97465c594e0f0eb34bcf3cd2a1193103633f72ef.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcdbf36e862a5bace99010065418381a4c2955d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9895aad847a086daf97cfe42b2994af21be7e293.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b92b2f016ace1df11b84061598c3c074130e7467.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b798ea17bbfa354f895fa847789a2b4f53b51ee5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/819640735260103f2841561a6f61ce79cc973afe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbcd375a0a3162872a541455d298ecce4e738606.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4dd152b1f65881795e1b4693702bdf3b2f37394.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/faf7cc92694c8344a395654ff22c45dc2717b32e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ff9bbc60dcb34f9c5c1705704734f22bbd40318.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a94478befac9bb85a14c30f690122fbe6636f321.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cea9f056503b93fda8e9716e9cfa5142cd7f1130.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0530815fb745d01ff5023afb076f5f1df76d96ff.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89a49de7a21bbeb9706ce24efd78a8ebfa8cdc06.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8262d08e00cdc460ef82a22620f5772df0a440e3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb4a7c7fdaeda64e09f9555c7b0ddce57eb4c18c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e4d6ba333c842d5abd5ab4c37e47da768de97dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/567ca84d379e5f7d22956c9ee70ff75ce0e87966.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dde43bd8b161c5872ad9db66ba1119780732c74d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e1e8723b9fabb70cef57d8d55b16cc111c766cd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e29477c09d733b06a9221193078931f6b6ca1148.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ef987f7edc029e558caca95888ed7a93c58d5a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2cdc327212a2b259c69e5311130ea8e787caec0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af29b360a550583a3c700e8043dacdb9fb66a25f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2bd0f43fcf530ab2be647dd3ad93016de3e304c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1594a855e3433fa274d7596f120199666a59855e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10358331f659ca963a220eacd4c3639e490c2f47.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55fdb7b8699d78ec6b52b2492ebeed6d4e7dcd1f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f5c7ae58345981daac096214f1d2b28906386bc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6bc7c4e22ae7107cc5618f2d9eb1bd9ed80a413d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecd22bc86812e1d31d182d51aabd7c22f292f2e5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3d64b3dcdfdad3c397a262638ff7cf6752ed0ac.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7ee8cf9aa56a01dfa1ca24038e3381f7d767a0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3590c970bc3b21862d42c14d7dca52a3887af9f0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5999c6cde88fce103e1e41f269e43b07080ff83c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/689b0eab8f821f31a805c0f46b31da9b467458f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09cc4a76d24d0a9e400eac73e0d6b2e5d43385f8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3ada63fb344b6e4de9225d12f44b369741204e1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8372cf74f570d9073c5ef7b2e9d4e0ff1f13693.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ec157a217b1418d9bf8e572bd02e92d488cd7b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfac05e2fa8c031ed8a242875f5db8f66815ac0a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/19-nov/",
                    yr: "2019",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23bb15ac2bca392bac9d5b25029908db73e4bce9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a1d9ded3cda2f48d84ed358c5b0616c57bad713.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee1a9c9079ce1d3acb54e5f0ab14239b34024e72.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/badcb9df384dbbf749ae674c992abbd094fe1e37.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/18-nov/",
                    yr: "2018",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/320c7f604ae9668a016c958bf3f1eb6966d0d158.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cdaf2d812411173d7b6d608b1e15ca22d695366.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67803f9dc80030dd55a8f7de96b34ca9f989f2cb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a04a00efaeb4783a689736f24aae014c57497529.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/17-nov/",
                    yr: "2017",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb4c443105820ea5997f43bc8539b595e8bb707f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/104f92bcd8ef05ac7e20aa311a69dcb51d94f08e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bc93b202e6ab37087736202c8769c736c70b0d8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebe97b434d37441a50557ab9c85c97ede6a52e1c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/maths/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c490a895f7b10776f92bb2783920f16fc7c400b5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c1ce301a7feb2ede8e808b878d3fdff51f03c75.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/H/18-june/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a79c9e8a3e53e261503e3de0214b0a777cfdf90f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/F/18-june/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/01e9550311938f234bf30d6f5b17a3de5fcf2a37.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3F; 83002F; 83001-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/3F; 83002F; 83001-F/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26f65d557ced830e239feda868f4baf8e1319480.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3H; 83002H; 83001-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/maths/aqa/3H; 83002H; 83001-H/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d90bc174b551fa50275e4a80dc505ee9aac9856.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/biology/aqa",
            pprtypes: [
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9a9417f5d544beba8dae16fc3c10582ee5769e0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91864b27ed6dde51a4dd5d9bd3aa1977ce9c77aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9016d570203ac764a4b3716392e9ad0925d0ea8b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a76ee1ede52e47e5ca9885beb719f3ab1ed732d2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbfe6ac78c52a384e4e8aa57e24d651f950329d1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88dc2e852403fdaff9a4d39329da9ba0ade197aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fc7e4f44d60cbb149879a63cba29f6de6f9d21e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85cb3afb57ec3f141048dcad467156bf9bf5bc3e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8a0009c360109d76a8dd3364a6fbdfe5e681f3a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f10840210e33cb201375de228fb6b10028bc2736.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d22e3088d988dac25416eb85c59de05b6453065f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7fd7d36179ffec140760465d10eaf368822c17f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/biology/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee5dc019ad7306f397c539d30ceeaf1ca20f2298.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/844c077ac6f14b3242d5eb1e8beab67b565adf1a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3bc256d1193aab692439fd016c7b28d64a37602.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e9a43d3a36cc7480327052dc13fb53064b7012a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7a270b8a3a688506da9e52f20eef9bd06112edf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a226433f7bad5974cd270c2da2dac7d1146949d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0909da2ded82d9e584afb300ff867531e56b9b0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b59a36f7010af934f11f40f6ed976a9fe5c653b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92ba9532bfc06c76d9941afadd73c37169eab7a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/229fbd8744fd07bd6ec1dc06a6de5a0357f8edaa.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/biology/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa1d313cd32ea2e818f4680dd21969010f1e61f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd471d8de7d45f1c198aa2dcb8a76d7cb0529d81.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16d04512995d15dca81a53fd46b148a1d72c4a26.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f8660aa32c19e622ebcabbe243dd8d2c189b5ff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12e85710305ac2956622081277e382615acb9c51.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad65d495a9e981f049d3a2c4b5bc775f4e71e7a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df33a5c0cd7ab47cc3bcc6cbde5739549fdfaf0e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/137452f41fd8800a3428cf60ad71e00b844d874e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52043b6a98d004d6bc11d7025c6604d356691d69.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0d69e817e0a7f5aa79e91737d20ee6b8d0dd50f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/biology/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/822500b30d5cb586689ef6d3acb85deccb4a00da.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c75e27e9960556ada5402dc8588a939eb1db07c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecaa4fa9ce38d87f90c9511c28ad48e8673f15a4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61c2da17f1e6446addf23bbc832f23119ea2867a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82d40f82efb5f0843167d25d7a7c89bb652b8fa1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bebcd31c77c4104b5a5d1ab822c72eb1d1bddbb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75dd1b43909fec5f2265dbec4ae496ab2858df10.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bdf088ff0cff1b1a4a120f69d43318c73ba3b50.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/biology/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d76b8a413c3d54e56a73e0553a4269c0884984a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11c384703144947ff45235fc23f3e510110a962b.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/chemistry/aqa",
            pprtypes: [
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c586a6747c7a8b6c8f71bfc687df95d248b4a913.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd36b1e68755184bf9294f429bc1c78e72aa9836.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e712647aac2b2bc2acc712e346dea258836f3791.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4702af39dffad4119cd215815e3fd9c8e73dfbd2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79d21fc272a171d5554a86dd9c6187199b2e1c16.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f74e0c6ffa1fb2cd2ae859b979f1c860621995aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/768fb3f9fa7502162c256460d9e9e9c99fb7bcb1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d451f429ccfed69977a4cd4b8a0892961ab6a379.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aad8d4f710f17456e2cbe6373a179e7c0c5a0a89.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fc482be5d4e2f76610af52c0aa5b56bb8b17cc8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0540606fa2be29d160026552d96f43bb8e1c0a28.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc2dcb29d03a5c365aa7f3f500eb3a449232e6d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83bef820f668c960cf134db98157c896a2f01144.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c48dfca007bf534919f1b1c63a27621594771de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/deeec39d77611e029aa13a7bd880b39cca5cd7c9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/799a81e2160f2f64faea8f4e276e0491077b9bf5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2639704c5e10b186b8f4f6b244dafe02c0d256a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2de630ac00558366d6cd35ddf3112e3c03e0552.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/659f064ce2f39e309b767213082035ef593e93de.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cebf03e179ff1f49ef67b954355b1e8003dd550c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d5064cbac9a48b0d087f1d6703e8a46ce06496a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57256f0761b3371ead0e2360be98ee4529fff6b4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef2abea203a48494cfa2cc1dd10bd94f836a253c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e61127707765cfcb4bf2093f1781fc8aa9f6908.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47227ace62bb83b14e7ab7eefbfdcf3b92b633f2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f30bbcc2483635460aa86adf4d6f0825196a0995.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c0fd4b423df54429ac386c810be4454e5010307.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c3730e33ef5aae7585fd205a84440fced13bdd7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1060ddb8494c8e86f3b75000f892cbfd28544cc1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4711bb4794feba571d84c025d5d0c528cc9ad6f3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f9ca2e1a220359de0436e351dcb31fde041ab6d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3baef3cf3687454106485d1f01419e06ce98179d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5465a9407ba1205734337929157988bb2000e6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5368548dd33786dc5c77f5f159752a22b0d78e22.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7301ed30d764df36530d745a6290bb61540b6f21.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a705105c5fbf7016c143c317d7a36d4cbe615ab5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e17cfe67b81614cec36c1fc7b7db6364d24ec40a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/40184c5d3906b53aa607bbd0ebc2615d3a311dcf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/880c613e31e7634a9e9b690c8f02627f1acfdde0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1adc0c64c03b74e1e8e113863fab88651ce417b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30be1fe5c5907345de66dcc764062bb05b044e4e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f18a4b440b7f82790cea5d9ae749b4383f12e4a0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25d21cb82a227ccf62209b7afd0c1d9511e573bd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6c78e2ac0606d01e565a405ba23a35afde84810.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6a743d4ab3f79279828525d5ef953ea690771e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf334193f4bdb18d66ba8f43b98e9543e562e3d7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72f3cee99a5cf37966db1dfa2a1e4d9057f902ff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ef159a8327ddbe56ce6ea8de9e9b64707ad8f50.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7067a9ebe07fa4309936ec549e8c6d30497a76a8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65a28adfe15d46d1de9c2faf1812b4653f3d39ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42c2b587a48279b0f02922c2bf9c48982783e507.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d744d3cc207d616b859c2c4233e61d042befedb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/321a000572ecf3edf3fffb6cf9512272f396982f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e617f0c27d2847e93bf34d3252f4d3432ef764a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e412e2897f3557a98bfff52987391fbab65a980a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0fea29840739c1027be2c4504bc6692ab7c91061.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1F; 84621H;84622F;84622-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1F; 84621H;84622F;84622-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc49f689fd4152b69d9523e7c03dda127bf5aac0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1F; 84621H;84622F;84622-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be0a7c2131c3f72d317df7706af56b9dd84591e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1F; 84621H;84622F;84622-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9715d6560f3b85b3cad7ef7810568fd3ddf1d857.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chemistry/aqa/1F; 84621H;84622F;84622-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02dcdb4b809bc26bfe7d36f454f1503a9434cfe2.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/history/aqa",
            pprtypes: [
              {
                pprtype: "1-AB",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-AB/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/369e706236a346d78e3a006fa0b5609e6e3d2b39.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8c0e9197a812415968b0fab4329a597cda38f27.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5dfa02b4c4f995a3eaf79b15e746ca6d5fc0a473.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AB/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65490b664324c6c7bad4bd7f972a1600735791d7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25cc9d47a75cd74ba21f77b34d9ff1e4087281ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/427d005ddbfb620b9f840435ec294101916cad9e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AB/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0af14d7078d2af22c72b7960a1ea59440a8b4fd6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03d3b164938edb1e5ec11086c045783a6732cd82.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbe9bc79fd8991d6ff728e19164e0c3867a90065.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AB/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cf376a50435612d6fc5707c22789512754ac52c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/008e006b9265f1bdf268c74498bd08a7a1bcbb8e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d3ff44c406d4ad70d3d7a156da2300ce2d74435.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AB/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6fc79f3b8b8588bef28ebf7f101145c982bdca2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c9f9e438e5790929f0523bdedd9444b3786305d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a73fdd5703df1cd32a43c78fdfc727f0318df6a8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc3bbbda02b2dd4af8845b63e50ab43066f1c9b2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/938b4604eaf5811279bb132380e6e93c58c798c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/114be31fc96cafa08a1b9105eded18c5cb9a3338.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-BC",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-BC/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed91592b4f07dd4c3df0c887ae50b4173972f6b7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecc69151f4913231fe76fead353ccf3ca9b13ee6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec31f1f739ff046dab47764aff2526503875b6e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BC/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a637f5912e3fffc511492ee40ab6bb1e92bc759b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aae645a9fc187301d46397363dc1ea00403afb1a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1776b8a3411528cd345cc8fe2e5308adf66109c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BC/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9809e586471483304afb208e1219e31161cb234b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47cba67287dd5e4336fcd7a9fcabeb37d45deadf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2457c3e8034385719e2fae278476707b92ad677.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BC/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d0fbe65bc00819a020bc33e6a55f1130752de75.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbcb96ed553c37fe8a5a44f252ca2af3f54d7929.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ac85de6dde23b5a4bf20440beefcb9d7bfad7fb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db258d109dbf93f125a462b5360b298c17cdaec1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f4af69882b00ad7aa9361372de8de05a4830b32.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a1e1ff73ef44513386f7f0a957ca77dba82693c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea41506a6279f1b275fba9aa7561240ecf5788f9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1e785d9bdc9d2a47381a963aa91507bfe9c8f87.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f514b03af33674fbc5c33458b6b143a849825399.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-BB",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-BB/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86ba3a0056d4e4db13d278c9b65087906a9b752a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39927db702f024f33e7f845a1e2d2e9cd9722f8a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d86ff995af8fa8a47139153461bc9c13d166dd66.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BB/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/626fb4ddbe0574c26d747b7f308f19e15fde612a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e168e3392c3849ef17b0d95c86ff5bd9f957e19.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b705ce5b98ade62399229de16f3b6317baa88e1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BB/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2a307f70341977cdfd0ed458904b5d40e1ffade.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59ea7464bad002ec520d0741fb5cbe95347a2fa4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9323ef87fbc8b1acc6ed7a172cba74a5ddbb9890.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BB/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3160ee2434475629177fc0e53a5297842927ea7a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a587aa64c389a48f7bdb413ebe894f4f0a6d7ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21d0c3cc613d95305fa04d52c0b0fd4e495984eb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BB/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c718a648442ad1febcb7c4d08a3f9545521892a8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ff5b303ff2f6dd36d04c77fbd523e8fb5c0cff7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ce7a6562b46c62d1ef7d8a1858a40e448b26c81.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5e894f59b8a7fd596a7dce34d3e9050c954985e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4ba0bd7be86c05ca9fca7015c17e815c93d16a0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73abb10ba02a5994ef0405e0e9a193a15c7827fd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-BC",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-BC/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c740286153b6b60796e4728005b444d5bab68871.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3a99dccacf7ecdc1ee021f9e39f2e1977f415b2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ccea2b7c70447bb11d3b8829fda7e26821bee5c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BC/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e21dcab15266969c140e0f50737e5411a28dc218.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b017ee7ffc1f30dd57cfb4a4dcb2a0b2f80edca5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fddcdb67edb29b98e3d36666806ea0360064fed0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BC/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d4c82cfd5fe2000677ad26f6154bff3f260d4a3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88779d18d62e8b33f58acb65af2d717af3b41ca2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5cabd48d9c11530afd827b417096c0c1ddf0655.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BC/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9a7a1826bfb77256683eff76681351072dc98fe.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bee18abf5188b2c0b9b9b7042cb781add888e45b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22ea28a6914d2761aa040030f88579944a4bd48b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccf26778210f8f1d4a27b6de768eb774624dd4c0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe6c6d5b00984db74909932aacf7518fd6c1425c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6acb8cd9574e065a45259078f83a5ba51cfa82d3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7db7f873feb054409db2f19479e30842f4a075b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d782ea2a6b5977a2704349eca54285c6c602ca34.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f8fb4a7ff09f49d8065abd3c1eaa908f0b8aa5b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-AA",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-AA/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f0498a5e00222fc9ed5f7b711db9488ca5d8f00.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/355da315039a045ff736d45686e6c5e28ca498ce.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff390637ae972979d6440bbc70b347b86b4bd6fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AA/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e815f9258679eecd07c0cfc76ffaf65e5d28723.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf192b4810c6ce8262cd14fdedf652c652526c91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ecde0b9312e14fac000bd1dc2676fa4172439e7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AA/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc1bd4aa583decf5f5a481b8b4c5dbfd909b88a9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f005d046dc45cdb36a820f86d4b789ed8f2c31c4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2d736f86902920426de5d8b80d1c01d2238df99.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AA/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ac66739e95b7e46a351b81203558808a99ed3bb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4473ebcaa90d614eca7e7131656fe81cc9c5e3a0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a40cd9076b8fd9872be635ec988e11e9a70d680.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AA/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cacbe2c7039a7cd6da2a4b4314f25758d1ea0615.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/057da587a5dd1529a697cca6da217ad83239fc01.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91115610f748c6e7274ca952b619f5be99fa6727.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ee3dc4de31f968518ced049bd5cc851599d5dd7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16b2c8b76321f90791c43e996d4ef52596eb00f9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f76a7426453deba32d81b010c4a2e2a371311d02.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-BA",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-BA/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c98a2250a756d8a040169925b89d6c8ddbba1636.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2064a8716bab9ff1ff9f0dbc7925bed3951ff6d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ae4d320eb116b34763a8296fa4bbf722af203c8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BA/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f828cdff9bf2053e28b9dfd0a225096709445871.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46903bf5878dfcbde689850d57f4271ab17164a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8f3c2f3cf8d3c2c01a15be526e1067ac4284e9b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BA/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f2a682913f952eec12fd6035c0131c4b0dfaff0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0aa98470a3723c5cb5c2f0cfed85267ab5b5c58d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a457d56998902025370c60d440a015834a0fdfd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BA/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a96ec895c204385ce1153f61d70b6ec18fd8db1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f9760c2e62b891f3944586d134fae8e8ef32e53.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ccf2aaffa7bce314379ffdd9f3b846f87aa743a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BA/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ab2608b0cfa9a3507553876201aa725ec00e030.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99ccc409e07235d6ed7ec0402a8793e563639dca.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d9fe66f65c0dfbaaee3395da7d21be222a3734a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0077a253be6585e0b77cad755b52ebabf5a3b12.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41c603a30577faa2660a4128134352b273380094.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f460929eebea236ccef3414d2572c4d20bb41997.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-AD",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-AD/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99bebc84d14cfa74b817afebccd7357624c65be7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9c098f12902dfec325acab0fbc66f734f147180.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e74e195fb614e5fdadc3d7b7a6f0344ad2063a3a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AD/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79aef88d04eb3d9894eda477deeea12579e939b7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79181af5a6307c205d34a0378f700e1117825702.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5e51d435b2728999b894504fb79506433b3bdb1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AD/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/289f8eee1eda6573480afb6a5e503a099509d01d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18e57169be0a2234d4c878d93a8d3ef6857c705c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/53daa56c64a58a50ce80db0653e6c3c7d5dee791.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AD/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe80e1986eed8e8e13181363f5f5d1c448a89ea5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06bf061f7eb9e6bbf5dec8ea96d646bf7f50acf5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cea574472240e0585215a8fb5dc3b67011265b5e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AD/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/feb589e8d2692a63533e12af5f2a44f177601f05.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42e76a92a4b753408b37e229b25fbdd977d58d1b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9d81392950672c46cbcdf8b7a7b52377fe4ceed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a7d60d754cff43489deeeb56d3ec4704357d25a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11eec2f9207dab71fd44098ae155f89f9a675561.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09a8215aabd4c75351da3c047bec4ba14e60ca1b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-AB",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-AB/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1ad83d13c6a1db77dc4a4a74af3d25b8888e559.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5adfd773b2739450a2a84c76fb2bce9297b9eb4d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d26dd77aa6dc94a76a59d3eed3a78090cfd025d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AB/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/647958d8fe7cc11ecfae7255183158647fd5f9b2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4788435b346b02181c62fe7f9f3e53deea8a3dad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/733b8571a80fc68123369cc9060bde518d6967c4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AB/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/270a618ee9e6459b36e14ae724c201884d8cfa82.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/289226031a44a936cbdb8df390e285cb601e7349.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bc89afc3a99b3cc80f81f002b29a3ea472c764c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AB/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c05978d1193376829eb00b6b2777fc6a29a5f06.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91aedc1147dfa958783a91c4aa18fb7fd9823f44.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2dd2af9627a89636cdd967b027c685d6692b3bfe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AB/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ff8d86b96f33a4a33afc66f0c0e17e4a668a21c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bdd7e59fd267ed8bf5fc2b015019b4d43c367d1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ed159967156ef93ac7de972cab3324e6b92debd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7af8859b89c19205d2872113443ba56c80386e08.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25f90f1428688c1c347fb938920a571f9015095f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/085b9480ca1439aead16d9ddd5b3c6cd7a4c9d85.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-AC",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-AC/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94844e638cbb45933779d86bee7db157940fe7bb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4c80258ca1cbca5c98c8cefb68cbbe721271b4e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f991233a336fa99d581368f7afc236c0de546ff9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AC/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9794402ed3141dbfc673b60551d149a3bf7d9cc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73b2e37aaab62c328bb6fbe6d956e0716722bce4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d37a6ac403af7ed68ce12d61db4a989f49304116.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AC/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bbf0a9e7ce65d9f8a77905fbb37071e5dd45b89.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16cff4d504faa5756e514541d6a100a8e88f551f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34c386ef858771d66a2879d6b82567b87b8282a3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AC/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0366331e82157501bb59d1af11ef5727b0c8cfd9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/626647085bf8d6601a2ebc5ca03dcf09e5d80482.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91bc3d6e14f61603ecbd68590cd4f49e57f9bf73.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-AC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a026521717594eed8b58567daaccb018fc4f21bd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b56fcbd7faf6539e44856e7f7dbd8593e77dce4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32ad3224ce46df2d057fd9c59df0124fec9523cd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91ac6d89ac1802dd50546eab21492fe3beedd6a8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3c64fecca09f41cf312aa0fecc2df5ed0a67116.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6add6556b244da4933de3818bd59789ec110e74.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-BB",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-BB/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5d0d66f467ce9fc557ac9230b4e51b0b9342556.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d605bd301fbc54404c277786755779e3bc934784.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ff08d1128a66460b660751d32669f4333a1eab4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BB/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50a9f00d96ed703410b3fe443a4c379bceab5749.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19d045856d2f9490131dde2b474219accd5d7fd0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15443559d20f18198887d02465ee91972037d69a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BB/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7154560f07a93c4addd086020b1c8f975f562571.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f56993642ef23f21432a04d24c21e23bdca102b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a26dcde72da54a49d397f1e2b122f77c2079dd05.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BB/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/354a3ef0de3333404da4cab4063f57e20a73a5d4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a78623ebcb8b54eaaab7bce4b808e81c5e7c209.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2b9234012fe0ac811a01c701de5ab1cc2a5c514.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BB/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/640f70b5904abbcfd53ce0a59891c9083d9b131e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2558e35f5d132227037b2c1281a298d16e806f1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba60ba14dcb0f5cff05a9186edaab23115e8ec1a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f72486e44857262658967c0c2e6109631f2110a5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/141d17ca2cb2afdad541bac8dff1b78cbf7b003f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2a8ec5d7cf7ba4fc2b0cfa41b989c3b36819695.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-BA",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-BA/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/684f54e63d8e3826bec898f69cc13bb8000bdcbf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94223b6173b97b88031e072a71967198462dace0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1734ca84dfb8bb9b5de433c80bf7175f23b251c5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BA/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/878acf186a0f8655c2a047632dcdb1d8ae86a87f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68f1f3c274984c40a167973808403e0bb51822ff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d25868845bb2937cde635ecc7e42f67665610e7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BA/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b96c8e2c3e402fcd39e63da220774f76c942b0a5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd2fa01ae17559c26589e2f51a094b3452c98c33.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ceb6bf22e806f0ffbb6f897965272c602009ae65.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BA/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8b04d213fd30e4db164d7699acfc52691e9416b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7d161769aec639085aae4a90c134333c4eb09d4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1f280999973d70e3f630d5d3b608cc973d65030.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BA/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/051986e76f1de5ea831eac02684ad3903aa04919.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cb2e067450126f9ca02e2aec4235bec45b89cf4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47b95fd66cb0990b0e225b257f302aebf0b7bd32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cce0e73e00f099247b74691827beaa47b8816d2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c87366377378ba26b75cc836a0f4e876336b5033.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b50bbbf71b3f3198773c19a55194b9f6c2246af.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-BD",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-BD/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/387d409f56c02f21e1d2346b61091211bfbbdb6d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/614db1951ca13e6bcd9955fe5d06edf072a4fdf0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2104001369c45e66723b6208b8a3b24a5e5c9ab6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BD/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/707e0b5febf76458dd37b293194009679f0b20ca.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b0b21b5dc5b148f425aa18878314ff8fb170f1c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff3545c6c7436c216422624b258524b6da166658.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BD/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c87e7b856f5493c4636ff1c35fa2652b2728284e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3336c52973f8c168500d28eeb0e934c78a9e919e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2864d125907593856c4b381192ca65e5554738f1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BD/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec53c250493aace82ba1fe2cbbda35e326f4c189.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d16776088e770b02f404aaa8f936510706c7c940.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/810f16a9999a74fe59bfef4766c54ee886126595.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BD/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec06c3b7547ff570040bc0a6fb97c76d134b47aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e981fbda2e4e80fe9faa45a537bac11b80324cb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa8ab4f909733889fdb36539ea7af3312942f03b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/136086c57ee34460a4a1cf7da533081232122999.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59411f20905d88525f0992da602eaed101f409da.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/264027981e159a7997aff2b00ad5860c63640c24.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-AA",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-AA/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33e4b83141a9df2c1e130b55768b2a42b906fd7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32fd01ae876ae292b8e4d90510617abe48a29332.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2da36e1e28a7a480be6b2ded3612bb50e50f545a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AA/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7f692690c69ccc2403d8703765ba575e96afe25.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e91fcb04e70ee805d0a4cbcafb8fdfe5e23130a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8bb764543e678c8b67807aaae5840e1daeaa6c7e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AA/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/565749ad5fcc838d452aad8eafba9ce1da99707a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32a8ec97d9875b5ed908d0074d3a7db77bc8bbcb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38296398fd2cea81cfc8657c529153965661f108.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AA/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98ae47dbdb13eb9f8d835d77bbf9200c10647255.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1737c5fb3d8245dcdc4ee1b9114ece3018a9386c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be5e240ada5a123a2f10cc25752c0f7aaef316d5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AA/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58ad1bfffbbbfe71c2dd2ccd918227a1dc75028d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b5ad9ffa4d8c13a8b4f17f5b7c85807147b3619.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d52f9bb552abe972f3224d511665283715e4cf9f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/95771d8772ef55eb9fbb0df1947ead176824a181.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8c132d9b6b865fb76e7dd3ee6ede409192b277a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8237829bc9d89c4aedb1cb10de977f70869e5f6c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-AC",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-AC/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef5fca9d1b43e7c549bc5dbd67822f9d53f4d5a2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7658f1933b6b9da76e97c54f7bb107cb8300c9e2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f183dbd6b6605d31d5d0950d9b7682a7e3a63fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AC/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1177dd7dffd996d565d95de341423844a05f7e33.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/287114c1181ff0e26fa51f78bc22f74de5aa21cb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da0363ff22f8b7d8ee7362d4df454167cbfb3bea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AC/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b84722b751905a656e717c38fdb94918a13c854.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f317ab1f1d9b2e699275f506cbf74a2b4067fab3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1e1d52b930b60f882d420fb05ff486d05eb0ed0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AC/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f2d310e8c13153b10ee3d9b4cb95815826f55a5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18d9b891bc9066d09bab26722dcb7bd3be820327.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/340449bbd232a3a827719a671e7828a2d23c7cc0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-AC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e72abe04aa63faa9020ca10c016517e22d3006ea.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cb7f108078001a71e0f9206c6b94e82583f09e4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1534e53c01ae9868bf5d5f29db31154d20b9666b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a85086fb3e3b3ae5198f52a6e49873307d37b17.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86e717e2216e8cef7ea2c386e0e28c23024e16fd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a786540ee147acbd94d35687fe31d6aa480c8f9c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-BE",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/1-BE/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acea330ac3baa4477418eef768578f668688ef30.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45e476051e76a8800adfff4afbb8fe0a0ee0b631.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc59eb8e8bb1fe7485e38b16c2e381195f3bbbf2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BE/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94f513b48200ceec328d457a0f4dfc1620427c64.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94799ad96ec969209cf09d863edf1b7bdeafe971.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0165830b268dd42f898f5193c268e1edde645ab9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BE/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07567f408b878c8ffd12bd14c15704cf9b66a3c4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af95befb4e260711ddba38b9c2b755d3dcc84ea0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/beb0e9cdb0cf713883cd357ad1b470f2367052ee.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/1-BE/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fd14e3735627fa3ec190360f81760ad89b600d6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eeab03296c22c480f085309900d32063e3a34d1b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebc6715db6fb2c801dd44cd5631af4752cfdcff1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b65810ceed86ca9a3db2d9637f78dd8b510623c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12c0b06451501d611c77da16e470db6e7a30d420.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0c9751ce3d116b2285800bb4c3df1d32c1c6fe3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-BD",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/history/aqa/2-BD/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/099039e0890ad840dedd4f21e38cf7ca3d9093b3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56d398f00ba4434318c2871faf526fda4eab7a2b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c60840f65ae821882449465aaeebbee3214988e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BD/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/720c8fa6881912505848ddc578d76f96180299ee.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6e80336239a436259ac3572ee03f666f916b87c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57047b46ef2113ffbc67df87c77d0ca33edf4d69.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BD/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a32fe24bd9a3c7321b06045f27f74d27169d4555.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28803a9a6cca4462d3ac6cc533d167313de378c1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59882b7e266d6b5c26007a2b633b9a7c4f6a3a93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BD/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cc09d3e1ec5b05b2f840b213bcb2f2344818399.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87c83f40fbcb64e1b619056204408fa480bb0875.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a9ac907070b2f6bc05d3bdd09b77b89ac04632a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/history/aqa/2-BD/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77d4af9db92503f6072b8ba94e7a4a9c92fc1910.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/632aa47dad46b7ef77c9c290b674f0e6c02352aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7c3c221b588680872ae3327e152672d0af173f6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b3a79fa6e83070415ac2d33d6d939a303605f74.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0036decc37b043e9937a7a2d7ebc3551a53014e6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcf2569cb61ba23f6134d0a11375875333c5eb4c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/geography/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/geography/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b0977ca1828ae0a86062625c1c11f67f4e68b05.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/428ec04327607a5f9260596f1bf9680fa420c2d9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73b5ba9330d6b956a30513ead4eb29926696d7b7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be1ae4f92a915f5f837d981e5535436993762dae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/726a8ff502cce3a780c81eb12beb7cabe7cd1d53.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abd2541a0ca6fc66613fda7e628b19499d3a9dee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e9c2868043e69c9d886759dc195733c7fec3c29.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6116a0eada86f4d0e05e47fc9b8e3725d099041.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21b499a71b11c0c3b4ca29ebe94802a5f76f4f85.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b21ed3e27564f3d756400ed6d925b40c682777f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94f26ebdb8219666df4280cf2b80ba9de0787840.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a7b326862df8def18c834f57c53ba56f4ce6836.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b69ff5092e9f744ee088b2363ec9c20731f694d8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/geography/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1b3fba285cd7d5c6329e0383df538ff4d65a9a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80083c166306730f2d3146aae5314ce04ef693e1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f9e5b051b4f87e7d5706130580084b55f3875f3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9a9e488d7d02cfd5c691cc951064d9a26802759.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/deb9f4df9b7ddc871b843e831efc701bc2768ed8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6558863720e646df9f266723447ed8348477bd30.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cfc0c7c360f6d19ab75ee321b450d250894a50a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef6addcfb1f52e6d651dfd665ecd09f2cbb35f59.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e4e93cb5b96c9ff540d0b195e82c2d22a66f2ba5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cc4fd3fbecbe80f996c4fe5b50f177504e07446.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0175f5fddf3542a6a5a72effe77fec5140eecfa4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a9dd9526a0145b4d909d25df19816b622115cd8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b210934518e3f5856b753e72ffeebc059c5c69a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/geography/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/460506a72648e70169682f218a78ddfb791ad4d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/736318fd50c61ecd7fc6112a8a6fc545373ad056.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04b2631d556290a491b2ad764a77b69b94be0ada.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69aa02693c01411018116f44afca5905739a18b2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25d5386b337b701acf6f20210b1e5c392077b91b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/197d0d09851e58af051f231af6a3bf17e3399432.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68b9329bdb29c7cd12a51fddb426267942b63259.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce3b018afc58f9a30be2e205e108294217c01c0d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39d3736044b2a81bc2c1329d68b3d80cf7a4e8c5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/geography/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce9c036d950b272d3a789d696319c8f3500d15cc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/483912438b7e405e667dc3d5d170003510c9873b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f71c571e3445227ffde3bca1a0d852174519a13.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/business/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/business/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcbef653105f03d993a1efb65682006bffa6a23f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b13777d2f372ad38f1b3d373f5f65a2ea0b73678.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec3047ed8bf7218a8c2a06302ca09711515a6e3c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7d60b313cf64e1281e7c52eebc8d3d9fc1bb6dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebfc30a8bcebb94fcfe192cd5cf93d5ad5ebda0f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df0b8bbe2b29212e0e084118f4d7b4d32bfba95b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5358f3dc8878c1c9199f0720939db57240184ce2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31d7f6123d6be43ed26697db9789a28db8cf6fec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79be6208ae07966a15d4042d05da90607a008a1b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3db9285c64cbeae69687365014edb605f74c577d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fd1d9eed7e138d5b2800e1a1e3840c90ffcb37b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3c365fc693b4e6c93f4ad0a0a4814497490b5a6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96c590ed175154d0bd51b7116e706de777111d6e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa7c9f2c76ed3319198e52ab156eb16c6c189887.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b98a305e18796aff06e1f694e1221c94f26cb43.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bba7c3e7c15be6c1e5746b338f9607c0fd442475.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/773ec8cda3dbf613d962ea38b76f8353ee5665d7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e47bb954c47f9ca281356722c3501485d8764b2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ea6f8967afa3386f893104e0b52468adea43e74.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a94353bdb159a654a509faeada15350c7f496cae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbf006bfdfe9b343cdacec9249276c491d990120.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43a51a79348821b713f5cb750ca6c5ea1002bff5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c473948413bbb1f90076858de54fd954ef499692.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/business/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d00abca79df8bb816bf5f57071f684f88a57005.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d1d4336afddf00224c7139a305cc0c28ca8430c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f5ab228369cee6fe79e553e1bd0277d6d05e4f0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b93f7ccf4b685998611efe5b0e734db4a0e05014.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ffa8e99475e82f1c9a5dde3eb7d463fede67400.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd238cb6fa6fc11d4e6fda5639ae345233f5488d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc81b72afe266d5b9b81e41c0c9e4358001838b0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cb8d2656dd33b16332e1fb5d59ebc1791d368ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bdf6a68da3e2c47fa2a4e016baf4ea0be1634e5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5fd850372aabc443765dfcf64024d42491a9aa2a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/business/aqa/4/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54374ca880c204d52fcbfad32c8e836174612360.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72cb1e9e143b367a655d02fd6c9eac59e2c6450b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3721d746780a2ad9af1593712e2f2e4fcb1d70b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d973a627a96be1da75bd273d8ef231b8302e584.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45be1bb0908d1b0a204315cb4be67efc38b6bc01.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0cd27eac373688d1c5897596229369ca6aaea55.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/037771cad168ac67641ce90d0d047d2e200272e2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85eea23324335042575875d55d0a44df88f4f59d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98c1d7a69d83d1fe8eae2db8ae8f3fe800ee95d8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70f3b8816b390b93d55c63a3126550171b51d2bb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/business/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e357079f2d5af1256a488243245e06578e543abe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/78968cc07ca6e7fabd786784b72edea10c9aa609.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/physics/aqa",
            pprtypes: [
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3d5ef539ca38e622dffd5367814d4f27a01ca6f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b467a8fbdf62462b5b5d6fdd717261be60920967.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ad5a83b6a44f298c4dcf4707cf68eb036c9e213.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fac4847ee3e0e6b4aaece44ee022991cfb302b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb30f0f34dbbbb95f9b0585d36a47c95079c136b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59092fff61a7a5ec44c469a7394c45e9c5a23d40.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86bb907604da4822c0a8e0fa9c2cf8d945c27f2a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b9cb033c63d87e019b27cf8d2bd7fe92b261f99.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bff7b5e80ae88684b505ffc2384c53bc74cf7ae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a604e16cba875a2bbd6ac98975f1ea817a62e930.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a26bb85f09fa4a6965ce265fbfe670a57a1154a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/847ee349b613095b44bb6fb44b9ae6a7c3bf13e2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/269026843416aa3b12fae41888eefddd2d9d8c80.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/849bb1783ef09fa4db1fd346819bdd9957127b3c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0aff9b8aa97b2c74b1ddd1cecdeab08991975fe.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/physics/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f135322537e2c1a6a08e1b575d97b02406bd1b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/497cb7d82fc035f1bc44219edd9f7e23ea37b90a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccd0922557bdcf0e5256cb825fa39064ae37ac3f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/864c92bd953e37f8f5d087b2c09024cc77615606.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f885e7469fe83e6eb59e7ded9fea529ebbbe8ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf730f3e5c4a776c966f4a887e5b0da28a4be83d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a8bd813ea75c23e805529b24f9e89c31aa371b5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/377c5c3536040f1291bed68143761e5d3fba8e0d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9909eb3abb53ebed21eaf534f3f74195c4002a9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4297d08dc09e1e6279d1c1f4839d00d0dfce5f9d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac4dc33417cade268898614a7e3a3b66308242bb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0b99263e7100deeb481a0e94752823ab4b7eed8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8810396bb6b12958a82c125918973450bc323cd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed0e87cc551e5ed7d456bee48e927c25fced5ec5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56d200c856afc2d41d0a6672fd5abe06ca6468e7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72240bd6e43057537ba64e06ee72a6f93fa23ecd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e64480b47ead40b57522a5374d186946b0f94bcd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/521e4fa647db9fe781879dd335ee9253e0d254c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7988d0b7e389b2355afdff6c73c074c64d085783.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b94336dbf0036551bfebf0b71b651de40b09ef7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cfbbfa120d11bc9e4daac02afca3d328ff8ea1d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/699d460fb39d90307fa776a499111308470e020d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13e63faf5524e0ced459d981f2a121c443aecaa9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9014079b9f4bd4ca9f7c146907d73e1bcfc3716.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/475c8c2130e9efd93cca6ece96813d9f82d63320.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f401a68d9b02fd50a5edb088c326069e35bbe195.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6ec46d0166c30069076d0a5e010989899cbd24f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d153766a1181f43413bfd781ae38986d040f41b5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac4b87ef93bf64012db51b25ecd23d7e26a03eef.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ddd74a0dc6e4f3c98cd2794054334e7406056dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51b55e75d68c3f8680fb88fc499fe1f90c500df4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06ecda03a98a51575bcc6d3d6fb664eee228e946.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e86b359502e54dd161d6825be999b717e48702aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6080675a29d3505fc787e6aa5764da1b2f06aeca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23a5a69729cdeda7d22e635d404f1d7fd416d1d4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1F; 84631H;84632F;84632-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/physics/aqa/1F; 84631H;84632F;84632-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e2d045f1f79354080deff749a40f11b3c962579.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1F; 84631H;84632F;84632-H/24-jun/",
                    yr: "2024",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9701f61e745562e1ef5a732d26e9d9702ead6e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1F; 84631H;84632F;84632-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7131d6a0d6490dd4a7bb54bdb3f45bd6e4234bbc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1F; 84631H;84632F;84632-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f1114b7d9c48d9d318e337545a4dd18d8e03055.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/physics/aqa/1F; 84631H;84632F;84632-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b712a9c9a4bb28a8717704e3b382cef46194bf37.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/statistics/aqa",
            pprtypes: [
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39ee98627e54255cd5c10f3ce4aaa121be82f4c9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/664aed65cf9dd75fa9f99c8ae6d4b1775f309bf6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e77624e1c9ed933e63025edcbe9c5e248c9e294.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6edee30f02a292cc222de190c0eabcace8cf7a4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/148ed2e5ee3162fe4bbbdb4c70db66d7554e3256.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b688b631f21b1b209966f1390e5f157e98003947.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a88e64e0e70f250ab2a878f30023b056684e46a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a368a7c1d3b7f8bdd3d59fc6cba1ad3884d9da9d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b5cd5b656a159497ef5811ec6c1cffbcdb1acc7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8883fffcabebe84b350d85120639157e28bbf74.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d7ae8f5f40dc1a1ec01dcf818f5898fb813db23.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7509e04dc3f55afda6ecca362178b25c5ee6356.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd2d361adf3b20267a92ec3999e4fbe27699ab79.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebac1749ce28bd2a91b0b22b68906ebdac860730.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/768c1a6d49de56a401048217d8c6b50390a04382.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ef91fd945a27c2352e7d3a121a1c118a5b5f95a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/953114f0dffe71c84db5cca8b9886b91192eca95.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b76c3ce99dc3e83b98510756850a5e580fecc6fb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cd21c7c4a683b8f04e8efd55748f5e6c6a57e31.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27975b7e2ff9597bbd7a8fa61edb69cc6f90eaaa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38d72e3da2ce989f2d393bc910fd123709c0e993.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e696bcc0803f429d0b820265e244bd49d3e088d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9cea288fbb99c39bc515fc5b40005cf9c4ccd82.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c2e023afa2f72ce9fc81651f1143ef48bab026e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cd1a0a2b060aef468caea58fd6756f37c2aa25d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39f671809e84e35e1742650355b9f16a76abd14e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2459fa7157977d1ceead2215e6dfb0110ec19a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/2-F/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dfd02ce2665520b1352ece19bf827612a216485c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de718eadc2276d4d22eadcb5b84cafdbcb378e77.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d204aa87a717c67445e82a1f6522482d7cdd914.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb43dba8db38b3a3ffa762fe9d67cbbc251c8597.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9785f2c37e5bec9f7ce5fcae72ceb21cc7adb929.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/803b081e19a3279db49b5ade94a9c064814681a2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a703e82c0ef4fed96b1d3a3b18040ac82e6a05c7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74b6582a333c01550cf22796b49fc52f3115aba4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e25397afd51080650c6383b6d27ee39d828588f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/statistics/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a95593301c5ec63978d02718ebcb5d9105c1621a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b50d6055ec39c040ee6dddcba3cd3a7c4d880d3.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/aqa-certificate/maths/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68d589354d223e041df0998cfa58c8650d3cf575.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e2d9bd664ab89267297feb9f5f4f9629fdce70b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2baa057669d31f2c5ed5c0d768a6712afcf2f04f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44be3b959a3d27905e87ad957b326cefe1a1cd30.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ff92368fb72fe1f796d546768b55f1f6d11b76f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7287f1e113e0182b45183416352224305ccf97d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b05cc4adea5f1f69fdf527b3f26aff0a7ad26466.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a805dcb786058ab9ef65dec4f935c0fc06fec12.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da6c9d0a4ed7a729f98d659f357bb3de58a4f52b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5de217672144bebd4f9db9be3210b55dbf47b091.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea376515608eb5d61a1ad5cd7e71543fb6c2fa91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91e4ccec9bb86e6248240a7c9e746d88a9119877.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/879ae5029823e1eb007f5db39e730e65d3eb3122.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0da02d40df02c673fc5ceffe75ea1a93d1d754cf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/aqa-certificate/maths/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/201e4bdb17cfc04925adb0d0495d49d73f777523.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e199d7905309e4a4131a762aa36854a9082881d6.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/sociology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/sociology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ded9980c992d117869803cc23da459c4406be4e7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98d3a7de331575b80ff0d1bd549a1598804f26dd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3e84363cd1327c8715fb5063a96c31edf85756b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4f6274c1116bf48c06b13696e72dbdbb55acc45.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d07f4ce719cc27d4319f7ba76146e4b926d567ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83ebd9101ad6ba39d79dada5f04c1a7e2c991a51.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28a3a97686cff92054f141490f17056b4089b4ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2f8b533b792f2aac1f50b00baee5ec23c10abb2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85fbdb5b1341ab6c1ecd767387ce42f786c4682f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/502660dc8cd9d7f15c5e3ce8a7762b9055790845.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/sociology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/100ebfc15401f054255a9e1577c379913acc4f11.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c07879d697e15ef2c7e21531c9f30f10bd83a68.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ca7f494814187b213f086c020df79a4f9aa93c3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/95626fbd5890eb1f26fb7b052afc1123c5c6bba1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d445836b8de3921d631e755fecb4b9d398c50629.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a19a65a4648c2590896107c10af7b2aeee8c8a1a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd29931d9913778502c643842d4efff3725b92d9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e237c8833f1cbb3f7af195212b16cd9c3b07fc7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/sociology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7447fc7a9521228f8270639adb5cc8f2bcb9195d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f9cf95d833fd52fd7d68910fac90ea02b1b51b1.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/pe/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/pe/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f04825cbd827700818aa49e0c00fae0a80c7e275.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b313c0d5f33964224ffad4be9138686e0ad8fa8c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7701bc0330aadac3450475e4523347faeb81d23.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/40a941b485ed7e014c748e95940a8227cb3020e3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d7ce8f614e0d5cbefa0f83c34393be858eb7ff1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72d34e5189a434cc6a361e9b246ac3a124b6ce2e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04eac7c440e9f7eb76a72f3ca1f1a699d005c0ae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/436b5c11cd9b4682527ba5a5bd693e1b914e3965.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c5df55becde006b2868c1bb36315e0a93a86a42.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f9f3cdb932a3e01cd51066e9013527bb8075c70.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/pe/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d89f9891207126df5d858f8e26de92216d892c89.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e5e38fa547d980377fb56cc0944bc6781d33a34.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/347435c28374336437b92e6619e1bdf1475b8403.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf30deab2b938d4d4e42e8b45171abc2d62eb861.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d37e30e9708785e6c67af2cfc72b50ce52ebae75.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3902c2d83db7280aa42fc72af8a53fa283eb33e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/209c0ed5824f886af4d2be69472f92d69005d81e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a8e1071082e52edc07c678b001555ed28e27422.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/pe/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3eb9778098c590e2868acce82a1becbf5ec33434.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/078a8af24bda6c730da393a04832141e64d553b8.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/french/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f73f443db9844a371b7d13ce95fa865ef765a8b2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67a06092af63d3ea92cd46d7d00e8c4c00ef4a07.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6681d16ad1fc42afac1ca22eebe76b75b3d9554e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6436fa39cbae9de107ddceb0eab1e95115ac2520.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/W-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c8d4b42c166fe23dcb63897becd7682b0fbea94.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fec031c241c95c0df79dbe732fcf0342a22cae4c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e96392060c38843d1996df9e02af6da0d92e69a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/034238d65a095eede8487488e9901bd08e1a5004.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89239a32f6b1d48b62d318743130aabcce2612f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da01c5043bf15ea2f411f2077bc8365d73b35a39.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/W-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77e2132aa36f718b5d83855a457edfa01e4649b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c9428c3df853f95bae6bff6b27d260933efddc4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02f6e06e670fb5e5cb1aec87b59fa8a07bce0f80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2394ce599658e559f76f82223e45c1656368b71.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05e56d019dac582a6afbd706536813f8ebee26ac.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/352ca413d387ba51d627a49b25b34ad7292907ad.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/R-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ff0fa42fb06272872f84fc7be38bb580f7f864d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36dadca33c2f23a32acd7087f3d5e8b23ff15553.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe94e33959aa1a4ecaa6a5331208846e41e1279f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d064dd14ac71948054c0c8cba86878bad3cf3dd9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc24235ebf400195575dae7b6153267617d189ac.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a65dfe92111bec1a7f6bb6d06fbb6b4161924dce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/R-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d3bad416eb7c495954414f2f4886cff0fc1c4df.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d50e31ae4519626e04932ddbaed5e5886b51bac8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f24a53b5cdef683b5282d9b7558d400e5b6ed976.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ded85945ed08f09064c3eca8ec85f7971dfd94a3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5146abf7a887188be06ad564a8e1d3d7bcf1f4dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/L-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ddb574d89b92792edccb29192a219a8dd5eec36.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f45c781ea4cba8e218f2cc9d2bad93e1d866e35.mp3",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f25a2c6d91fb615ef4cf2a9d57547dc9aa30bd30.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19024a9046a679d872017f24559c0538b83d7819.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/577bf038cab56cf0525d80ff2328e04818e302ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57ce6e7d6da61e9e46a7cb769c383647dcd2c690.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91db1ffe11d3d7cdd209f00a25a1b73b9bd2c582.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b51ce578353c7507c4483609720d5a1083ea5c72.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a2605615f521fa98b03bb9c90b409f41132ee91.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/554d3fa37dfcc1b10dee4cfffeb0c4b94027de17.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0976b349ca7fe264ce9ce9b27499275af79f7bb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03c759bbd01428699bc90b5e8abfef495dcf18f2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/feec691399b9d709f67bd7b28a37d38199027afc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3892e6d0272634114ee60f36c57d0d62871eb013.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f28786ea19df03758d33ef2326311bc2f3eebb2e.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/569606ce46165d91b0cc06bd38711758a580a7ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/L-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/851fcece670ac577e60fe5b0c86b2d8f9ca06aa0.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd1e7b5a845bcec9ff4b0da7baa9d539957a4782.mp3",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c71be1ac8f2fa56828486d910af31933f585de65.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45ad1d3c0b8cee3c99cc6b491b9011600ef2c2b8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2fe90b307ec5e1ca784745f7d2af943f7e44c1ad.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04484fd921f69d333cf44a08d978004b3913fb7c.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ef5acb038c082af5638a7ec4e5a0d3e13c5bcfe.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e82a769975d9134799f08c51112d8f5b35c53cc.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8da5917f136baafc974c02b79e6f08105fd13d57.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a62a84702203ee7017e27b902659b4253cf6a50.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ba2564a5ce36db0674102df436015066eb22bde.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb898b4a35b95e016f9eb860f4fc05093945d8e5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b41b8fa6b6cc294ee37ff9c385324a042e26ad9.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d34bc1c15511d07eadb45c7eb23cae227656488.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7949235be44c21c9a09ea21cba331d017c153802.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d553948acf228e3cb12c8ad21c13e8432b560cb1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c84ca6475432d34760e3db8cafe2ba45737ffb1b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c36295bcac8bbb1281d2706f9fb93db6db4c5ded.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aef38fc343307129dd453133c04d56f7b3a8253b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68881f75341742a6fe917b9f83ce4d5be74a1ab4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d148a5ed4a51f7b47f9a648056c8506b3fdd2e9e.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/069219db6f652833868cb23880fcf4442c476568.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fa11aaccc0d98d6ef493984276ece3045577c08.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8133b3ba12d8effe867318ff3ef29e03ddb42050.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e62c69178616b4878059f01f0e71dbfc2d5e6a2.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e214260b0be79b8771d36b475f54ef27d0bbc2e8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a403d7b54957f3ca3498ed6b759138ebdfe143c.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90e97580814e6b68c60ff2223bb2bdebf1758882.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a97f2a0bb67782f8869871df30ba212c5aa7a3d.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86b886f5513df4ef236645d396a21a1d0f558bcb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/209819916469c9f4d47fd4e18e249a0d6599e5d1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67e74934585a47ad49574dc44152a0b3eb4b4c6f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e061b5d3a1879e84ae4c1ecae5e30a42709f784.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21049559650dc06914477965a326697c83659e73.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a5b5327d62515add5d4eba29bb69ffce4e6cd96.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/S/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66fd0bf4413b350a4900fa4f774302c74297744c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "SF; 8652-SH",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/SF; 8652-SH/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/585d85a1046e7d42e8fa78ffbbbc615237956248.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4556de7721919cac9a68b7048ee9828c628a06cc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/536226714791ccb19f55439080af786e9dfba363.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/456f9b0422ac865577c1fea9c8d1997e9e09d507.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce6831b6f213963b175cce4fd354a530cf640b2d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9281ad1aa5961b0053d4c7a136245e33f4f16e7b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8da370378e50696b68adc615efd20b04fda9b10.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5254a4dcb20a80706d30bb139613bca77034f54c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/483ed202cbeca687fc4b542d9cacf5dd8cb79e4f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcb7cb92fb16d31a4551a3f640cb1929ca979a50.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15b81de52e564494bafce32aafe54a99de42110a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ffe033cc739bdadc4ea32c9731a3061c42393b7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0c9d7b1ff85a940a218a462ce645e71e470ea18.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99029af63c038c9a22e764e704bf46576d78c906.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e44573aa15f97b77bf12b2b48aad20abed901e2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3483c68e36a6e7903d6d2ed31e8d28652fe22f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d2ebec565c3ee3cf888fe023e92cd0a7fdecbd1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e90ee85968757d474a0813e079d05c4aab239e7b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f3f77b9c91230319eaa2e3aaa91d40d0dc1e770.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a29a848a09123a3cfaae4e2155d9398290358e7f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f99c0008b32ad85d6fcc2ebc81f7c5a6a7e34dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4fcedb0ca0f71fade17f8c2fb5bac39c930a0015.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/french/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ed598b734f8578dea2cc4e0820a5865c22ae2c1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be8fb4feb4b2cbe5c57f05900ba938522c80e6f9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a4379b4de8f12f0368dbb1216746800de92b470.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7377b27a988d283b9044e1ff3ff4560cf93a9359.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c70104fcd8de9cbed4b93e07135e865f15a972ce.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f78b0a043098250aa5c8f7bed99463f2708265c7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1afa2521a84bd632e00c013097faa4678b0c05cf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0bb780d13b37131dbad6cb3740795d6e87d2fe7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fcf4998fac4951e62a5686e01afcf245cb515b2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afc6666cc17a77b9299ce44e6c601248a4ff9f7d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3c4146d0a69fab299182ed4d11ce2c4addf95a2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09441b78b50172a5d066918d3e076fba4390217a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f82720223c9a2957166eb0102c88b2b55128cb6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/beae8ce79602805e20836fb8dd28d261f3033681.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28862e7ea009b355d087df9c5a9c4d8f41237078.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/872bda95cc20c8659d1732723ef3e50e2e7ea0ac.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69d0084e498a7c99f1aa05098681e81ecadffb9f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca99b7cd9615a4ccf8c448a3ccae5d98de665de2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/40afed4de76e3126e4ca8022f9d7ac1c96ddf1d8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9684e24c1cf61508d1307924458d060c18c571b3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9626f5baa1aeb1c8d3cac55bca430e7549f66965.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8f893e07ef3ce9bc2e16e919a8d484ad11a2f4a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9df23192fcb2dedd9cad944cfa54b01c8d00cfd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f15963985cfd47dc65467b464d2c58c5e3c2360.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5947799c3ea4174bbe4b6cccb301c3ef2303461.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd10ca09870295209f10b6a80b4031b897857876.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b4fbf9ae92556adb47224b43421df322aaa9270.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f15ab02e419e55b00f66f0d073b9bfb6d8f538b9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/964fd1fbec502e4f35779a78f38d516fce20355b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ab41576a9059007abbc7211ea00faa066032bef.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90f1cefe3021bfc2b033f1a06a21950229660ece.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2430c50eaa9994acec54732816ce9bc45993b808.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7331ab247430898f4ee73c2d7a6c0b46696d4d81.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b7f09f6560a3581c83e54f4456be66fbd106c85.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8c8ef9c05768979c716d5f707318eb869e494ab.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5880125d512df95984e08759215b2776d1dec63a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca628dbc6fe3926bfffbf0e5e5b74f3fd29595f6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/856e983dfbcf12bdda131443c91df8f005082848.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8449a4e751ca108ed020ab71b99a2384b02acf63.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/63cd21a7a40436e2c451b6ae3577b07096aff648.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/french/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c4a4ba0357aaed573c96cf00a51dddfe4143646.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/sociology/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/sociology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea161256f3d3ca18e41d54a89009152272e5adbc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbc2ab781bc1ff91509a5d232b99615977dc2d1d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2d7c8d62cd518f017c80012bcb2317def610ae2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8532235b6c80ce81936940efdce32ab57b6c846.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e37979073f2d3b9278e309cccb16253d76a68c5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/312f8c9d692f9635bb7d51d0c5aedebe5fa2332a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77d6435438a38faba19950f4886953cc0f6b595b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b387c3b545f0fe49e14e3c3c05558fac5e4012f6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/577735ea63e9978eb28f92672135be8d632663de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4577c08cbc81bfba73641ac8e49fa076e3d9c448.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/sociology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/926da24b3bc1ce0f9f4f434d78d304720a007304.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c23bd63a143eb47b2986371ccea389688ef375ca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ada22f946e7ffd420d45c1cef788840c42f261c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0a9834872c31860d63e15cf9f9d18215090b50c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8066e34e599e882c457dd4c8a3a86cfacb5b1768.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd6b33ed1b10232147b4283e3097644d3ca043f4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb6e282e181612ffd225f7aa0f05c2c6a80d73b8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7bec0a4bacfa10651fdb1bfe23fb35e35e6a7cc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f0581dbc9bd1940e5e919e27032c24fedb72b1a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8bd498ad4424d70c20403d8129d67fdec0693d2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/sociology/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b658e8df105b8bf03c243f591455915bc13bb633.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/921300b92e96239d3600246bf73b255deef6af12.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b001ed47b9711a52dec045d66beb5205d6d73cb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42918800f3f138b8882fa4ed0ae481b0c1394981.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a97ffd32b82015a9c139d1bea13db8d3910fe60.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52caf40af5bbcf38dbeeb2a74f260e92f38da60b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f29ede4c4beef631f922178059ccde054e866bc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84b220a22a69a20938f89d472ae3b363cd8d0bd1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/sociology/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77116f5de39518257a0e42a3d711e0fb9a8d27c1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd1ceab8fefa62d802e4e9077032db6bc017cf90.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/history/aqa",
            pprtypes: [
              {
                pprtype: "1-C",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4962b05786c8e45cac5fe5329937d42ca8e2d6d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87c0573e9c07b2e68348875034fd74d8b31e4b4a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d04bf16899037a268fcd6d7c8180eb74fd077345.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f24af0d720a3355c9b699e95b44c61b5601dac4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-C/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9eb7043d79e75efa292994bf56731f8e58c87bb9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/00f11c6b1215711e05f96a67ee3ca967ba9ef6a3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-C/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/768256b194cd262e1fd6238e98f33aa0bb2df480.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/943aac39127095dfd3b00d4e04216ee3b93fc408.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/886e3768e7bac60a550578dc64f01a2d956918b2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/651d936fc51b17e9fb2bbbf4b068548571e70004.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6870d175a7f5b9d19b5af57295bebae7dde3177f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42926340d09df68539b8eb17c343191906e08054.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-N",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-N/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84233535182f1e58780e224a0c68dc509c8ebe20.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d99c0cd51567189714f4dbd0548ee7936ce0803a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-N/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6080c6553225eafa30bffa6a40bec29ccc05e553.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7fd74ff93428f4fff50e3bf4c110bbc22b68623.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-N/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad93e07b94cdd3087a2953e2eddedc8ff944331d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87a57c2a29ad2121796f04d70dccca64e68c2df8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-N/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e47d27f0e1b80ce1940a760fc109f4c7a16c7d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1eff968be992ee7c4e74a090ca8f025738f395ca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-N/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1c23b39eee3a5128edcc52eae6f66066c387197.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd707b2a8fd90fb104d2422f30a084e114f37f89.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f37fb6aaed52ddb88d713ca8a1c5f32526d749b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fab45a8ae2a1566c9de101a1a0e4805a1eb59c4c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-O",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-O/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8d0763494e7a0230d28c7d57770af70b34c057a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/479854c6a19528c12a23af219e2841a03f6765dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-O/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1be662fe24f18124e4d1c64ca67dc967f9e71b71.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7e81fcc65df83d1b8b7fe6b6a209eee83d25655.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-O/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3582a235ed11caab0bbe83e2363bce7619006122.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de07a1e5c27c868cbafb23fee5bca6acd95a9ca8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-O/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4897c46ea1a3ac84156938cbc25cb66c59196d1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb036f1ad11a0cd05addda4d084c9f0d1f4fc2a6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-O/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbc51e599f516113f2f29aab88ce02c4735af8dd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9501020e78e75214fbf083b7fb3523f46d85c457.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e05f1d0fe176ce1c25c117509b2f9e2d76f1fd42.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a87ca0422b20d78a2d348a2ebccc62e00345ab8c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-E",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-E/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9026efd0a9738e932b3111f26e0d4cda82c815fa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/910b284dee62264bc59d0816a93cd4226090ef74.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-E/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c82d4aad76eb66b94eff7f1fa98a12b0968a0b80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d430bd6ebf82c8684d3abd41ac204c11b08bf157.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-E/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3dd58b614d697d90fa4d3a655308f5b3d6dbced5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1a8c48b43e491e3479eafdb52900d65369ec405.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-E/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4f4a5d594af3332fe15eb7258577e27b2adfc43.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d14653946970dec1e622380666952f70c95fae4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-E/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb04614738b340105a74d72d0f1a07e47a2ab259.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08736e68951499b2dd567c378274dd449d6ef33c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8bec92fca48ba9bee39eede76c72c41fdbb59936.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/942d6734fb0ff4e959b003fb5a426b2ef2bb3eea.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72ca285cb7b4d324a4d35f33ba0b1983e09f9adc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5c97fe7ca0246fe219f5defe5099efa8c1c07c1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f2f8cbaeae5b9b6006625736cc2de5bad200939.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ae40ab01e0be8116ceec2e1636494f3fcf74e93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82d366bbed24d7477aa58c306c15498aff4aff35.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/810307e32bfc782c156ff0ce6ade9cb752b113ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f5faf430cf308048a2a075fe368367718a1a9a2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ce0420b2f0ad1ddbc5288cc538a33393d1e9738.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0af076c5e9c02ae6283f031b8179649a593e310b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbf01bfe02f192719ee3ad43612296ee1f40649d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/affe8b48e16f64a22f59b258c65bbb31b54aaa06.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c76ea2c3ca8a8a3bc7c9ed582c4ccc052926d9e8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/459877690dde695cc9ceb54a7a261384b45e3185.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37fe817d2e601bc5f7af3e66627fcd1dea5f22e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43b1287175d6f6fd5e04cd11d7f47a774cdce884.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c25733ee7d6e20b689d1c79a007b984ef88de7e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb6981f494989f9cc0e8ee10058e28b15b1bcf83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ee6b64081d4fce807f6e317056c3a8a1c17e973.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3b0cb87a9f34d33217bf493d7652fafbe3db12d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/108568a12b22b97febc80a6bc512681f01bc5eda.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5dbd37a5bd3ba1099edcd3c3bd7bd1cd2b9c0d67.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74701f812b630fea86204ce67669d449de1d4416.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-S",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-S/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd4a36b118a8fb4a5f055316c55f9c29b4301d53.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89e7414b0252aee366aecc48f4445a911d85a9d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-S/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75430ecbc872319ede7217a1734087317c3fcc35.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f82d1b367b44cf8e610b554679feb8920b01c82c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-S/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fc297f57d2e154e0673a96a4fd6041cb8dd1471.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5eb6b80f905cfadedf08cef14d199786460fb041.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-S/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c841a0cdc233f56cab7d9ca396c16f43c2b99d94.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/baadfa9b6c19c07dcb40f167c429d5de10419376.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-S/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea38dda8fcbf2707ba384056384358d3d2869300.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d7d91158cdf49fb643aa46e8498f681ee5b7891.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbceec82a6ff39c1c9cf9cf838cc00e632618903.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cf01f9424d5503b6dda8d2f4afb38af72fc214a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-R",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-R/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9154946d9d293aed05df18e71ca5b4b980e7a2b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5e864bb79c40993501cd2714a30f6e73831b024.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-R/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe6c8be77d3ecc5b53c4ced33f87a3d4810f0394.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49d71796164efbbc4138a14a4f9d67b27c8c773a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-R/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cfa334c65a320edee08c005e18bbabd78fa1a604.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88bb178be92cac49527d49b713f5aa8bacb37eac.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-R/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d17fc3a6bf4cf2cd4154927ac18ae50444937c3f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d43bd5a9caf3106b4f13536d39bf457edef96f0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-R/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a7f2dcd56705d5905e6e7ca2d374f57ca7481dd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e8133debc4f76c05b6126295f6601cdf3556171.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c9891090e1005db0de794e1204ebc69c594a043.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb18f2ef30f33a061fe70d4525aa0e7353a7e338.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-J",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-J/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e08e9388f6a610d93c1d33f4f8a4600ee831efe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27379fa1e9f9cb0a1584e4612cef6e035986a019.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-J/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea1340735f5a33e8ab5aeef45bddf75322d57f91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96ff96d903343fe17c0c318dbad5f78db8f87f8d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-J/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1f43b943203cea0ffee62f174ba38bbbbd4bfa6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b04177a0eaf7929a135d89d21572ce5af1dd1d0f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-J/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04281d5e192bf3a7af8fc1ab0698bda9a534d420.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e182b5657f8a168b3c49ba18650084613e72177.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-J/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b16f05233cfbbb06f1345100596cd9bc6a3fc7a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa0bdfc04ab15047ef4bcc42601ec1661ae013c5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7049de07beb45077ce3fe9464425b67d0e44ed0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d823613e3252cadce7dd4f05f0cf29a201b63f85.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-D",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25d4f5c28aa58d486a8f02f859a7ad4e3561b348.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de56969b483acfbb5ecc65fe68c4ade3f0cc26c1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4051de5f45ec3bf90ae7fe959cbf04e3219ad1a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c3557548a685999668e1d35301a4c6e3cf7b9a5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-D/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d77d3ac921db9c296e8d2e941a424adf1ade62b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f6dbfbac1e14d688d92caf2ca4ff09742b8b17e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b75838b576aa85808353c13bed2188377b885fb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e42931f63b30abd70819a72589695ef291d4c31a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c4ab9f1346e8986782311abf18dcedac14ffeb0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60f53c41eec8fb03c6b2aa0be3d152970f56cb81.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5354ba205625bc486b7ef0b2f7f806dfaf84b940.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/221eae6fe766382cbbb42a023e1d90876bf4487a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-L",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-L/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/feb582155243258405f49cc8f170b5b4b2de00ee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e33bcb2db237f28557e992d5afd475e927d16827.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-L/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4a843c998aa187d6e341a22f33c6484b6aef3a0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14ef7216f2a1038d7ce9dec24ac1bc8f6854c14d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-L/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42c10c7b86acba3c2a5ead301e654144d3ab59d1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15997bfe503c34c05ddb899cb4e0396cd41b2879.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-L/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0cf99557ce10a9bd810ea7a0692c3963fa0d9ba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d6bb884020f60c4267ff40b3a496bbb3a4a4bae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-L/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/444c9cd89f16efff932308e7bf939dab7c480e8a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a88864c9a8ddeee39e1562eedbeaa83b666110c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/266bd6d1da1278d212f5cc40d46288a3867bb88f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d314e119b7acfa58e4078e0f6c3227814cd8497.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fc20f4c794817a1a377060c449d17d14c87ca85.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbe6b8feefc00a18035dd75b11d0e155bca31586.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e704421d805c3a1ed92d439943542e91c360a3c1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8950884c78f099bb6bf139f523629cbc356bc608.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8683dd64a71fe69149685a86b8f4d7d689229e6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88d4b92c8687a8d55322f39bec0edbd3fff68940.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b291ea5936a30de801348608de79f7b00dbd1187.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1668645e1a254f25306c1a0060f730ae0c2e5bfd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34e149a00e7a3a5743bf72a22eb4e481ad8f47bf.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27da6c4b6fca25c771aba0437bebf91ac2841386.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bb5a4776188754bba630261fd49b0d38ca3138d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/199a4752a95b4f9dcb9a877451e83c123adb97bc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c07b9db3848bf96476faf4c45b4ef6fa15d8fbd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/328766dc1e427e4aa213688e149f55626720db88.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa3e5b13d116f6dc4e46b4b1694baac433f4cb13.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a5bb869f750be01e829288ce7f3458b50d0ec44.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa007bacc22fed5f9ea1cf9ccc061d761f284f31.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b673f8209335ac97380453e84fed248bbff5588.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54abbbfd6cbe58bd53240ac7d3deac31fc2c846b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/831c98eb5e372667c647c97925c3f62bb73469e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/997f8145d81d18fbf83fb66561fc1e68de279bc8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/300500790f50fe24dbf75ab893d5fbdfb9dbf5e1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3cb7b52cb2dbab2fb9d4e7eb3505d2ff8e08813.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d246341c04580a881ff58ff21019176c4575ac13.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-K",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-K/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0de1e1f540da1b9081b98690e9ed9e6f27b521af.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33753d641ce35f77147ac1f297e935f97afbd84c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-K/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52937075bfdb75066aa1a9010b7965d5e1949470.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f19b78e734b1c8b2c6536ef547995e5f75e1ebed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-K/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b8d2417dca1dc389b5cc894f68bf51009488328.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a75f2c3f5f8cf86236122c0fa353e6ba31c8896.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-K/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa483b40b0334d0dc38c1aff84f727d422c26e87.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2502600ba8f2301c39918c001f6052f6b1abb172.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-K/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7381ff25e7ba870b1f8dc21d848ee13cd54c810.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d271667fe1eba9a056104a735c4cc95b4c08771a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de986ec687c03c00976c54d38ca9c464c0835727.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efeb95e1e8cd806a33490719ec1d681a3e4dab16.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc93e5e29872ad6916f66ef9bd8056e02e7faeec.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a13f9838695e5463b300e32befc2ebe0720edac9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb4a276f109959f4f02bc04de18cf05cbfa44c42.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9258ec4345fcc94da1ab01668e8000b46ae0b461.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e67fe48645ab52ecbbbbd0b1578754e6a026589d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e977ded96be0e780f17d8b8aa7fccc3d0adee505.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03ff6bca12416e04dcf26fc5fd0efc0ac88ca84e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/088efca39fda503ddf959b86699df4b1844b952b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39ceb2c222ccd3faafc89578ff3e849b321aa678.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa4d2edbdb04d1f23c89aaf223f2bb211fe70911.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58da53f31f5194743cc7421f1e258119a7688a96.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e8c0fbeabb8c4668d9182558a4382ec90856d6c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-P",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-P/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34dfbfd088cee10e6376d29c815d290954645ac2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/833facc900b723555e78d2717998ed28c51dcbea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-P/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d41a8885282a9889c73b4643d23502861059eb40.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eae7486407f78d827ac69944dddef0194095ae52.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-P/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91a6e92168ee54eb471e04df2efdaee8307ffb3a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b8e626d61972220d8c2efdf66e89c4735ca9080.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-P/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/48b96380e7b0759016bb57bb5499a433cd77f14a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db189ae4b3c79e490a5dc4c444777636f63eaa52.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-P/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20a16ff87288c6e3cd3bb8f7a258b33fa597c2ed.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c30fd35f2f34d5326f4084c8f896af040ec58b8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05ec0442f0d36b1a5e146d326760fd2fa94a9b36.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a04b11fd403ebb3b73154529103637db1072ebb8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-Q",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-Q/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f491f3e49324a31032538ce68e9d421de586975.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db5bd9f04cabbf6ae5cea35bd0e8af1b26b7c442.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-Q/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4eab1c008a731b2b13b91753cd36f6478b691f38.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/234cbb6f2c75625de12d93a4b7abcf3c6cc5e1e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-Q/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/faac4dbc6f2afeb4321b41b9ca41e3cd6e51b02d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed82623f922bf48dbe24dace3f2115037d432321.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-Q/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/357894b807ee3c95917eb84169303085e07fc11d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97eac665285d39ab260fe49a861db4db2ac8c44c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-Q/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ba203bc6879a3ef459ca27fc8faad3e11305087.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a148d563e5edb1d4137d8fd85867e35be82219a3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67edc52e342b2d37ffa01f7e2028e0270e676b84.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db0ca2086dd765147e33f8ef91f92220360154b5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-G",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-G/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80438c1ba79bea4b68d1dd32ddc23679018fc066.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/153504bf4d4197ae516d7726f0aeff85be99e16d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-G/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/267b933b9361d8563f875c995ad786e66e4b128a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa9f99e6542cf79833f774a3e22865658287df5a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-G/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfa882310609a7d57010ae557c1700df1cf4a88d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/526c7bf7ea7d608ec2686a7b90c5334050b14d59.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-G/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e602392df5a6f295982d1e4c4e10157d6110439.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d231d4de000a30c30159df4cb29820ab1fd75e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-G/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a803678c814626b8732d7b60c52083672b4d014.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f427be031df533ad7d2121d12350873ac5bc4b6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12510927bb0e59f10f41b0d8cc7d3daf85ad7f4e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b910bd0c169a9ada4132651d116c4322b1a0e60f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-M",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-M/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbd307a340a8847f7573df92864fe8351ae41288.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2123d438375390d39249416fe68f50366b3505b8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-M/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f395afd822030e354f4917a5c43dbbc10f04534f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a5ab4173c7de7afbce67458362c40772591b0d0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-M/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f7126870e52b2b1b1095ae706aac101a73717e7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3924ba692cd9c67fbdbedbb9ab1f4513b2710350.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-M/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e45a30287e9756e2c381eb7168eddc04a51f5df.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f203bb46bc64630cac2f12a0dc8c460fbfa7206f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85a7fdace2a493f3005f5029c6fe064e92004834.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64e94924b32b6a685d2beffaa70e497459126d86.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-G",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-G/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85a29507eeb44126365df445916f050252dd3979.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b00882dc2e67889415cc037e56053ec2fed4e4c9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-G/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5826467159c192c6cfc849e3a13e9de010e45b9c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66e231880eb78054942e585b279c49ea7d025c8e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-G/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/628a1e0f5122b8e00b2a4c5fe17b4a32a09a2ff5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac9cdf888c2fcc92bd7b6dfa77ed84738390d67a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-G/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8784584059f5103175d2eca515cfa25cec3aceac.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8316a9462b26876a66349fc21ff50e1e4e2c137c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-G/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/edac9c45e6e34e3832513cf736d1c632cc286732.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e61aef78234555eee2331c36a8fa750a491c86db.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f45fe119c48eb420b19c900d50fd9cb8421dc390.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e2408b5f6b4f44d70bf59709a212f92bdf7c8c8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-T",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-T/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d1c6f89006baea3f0510f1ffb23e06a56058f39.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61c2f5f207bb20c17a5b4e52fd25a3cd543ec1fb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-T/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbc5ee0d836f8baebc50686a8bd3bc608fc459f0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d8ce996fd02a4207f859f2ed82ade67e1d769bc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-T/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2591b8f1a45c1095c28b9cb41cbe694182e3b68.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8899c67a8e9090dc2381cec0031357279b4b898.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bc9dc760f6260b880bbbf15b2e2f8e5568c24b3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/929eaf7c5737b80a27f0704c8960d41dc8009c4f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32c2c960d4d9f5264bb61f4240a1533f1f0c8754.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c7dc24e50ff9e78eaa1ad06295b5556ec803eb9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9af97f4b8014ab63ee6673ac06903bf17112ae4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ec782ba4d1fbee7a4de50043e853166deeab9bc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b35cc9d88fb2133030766a56cd4d8ecb0534d7a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff92f78c8a4a8ab92f8ececdad7692041c8c0683.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/037631d4f0e80da6be70175604a6bad314ef7480.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a55247972698ff228e5d30034d7539806e590f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e936bc28b254955c881a9b295fb3d6aed0636c8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8651e04697bc40d8e4fa88c13ba4b026dda7d7d7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38e1d9f684c2ed35c15114dd86d9765009acf478.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72fc875cdd9542ebb74226317307f68e8a4c9cd8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-D",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c76f8f118a0ced57f22c21340504340209671cc4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a55d40e76c501940c3cbf9229074db669a3fe668.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58d57ffd5735f516984efb1612a534a46d0f0898.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef37e0b27d288490a5b8ad312ed26d3a1eede8c3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-D/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66191a2e53427058d463d0c0d08cae979f5d6db1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a442caaab17c2b07c7ce1ceea2b187fefc3f62e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a7b34e4714f0bd2c15832763dbb829dd073d53e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c730865e76e72d1dcefaaf4b652579e5062d16fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8cd2fb1a99621e7004ad48e1d281abe22b7d369.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8cd2fb1a99621e7004ad48e1d281abe22b7d369.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcec5dfb99705b79bc94814f5330fe9d81c1bf6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7115c73ec65944a1489553fabe143912cc0e786.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69c593ad2d0ce7979641e360ef2ba8025d8fad44.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-L",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-L/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74132d1916646d820230566309df20db6a335281.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d127436c1eb71a0684a116f23103f44a98123cb9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-L/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6374f9c0d0cd71a9644724ae12599a8040c89c0e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ca8661752105aba1082cf88a67304e3cc908381.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-L/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51d0860fc55715ef88a861265993bf011cf54beb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f95ee424abf3f7fb254114e7c99cc0e1bcca27a9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-L/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1647f1df0f584871f5eb5c62cb41d6f126b0a1c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ff2a71c68394f3ef318543bba524d8db2dc19db.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-L/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1def764f783a85c312d0c6b49dd583ba637a0ef.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8595c183906a87028a960bdd8e64d9b5b3294727.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffda91e02516ec9b20dc5e45cfdcef217bdabc83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a675ff02ff0bf15180a86d9a79b83284f7f156d5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b9a9170f5d1e9ad915fd11fe5df455fd2999709.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad9d3a86c55b8406e3b5db43bbaf6c0bb79b82f9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/914110cdb18b505e861be6cc4a412788bbae124e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52824552eb151dc2ecd17afc14d259ff8ce6ed93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09109e5ed5a86bc664b35b132728b89fab7e6b2b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f462a802b36f8a1ed10ff54122c2970d9365d074.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80e561ce0e503b505e9ec1ea56101b0975107d5d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0acbb772c789aa50caa138c038958896a185b67.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6406f8bb4c02007048661b1afc8a7f32780b9a03.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4dfc7ce1a7a21e25f41c942a07cb1a1bd83053af.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-C",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b15b9870d54490b533b3b313a4b420f59cbf769.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d6a9a68e5f2886305780161d4df720158177935.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11fd1b1b7b424e50bf2c5332354013cae0927930.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0e5129692487e2ed08437b18bfb5fe605f0fcdc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b48c62ebdfc4e51f84c1e620129e6985b6c2c3d2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6917516becd1f7b3525958f88e9268ffab73037a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04f852e2f444ee102bb19069793fd3beae13c8d7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/490488caec8ca7d81ac243f442104ed2d2cdd7a5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-J",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-J/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c018b78bf3baeb3e471ceca3d440c388092ac1f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f7f79a5bf1d2e9e5a1005b12868f07b50dce68e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-J/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec166c665b532b8a472c9a35c312a8acd41380bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce3af8eafb34ff6e5605f9425831a1142e2feb67.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-J/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d3b84a100cd4be5bf1c616c40e674a84bd9e6a6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5289320994af87c57394db8cd6c8df142b777d10.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-J/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09aa3cb7d1ca8416fc0bbe5e3bdb7f59f7ca76de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26d108fc2c2981650a8f7085593ae16e948b7cfa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-J/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25b7d452291f2882bc1bd5ff6322d43688893726.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62ff5757c4eb3ddee7176654a45682a05400dc92.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/adf29c6a7c87445a782640ca45e5b156f7cfd88e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c975f679ab6be2515db1f2663c4347426b81290.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-K",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-K/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6da47c4d56959cb6d6db5e245824efeaaaf8763b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d8dd587f212748e802c485bb588bb58f1c9b473.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-K/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d01d7f3541c11951a10b5cb2c68664bf313d3f37.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de46b946c1ce26ff3ca807a58bc7e8245843e6f1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-K/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0569b7737d48a779aac7d14a6fb195249e6ed47.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f682f6e0af8f34059bdf909b39f102bf79a654d4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-K/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b6a48ebd922e3826711cf276e1f742181ffc44f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1a849bad480da0d23f6ea84024bc3dda3870e8b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e1ecf8b64f2148ef638ffef772ac40ef05bfd7e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/217bfbc425bb19d079208754ab2a5872010211cf.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/2-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abf38332c0eeba04a8f6e8aca96471092f9a0632.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c8445441c82416664b88d143b2211cac2ef4a85.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47ce84bd6dc6e23c182b9361024c7b3fc9634d65.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e30926719358181fe12ef6eb6198a96a00ab2f96.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a896075e0a6b618e69379148dfee12fc83d6f60.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16eec6f210eda701fdb467090be6fb9c247e06ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9349b4cdd06f206f6878fba65c49e1fe9100097a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c30cc8d6e46e4a2ba6d9a700ffa1a1bcae265afa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77c0391253fa53232d6729f73a1e4353ed5516b4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/001aab146c12470f0c9a8374d67dcff1ee30cc4b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b3beb8fbb79f0abe0cd65dee1c348d30e69187d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/560d6031a40071948b0419270d469005428b0300.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-E",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/history/aqa/1-E/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a5e8e41a3275bb6c04629eefba1f3fa595f46c0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91b94c9d5570ecfa4a6805681f4570f8e4e21f70.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-E/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c7c41fe8c8831bd9c431034e0c77064d8b3cb66.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cab572f5edd47c563021dbe53f9597da83aaffc1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-E/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/134f4f9e3e6ad51a5a1e886b5f0a32ee97b41624.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da84285879e3d687b233b70d215ba7e3a1f13fbe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/history/aqa/1-E/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb449d01e8b2a3e9df754d8bdefece06c706db90.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dbbe1189d67b2096eb6a0bf3e0cecb1bf6292cf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c04c8962611a4314a8e0c0054db93ad7aeb8bef2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e620ffaf7c6eab46695a142aa285717a545e7149.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/business/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/business/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c060871afbfe7e2c84b31b5d2cc1ad074a75e1ba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d62408270e78ec1b9c266c4d9fc76541dbd35af1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b65772346f39e07d7cd29d580c4fc3a6c686e1c1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/431847e91f974fd21eefce2d9a11ae1b363308bc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65a2c83705561aa9fb6bbbd92aeb97a10ce3f61f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1d4ea26b2ad3e6e431f24bb21590d72b29ccd8a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bda6b03caf67fbf387d1bca2158f6acf6fdff8c2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a037acc2cbf2fc76c068d889f7ed87d1962ab92d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f30fe59b1fd751af72cbe71d9bc7c0b2519ebee4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe324f54ad09acb47ac696bf4f0a4575b0507e78.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80b3aa8884e50af3402325155af9bf32854a5fc8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/business/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aca3807b41c458a5dfca4239a390d5a6d8a70e62.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd49f07d6484f0e7214d7aef2df572ea91994e33.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7500d3d0c7635e8ae6b20d7aa65b24f36854ff8b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe139caee5b85a0887ff612078abbbabd39caf41.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c01bd02eba2368d6c7fef33aadefb55c4bb746fc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f948cbfb5976da7acffe359639e8951603a8d28c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9b0189a8a91a9f390b9e7be20e8833d34f276e4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5370bec62e2cf3e681611d43e4ad5fdd8c86ac5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3cb66bd479e673cdf46a2b220e915999c376a21a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7828439b97b8ba8bf06a3482660a28182770f4ba.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e748c4fca5b583b78b4eb49df39e92b065bfc0b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b7fb1ed2deb752b600a57f8a52043fa0600b65c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/business/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cdcc27b8b73c2b78188f66bda0ba84c31e2141f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d528bd281b2f952ee3d0edc364f54b1756fb320f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a33c9e5b2d2670168eeb110c7040f7601c8937fd.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/spanish/aqa",
            pprtypes: [
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f36133c4f4b30bf1e836aa78b7f0a8bf1ffda0ba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee0b6a5e80a29aeb5639f17b1a5f0e8801bd6243.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebcd85184c18033946bec4c8870e0efee464fd50.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fa161eea47a9ce15822ef1ffd9223038378b03f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df62ffcf300b1c4f6c22ecc448652126c5cc5147.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d0b186b16c08895545d61d23977af9bfc3fc8e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1008d102c3d065353225c2cfba65e0c45df4896.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d63152f7125276b9cee36e4c623a110f7109907.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2cd7339c141644becdb66fb789f7b622d15eb86d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/298b0151a12c88d325b6177440b883e6580f4e1a.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3329c81e41a47a0dac58753b27abf41376bfe5bf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/408fcb3c19fda32f2fd6c32a7f60b417ec8b3415.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d264717c78ee07746eea9d0e7dcbbaff84061318.mp3",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb3d8bd71b7c5e29026ed3aa8e65e3a14ecf6955.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c5ec8c146fe31542b3e65d1982d6f11d134a595.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddd863c4600363c6dc09b92e8eb0ba98ba554279.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ded6ca029bf6523bc14751516cee8d238a059f10.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9887f1bfdfb3e8560c454945df4827395ab9897e.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3526f287a1554699dc21c38b9824b7f4bc2c1b8f.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4a642ed1c1a2428e6b68a9fadd0f84809c082f0.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8bf25151e2a8bf13518b3adbb8f1836500b066b6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef19836158e7e0c5991f4a26f9135fa4171670a0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5854a78651c8069ace2ff18ef36efa1284c0c07d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/056d1c1cbe41a97b0693360e9630855d25e089a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8275927b106f0f399a028360361f39c69ed813e8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c01fa8454f15d69474371e5fa0fa4213192440be.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6476529603f39de2d1343f66bec378068790d03.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf298329f8800fcf34c97af53018cef4b5b200a5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/312e3b745defb529a6b9fe2bee6aaaf7a0a9aac5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ae3248d70edf768894f09a549794fd0ee38b052.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ed1704264b06564d1be722e905e4f78128c45bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8f2e0406285bfd25cbeafa07494ec3a4834ccc1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e01f38238ecbcb8e3f773446e11bb5077397804.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85f80e6042c59ee2d15425db480695b4d4ef77a3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34c7feb6045d6e72f929b5129fe2bdb521d3cdee.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1abdb1c112c1597e4d3fe90f255a815f8f009c3a.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c421edf7031f57fe1b2be9c02e8c9a4f58568c83.mp3",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77441338ebbbea82998634b1ab2e7eb5bc2eb267.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5c82024185bcc3d3b90ca3f8d2f897910ff89f5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eebf9cde3c7b90faa75ba870a83baf83fae7b940.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92dc03cb05e5d5031b40b3f7219019e881243527.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5737cf0adec483dd550d93bfd500e0b971b312e6.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41bb956da74bb42c02facb85180e01bb4ac46cf2.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed0120ee749248feb11c76473665b64f9d003804.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e0ef7838a503fd164f6042bd1b72ed42ee8d16b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a7c00703666d157c7db7d28088f09640e0ff2648.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f27038b2cf6ad858be063d5755ecc913721f47f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18e50ac5eed12b1aa1800a190e726d9f1086b0b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74b769003c37998567b2d41009a25175bd858a2b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d1507eb56a8bf6117e92d3f80b2d7d8908c4cb4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/037ecd7489f5ec70fa43ebf000b4dc1a602afacb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ac67e7c51fecfc6d190f426e22ead259bc8364d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d1d8c92e3a3cdbdf52a6044eeb61affa56fceaf.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c06a1b3f2115ea7670be38e135ac9c9119740b4f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f73e261b418ed4b75b391be4d0600f07587e0de2.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33c697f91d268d21fd1b5f70473208ecd08a7424.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5917062a2936905df6f8a1955595af79cb1c753.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26dd775d50501bdbcb5ab2f31a5aaf67be3de257.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f1b6315159445dbf83f5bedd9785a58eabed008.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5df04a6b523e7a95b48fc1347a30094f6527b190.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b836d2f0f0ce43d18f50f2b8c3105d245b09eb2f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/731f6b861ca566181464483bd53a46751d60ac01.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6db7676903551b43b3e4b6e5f7a2b6e491cf143c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7208c2b88c23fe6482731de42aff457e1edfc8e1.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1438be80a649cf702bbb3a491bf32344dfbcf76c.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ec98623c0cf2af085f4fb85f61a59c5ea2ddc25.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4225a856816b1b2528d9f52af43f1f14a61551c6.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7187e8ed7ceb325d2860c87e861f86d2971bbf1f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3f9d1a75d11475c8dd8ffb52d6d7aac499355ef.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe3cb3268797fbe5bb829258343edf1ac708663c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d7e21b589522e254851e70ac75232ff14fc29e2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c2915cae1118f792d2b340a3c9cae6dd887c096.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f07849cacd6afe617001193be9545e211bddeb38.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/337eca8f261832b4ebb250986dac961a7b862c00.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "SF; 8692-SH",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/SF; 8692-SH/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0709cc9eef440ea6cb598e912d7ff3f6a7f086a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b7330367c979abcec56ecc6627bd9df7d137081.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22b577ef4adf149e3974818afe037b9bdbc021d8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31196ca133dae85a0c00e8d9ec1a34e6e88f6210.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7ee0b0d115b172f0595172411ad41f6a580564a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd0f54b45c92153855237895606926d14fad41cf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec1c0dc7b6f728529b7fc7e57e0e8ac8f614e6ff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f6dd3cbd8dcc0c93557c56a199b17efa3281bb3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f5c1c9ed2794fd8e02afca30c507f8edf85939c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cbc6297a1654cefdbad0b05e71e26b360581f9a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7cdf5d4c8516be952d7a9b7d79508f6e08b8364f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05e89d7f1d1b58a02d2f50b19ac48ca0d23ecdca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/752e68159330621cee557a508e5976e4f5854999.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3687ee3f23ae1ad9787827d0a2c768474a11ea46.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b40cc5a32da3f70837d11e72d19c10ad3bd094d3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88c506f09df9017f6b032e497454b35691d64fd0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd5c8de06069a4f8394b88df509f0ff9a8c98099.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b352c5cd3104b368b6b21cf71c80e97a06de6b24.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b735a4e4833c242e030cb16ddcad9671b4dcb45.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49d57659cb30bc67574625c36254385b7eed272f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a42d7dc00e4e4f67a679e60da6fee9fe9c5ae02.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52fc7a82bbfd7c22d82aafeb4a8c96f54a5b220b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/spanish/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddb3a71e4b343eae4eb8c852f44d9198dc0a6e0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89155c1c7646c78485ba745a77b4053964a65701.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7044c881594ca1bdf315cd1a3898973a0c88d297.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27ff4d434a4188eafbde15cb3d4b12bbde3f5f91.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a105607c34f21a3ca1122446e5c97305a09b539.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87568080f0a392e121df6d57389052047d24f376.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/329be7e7f502561715a2361ce85dbad49bf090f5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/845f677615bc72c6cf0b4fe3494a7db50b329c4e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8e54e8328f0d8049bdb2f7a20a45a5b849ff478.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87cc35acf1258b9a222ad2172ea0e8b37833e6d8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f781d22895b667d91b15e401c1f686989c014ee9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2df01c5d595b748b4399f7ef964dfdad33606b5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dffc59b58bdd4717dca7bd85f359f139c20234d1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d14f34b35c7827f4fda9b8225dab4a3057007164.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5d8a4da405208498899691aeb0f6136b0cdf8f3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b29b6ae84369a9dfe6afc0fb9c50ef8a29887f3b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/461d365a14fd1156dc56a52f3e6426989030c194.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9831e8922edc7fa623164f960837c1e945d19b4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e45ee189988d1ea5875f16d06c356f0ea80a75ea.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96d7be2d8ea3ae85b34554612477beb79f94b755.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68882513278e06eef5b9cf63afc12133dfbc41de.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5fb05f2f213cce4daca1770da3fcf0f9f3be6a7b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad998fe62228c1101887b5fab22c3d01af76e53c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79578510f9242165f95d0700f0696e5a39bd1b1d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5c57fdafd8f79186c2fb91bda104e04642b2c72.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be6692f3a1e4678677006dda904ee71dedc310fe.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/840d972674bee99415c1274fbb3022dccf255770.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45ca0e58675401b94ef01f1ea861ec042f89e041.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/764d7b2075324fcb81d350ac40a037ad11c77300.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b553bad0a09689f5c84d2cd40b6dc3dd743bf3a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6acff348f1662cd837e37ee8c725fc909f96d3b2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a011fc7b8a6ede844295efda540acdf5882ad252.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51f5067186052d50827eeb8ac7bc87cb976f7473.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2868931ab9bead06344906584ea6fb409e90315f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfc3f2c10e0fcc48e09bde456eea5e1dfa7fe5d3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3916695b94d46cbdd749c8ad4e86a51fbdeb20a8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c663b8ec35b3708138401b5f7ff2c39accdef55d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c56e839edf7561171fef0998f9eaa724da0eddfd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/560906cc84f4d7d2b5294ecc7a1ab425090caccb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d98f496694ae98f48757df4eff332eea5df6b07d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/spanish/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8b42b3dfed24d741a591c0298eea64ba0035e3b.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/panjabi/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4358a9952a775c5abfa3dc782d65c66654f434a4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f283cda9c4632138985cbebce20d7dac4e8a7d7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f6e765b02802a43bd35fd8c288dc6d08a05b3e16.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0962ad927c403226bfb0220630c8e080f74724c0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e9f1f58996bad74ffd6cc6d43df209389852be3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2c65d1f7fffe58bdc7a310b45a5250246d66cea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/934c7c0ad8bdaecfaf5db972d0a09b31de9b661a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2033ae5251cd40e51081b0d868a247d1fb9fe493.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce671113047c025c775d5555b009e9dac50da14e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7085316b876d1ff8a3e493c3fa027a833965ffd.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4152ac10e61c74b9716ba9c1d284cba9f8e02766.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c230c9e57459ad691e548ca22deb1e5fb9d14a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0191fa52fbbe4e64e26e7d5329ae3ee4ca51a6f.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59eb79aff79c373d81062daa181955748873340d.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55f3c24bc0c1c52c989c6a49e5c1fefca1e243dc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1ac36cd7817cbee6ac3052ada7f0b3a4dd695c4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aee1f10bc417fd8fba9cb353d8677d26ccb7ea21.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f712791cba3fa4bad6e662d971cf5a69e74411f0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/227014ce90b29b4238d25199a7d8613c0c2dffc8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7a5455064aeccaf60b6c231d9eff601ba877dd7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64fc1bbe2455fa6079555de48c7335304b027ed5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42256018ebace444ea57e405184aa0d78e602b8c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60c8b694a11035a704023d6ff65edd01aa60b19d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/388340233ab5d4396f247acfafa0e69a7050cafe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a77fb6e35355e1491c59cd97baf249299eabf66.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36eac6e608d88cd2ddf603ece3e3c5262b79d8e8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f2b890f31a33359eac0b086775df568012e0e96.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1163ba3407f52ce4c4427a4a71847ed8afc365d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c1d240fa3ec477b52c19f22f586b7187ccf3307.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5235e33207bca34086dc57559c2c7f60d66e9a89.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d98e25b31aa60982565746e989bdd376e3fbe27.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/722ab3ceb1f3d34d6b98bc1ec8481b1abd6a5239.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3cf8ef1ae768456de3abc2095fbb93628b00a702.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b97e58bf7fdf62bed36fbbe6117695b2f5aad81f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d0e70e0a49c36fa03d2f69aaed41cc50451308e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b510676f4abc33edead94235f90355e9bd34bfe5.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6df84461974fffe6a883c920c6d1313700709b0d.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71b04f454809b011e5f628c0a6afdee904668ad5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f770bdd775417148a6b4f2f817ef8ffccaf4eab8.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b22932a597d69b4d1d618fb5b5361646176e43c7.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a30638e08b16629fd1fb1f0a9cbf2c5b0841c06.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe109a3fc9825c4676be350c48aa33ebb4732b82.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10b3ecd3f3be17c14d339e6ae8a7c76e572ac72a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85438ac2ca4fbb0147d7ac56b6f858b6c599a4a3.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07b73f3bf815e868b8b1e78dcdc0e0694a07de2c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6777697d67b753ba2505315108a18869861b6bac.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddc0ba3355e00646cd2d4358edde01e6d2b3eaf5.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b747a3224f82fc467ae6d6fe245fa4eccd982fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1d98b8e6b76ee7b90e3a28bdbdcdc10bfb0dfb1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be4b996eb21b2e296c56753bb27565ff5d04ac4e.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a31faa4f7c1363a7991aa73bd3bada8168a25c6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87898cd0bab549728e3b6f56f200732d9fafdd88.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed9fa9eba49092785efd83b29acad9ee0dc9b605.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55c5cb24a69821c9c9689f7b2f3e68a3b9d1ca95.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e7a25affaeec6a6d36733ecdf1221f3d4fce4d2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f176b949ded8e1de46c20fa29ba17435fd15056c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23311ed2192568614cc40086397d1b3aba9d2b17.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e37bbf9ea8d1aab0d183cd24086dfd99dfbd2312.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1909e55624aa2791f02fa3ed7b3b59094eec3b12.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a32b0d9f39c09b4bd23f75c5b6fc36c2e0c92dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0062c84be52f415d53c7a79581639d3d6cf7906.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39613daf1b1cea6030681c5ec4041bedad6a9de4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62d1494572ff9742db47f90301efd5b3efa26dde.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4711ae9faa897afd2f4459f2c403cb6e5a9ff987.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c9bf11cd08e8883805e24c250b642dc0a4a11dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4bac34999f140e367717734128b5a9f56ea7665.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a297dfd545b8d8e44926fa381cd5929a45efc51a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/817299c1c14128654cfaddf3467024080c0509bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4da0e8682fee62ea6bcec18cb28f83dde65111b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6538eea5e4952fd4d014913901122e014982979b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2520fc90e258b53c7f78bd27b64c3f9391c91bf8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b0ab7eb5aef4eeac5e416953a7ad6486323fab5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2e5a839156ab0595df402429eddb7597bdf734d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd640913635d1ca736c290513d242654795188b7.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dee83782e5c2bbf9f01bbea81d43c0d531c782d8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c861e18e0a29544ffddae0600c0c3a33a6bde08.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a9d075c8cc477f86a11e666ea6d3e7d72ba1480.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/188bf8b6e21df3edda92f220ab904c4cc3d59a0a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26cf9e65b69ab3da7e115f5402ac24503fe033f8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/panjabi/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd7cc7dcb36c10d39a201317713631c4e8787e35.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/panjabi/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f111907e0713593e48140de53fa216a20438bdca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/121b276db4e6bb7a557ff537b8c44ba9108fe698.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/panjabi/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/panjabi/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd0277b2e6fbd3f4ec8aae2d145833848fe0c97d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38e5b549974342592c8f0056f10ea76b102e9998.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e75429becbc8d3fa1ec65ce43d22a86e1152cd63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acef285ea274b8adf140be35a26629d3bba00b67.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38a728cd7a0727b037a9f170c3d904cd4f35c505.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a88733b359af07a25a173515532e30e177d0b4f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c83b0036ae70d3ea55cdeb538472ec82d8cd72d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/134ee1339503854ecfa3371eef2989eecc8072ec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/645ca57faee40ae305718ae7d71ac2e8ecad1c9b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/522dadc1a32d73239ec9e7206af4e84570ed12aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68d13d6b8da6d611cf7c0409b0c651d7c6b1f5cc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/panjabi/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aed37ea13b47115931d7316c77dacde6aba0a75d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4abe0abaf45c1c0670f306d01a214630e03e11b6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1521d56edeb938f9e601c569d051ac0f814857c5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9494e4d80a3ad77da587eba539329fe669f10063.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02602d25e275dad615ec0d5035ffd21484130918.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60bbc8d32ffd2ae9707a712f7cdd9a25a2162bf6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/602a54a76f3d5af481727d65ef5533fa5f1746b4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a267dde2d35cceb4fc5e9b3628de8a39356da006.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c4d6e952df5bcbf311d2029e5643ea1c1636005.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/699c96da4e6382678619a0920f5d712324528a66.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/panjabi/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0c2c3e6087922af88f0fdb40e286476c9102dc1.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65355b1e1a3415b258ef895e808a281efc3978fa.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc1d4aa9e93d296b0560ffd16ed876e36a5c190c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59e2d5cd6f4dcef0a66334c465eb790c39f1a002.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17607940dd1fea89f06878b34a5771889eaa5660.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68f89e6814ac9c837339cef11e2648d91b228903.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8256e9939d6e6837e22270b8c67aff1463330cf4.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1961253e2bdba94b3200d14209043abb6cf88f49.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bacb5c1a791f830ed771d5c0663a6a77d6c3c88.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7731298e10b183800521225b1c1107ae6f5776e5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc0833f896e87ed74aa237de9208627de185cb47.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09a71b331d8df8b0b195397c8e55cc81878c3066.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6eb61e37fa24542b58bab1045104a72705a5cf79.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b88238bd91b7a9ac57350f5a8b7fb1127fa2da0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd43ae7d2ec998bae3b7175f3c3c8064d49b8d4a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9268a6bdc70c90706332b93f153b1e94932d874.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/panjabi/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7a0f402a0b07a74ad5de0cc551634217d58f456.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db806d78a2ef2e087d97de2e0343d251e7d03f3e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23061413ef1a17bd47b14b9e2a8624891edace01.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8bf3e155419869277c3e8b40e187ac5e50475851.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/geography/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/geography/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d797dfe2d465de401e20f4caed8c88698e576ab2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ea8cae0150257bcbfbc3166306419a6a35d3024.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14a44ba73c7dddc1c6a9d2469d0d38feb465188d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a551380e7fa9109a7823fe53894f438e5b678c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f6f896b3e43d5a8bf835f238a6481a9dce885171.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12cd4ffa1e8ca7a9409bf028d6e8ed094157cbd5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a87ed66ecb79446d458f4a83747c08c684cba15.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c203a83fe20fb43e46e4db5a30093b962d6086fd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e543e8efec3e844e5ed4366fc7c87ddfa1b3ac81.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29c88eb80d1ff02c1964d3aff35de8517e548c72.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2b038f860db2217ab7098aeb0424066358837ab.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99a78f9a6204decd40e0a7e1c25862a2739ad003.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0c22c1cf71b404c31b69db039bf19f322c3b548.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55c0f29b070d9a6697a2274b73748158f1557c84.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/geography/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c9879856f5a21faf817fad9d1df0d911d3f8704.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cb74fc625dbbe07ab4bf444d3af36c491c03b5b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96b4cbc7f8e3a2b77e208a8c2d2dc654e96a5eed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2152271efdc7b6c6bb95938f1e64f9c8deefd8ec.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d23bdde5199f4899c8da259cd356a40f76d9a568.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6ddeec0cec4ef5942fedefc6424071d8bc3c7fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a93152ed829b43d7b2af2e131f56785733d06238.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70be71e3217a2d6c125866d774a43151a91af9aa.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55ef7343106092c99419036ff597267b23cda08e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10581529bb55376caadcd34a1f3de7415ba7c00d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcc2e71a83e39e099fd79d385c2cbb77f30464ff.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fc0fa1a54e71ab75d799ef2138d27ff45e2c0ea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/geography/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0fa7f22c63c9b98413e28e6ae7fd94bab74c915b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b4397e3d75d05956dbd3da0f6324e291cbfbb62.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/rs/aqa-b",
            pprtypes: [
              {
                pprtype: "2-Y",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-Y/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0800aefd11fc9387b0c3b526543a26fb89d9218d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcb8b42f3178d9b63622811bb5990f5fadab2005.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-Y/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb43a9ac0227939e0dd917e8b290b83bf9985e10.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e618ed7ecb4dd5a22a4cfc9baf9d76d1c332f3f9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-Y/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05b20c859340e5ee169eabc3933cc5472831a2ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b790ae95b73c82272e859438c035f35509e1cb8c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-Y/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60dad95c63669f56287368dcddd4d9f6e7f2034f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/211c18b30231ff76c48e786ddde2025e13934eed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-Y/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46051ca15ba0589557a3f02a4b4b8cd21309222a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/295065096b85f3aa13234733dadeaa88c56375b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f45d3b25edd09be6311cd0a140f4dcb84d7dce0d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c75b83437e45b8c3446985b6fb0af962bc7e8f3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-X",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-X/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0893404044135d7c9c449f084aac9420597c72a9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9b7c38133c0e0bb028cce7cc3691729516fc569.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-X/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d84e2efd3dfc43bd05542664bd40721952003e8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71a096c7519f473ce7703f1b365ddac89aa69f9e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-X/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4897b0d1e00379951afdc928a86e86394374fe89.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d85853816cc5029e28d166fac9a66728f694cc21.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-X/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/120512857bf9a7412e2055be6042b49a7d076647.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b4720392f312d4da3be5e6732ec2463cc3f2f30.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efaa52194b1f99d380285a19480adc51b832d7ce.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb33a6cbe230fd1e8901b7aed6e2808a248bacd0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-b/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bba5fec0eb1c4260575d0b6b4976e7fb0b47970.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf1c9fdb1814424fd06cc720acdfec772ed207c6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14f682f63b13ddc8d507601a1731a4a1e0aa8e4c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e9373b7abf8a2b2b051b4e76fd0131ff1cef5c1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c6e92b419504ac22fdd9685107a059fa855f145.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/606cbb5e225230850f41bad8c4b6fbeced05f0c5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/294fecbab5a90fc44860e16b59e392167a95aaf3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e2032c5d4f6427d919d2cb035314d0007a0f226.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71aca8d77e9ee935bf7c139273622cef5f2f0e8d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55cda260024bb609e9407fe300b4e775effbafcc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0b15215f3115203621f133e5c367eafc2c34bea.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eefef0e9a80a15cb193865f38570277d28fc79f0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4b3772bcf32b0fee3d8a4258dbfbe49bf4b146b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65ee314d4cc4f1ca49e0583a32bfe6c310cf24ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ade1e343cb05db001ee60db8d3fed9af28ef9af.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/973989170d5af356e795c8fb96b73cc1f3a8f7a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc9de48f9ad1f37bb99aa6109cc0cbd0315fcfd6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bade5eda240e31662a267e041e4ec8690d24488.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60a15de37a45160d56ec630afcf52c681ccc7447.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a9949a39f3b5c59c7c2fa176e9323442ab6660b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15451af032efac53db784df1488d633928e577f3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da97f646d0312ae9a97d1b36066cc8f3a43398aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cc47f377cd9721d3cb159b05e2778dee6b18b4e0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2634394fbf7af27d380ab249eac4676f15104473.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fc7436969a1a6db5e3b58de261991e26db78b0d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df2d855f01f0717aa7fae926c3b8227c67e6d2e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2389dac713dd6a7d4950072bdf7309f7eab27f49.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f17834ea04e22ac08096fc0451602f5d9785ac1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c8c53d0e68f382f35f830b697ede9cafc6e5059.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e8e3889373d95e844a567d940ce2b2ffde90f52.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/rs/aqa-b/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/395a8a56897c20cefd72317186f7d3571a4e7c89.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/712d29d97ee62d78b23cab8a032de79b2ee4b992.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf0b7ce69340f72fdd4f2e952947f86dde4db3ca.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56baa0cc68a165ec9a9676b2c7d1f2a590360f92.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/psychology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/psychology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1ed46970fa462b3bb09711b04fec0a3413ca87d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17a209c3930c0681f2862da435fa9631a2f17073.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/714c3d69a154f988c3c4966be19a06d27c78c2f9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72332f5e061fe0ce748fd3bd61870960b121eac4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cca292f561cee62faeba78f9e5dbb519473d917.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fee0bba4a508de488f7c1f36d1ff4f6f0f77daf5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a48aa65452044c985f04645442c7ebc337d92bc2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae8c995a7b427a395ab116cc62f1ff4c39243244.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16d67f532cc67a516b87beea218190be24e7c10c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c391bf46ec450ef2001e63ace27e116d72d4e832.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/psychology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a90fb0eb5eacbaa4c244ee8a1bb1a1efc5359dad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c62af6c90407cc131b2b2a70bfa87f1df360c9b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/01b32cffc31b7734610cfb5577d611570880c11c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fe807a7c4eea727bedb3f36d6be2f75fa86de8e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e995494187e8d0ee29c0d738b905a89b100a766b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44bc094ff60a316ce2b0970388fb99d1519025d2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a0caff40d3381a44019efbdd3395b7e590d4258.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07dbc8d0e07e6c267379cdda84e59f4f1a33d0e4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/psychology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32f2c422d2f2a66fa3f6518798aa64de9a701636.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a49f99aecf076bd6f6586d3ddf017716b8da922e.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/functional-skills/maths/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d81e8de0dd58b564cb84ab441849811b9f5af4b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7ed08eb29552f3a0fe24200d218f4f5b5c92ce5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66bbf22caa077ab77eae3131e60783af0130345e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e95fd0514704456204db8828f50cb85ad26a8ac0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f1a1a272d95665985c264bf2e42cfc8d24a7750.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c0ce1089558a75076bfe6a75f956acbbe983524.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa90c6f9f5dd9ee0a58319fd32d4bd901b6ea067.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d59920730290cf60e98eea9f4c7cba0870fc482b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/24-mar/",
                    yr: "2024",
                    month: "March",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca505e17747207a0917032443d900463059089c6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd1534569daa292a4d9ff06b0c99ea9fbf4cff0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b05131f709430ed37d8ee7985113d4f9f48badd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8195ae3fa34b3791b52d3e9ea2fe30d47cb8f525.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50b62a6f37a7d84beb03cd5709b6e20c733a2c1c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88862b1d75598c70455c884e0eabc8e12d60b18b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9da5c88ad88ec21c92103a957462f83dd697f9fc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4879c8fa497ca11340f9eef2ad99eb939332b110.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/23-mar/",
                    yr: "2023",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b679a91d43ea5901a2efda646773b857c8dbc1e6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/576f70f0315fa0ab9bbefcf94fe4fd08cd0dcb3b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e4fed0803bb7072a82f6325a11f275ebcbd951a2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a8dc059a8055e03d99e2ca3d276eb21f0519da5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5ef920d3d8262250feb26f1840e9b2f41434940.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfae1b317e41ecda38cf6e160dd66b37d86f444f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5666d0ad1be24a5098debbaa1f8fcbf5f27ebd5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d94d0376920adc6ec7844fe184adda792c2d69b7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf2daefa7092a73d9135b209a24a2b5b5e1bd5a5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c790bfa49069a19f50954847a5d3270f8e92ecf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94feeaaeb97ae783a78149e1f50a667d4cefa719.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e02fd022f136c3bc7ff237c5261e89f9ab3ab235.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e664abde20bc0962a472bae49767d9dc1f6ff43e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8becf5136492786ee42132ff9e33564e42a2dc84.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f975c90ae1e8e417c7132ae1942ee71ccd8b09c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f11ec8e089d4b0d89afe3079442b55be186ed1e2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31205ea6b9a54c4a5a9b3e5d95b511b677268203.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3387f3d56f393ad1d05b689780db4ae0bfb2db41.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ce14cd5bb9def4a8a7c72bfea65d156592ed2aa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/62e7baa2412bdb23eeeea2795dba3efa9e7d0b02.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/22-mar/",
                    yr: "2022",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c60007a66289d0fc1462490c5b2d239e3094218.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a08dac4b0d39ced006780f914a4b02bac00f6a19.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b676a2b64f30947f6e6f8805b687ddcddf7c3d65.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96db9643b4b51c049ca7c9711f11b23575f364c2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf85859e7ad580ef883f15e0527a8c20f2f6594d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3ea220f2c9af8fa65114c9bcc364d43fd9ce1bd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ef28e215219574c40000309ce6eafd1acabd4f1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc24835510ce851b919c0b8627bb24adfe5edc36.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cefad0ec7e094ef2b35d7c6ea15ce64118047f63.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f6d6dd671c30de6a54377a78559dca788f73777.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8add28f9becc0ad5bf43d9668a9fc5187e8d8d91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82ced0158e6dbc336d3cd4ab90b0310703b8aae8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/20-mar/",
                    yr: "2020",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a37fee6e234ff1bd1fab796207699a72ccf6be63.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a132da212f8e69910f56bad48cddafa382f0279.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efdfeda6bc01717d261d55cd6658f2dc1dcc7ac6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5f31ad27c51100db526ac8552021c684a2e7676.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/871a920fceb783171cf43e1d1370f6bb6eba6a29.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6dbd57350fe9d272d3bf1f02e43a0e7b0d161bf1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e43e4ddc5ff4fe51b97cecc95a5047517d4c0e27.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e9876a9538632bfbbafe34e55f013664731310c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e2f92e2d5821624cbed49accfd675c9ef6abcc4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/baae9385523a4c2b9d400d4561590db97ddd531a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/482681c7d2365593a9366f0c31226ff82c835c11.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7860b3b3087f71d6042825c844268396ff29530c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/850e09b6fefef233ebad600f3bfe6e5ec40077b1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaab09a2a0b48c5c3d5c86ad3149aaa2d11db931.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/24-mar/",
                    yr: "2024",
                    month: "March",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebea29e3ba58c496c2f5524839420b4b5c6f467a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/233d2f8701a534b6a287686e615c951e4938b8d4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7251feceb3a776aa5a41f756d9070dd561d8b175.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/985451ab0ddf5eed41c096a9a4508f2903354358.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/23-nov/",
                    yr: "2023",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fed8bcabaeb2010648ddcfd242da40160c94630c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3cbf21004025396fb5bb72807075847acba679e8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba6cdcf091689b8e022177838a8a9b4221058cf2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc2ea380dca5f3a652bccdb1d95a089b2d97bbd3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6aba6272817a0f80a099e6d843d22dfeb973d865.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/23-mar/",
                    yr: "2023",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/594eeb05526b3c7a59e3f0f8db735f82204d885a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22de8ee7eaed712a97cbb76fb74b40f64a89fcfd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93b39d5fcc8887aeb5d246a4d7d8d00f37e82945.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/360b12120dcb6ad4b5ec5bd9a60335352967ab09.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8da20349337b95b1b54fd5d00e7e7ac99ae85d70.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38f3cc04c4fee11a584e47580d9e3ac78dd19d7e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2abb42505b7a154bbcc5b8b216e9ca7c71e56660.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd6caa15e2b0d09e471ca07bf53f280c105ad46b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e91dae6ecb4013ab9923742be733ac98837f6961.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c21fc2f66f8ba06e0eb9a5fd76e2796596aba069.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3535e877ea9c7a5cfaab3924ce5ef48f9e437134.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/481365bacc77d763f02573504cad32a18824a38f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b132bf562d5bbe57ba8563ec786c90ccfbfbfb25.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/923f3580b3f359dfaf34a751f81a768a6e2703d2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1a8b941debb0e73dda8573f4711369c0c95af9c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e09b52a44c97c22a38fcdb13cdf3657d82dd95f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0cf5ea68ea94a9551d6af1af05c262ea739e767.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de4d0c87f28d97d0d36c9f9b9ffdf8440bb82f82.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f11b704eb268a97db85bb5618a4fb00d1ed76563.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/310c5ae00423a5bbe1ca3adc2a6e967411c723aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/22-mar/",
                    yr: "2022",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a9c94196fb76805bfd36b8814cda109537cb0b8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2411ed890e0df02e688faead16587c007845b7f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45b8358a56d14f75403ba7bc55592cc16106a97e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab7e8ceb71fd68831d730c8a730902fb39bd759d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9bc61ce2455705e1568ada9a4403ae07051f5b45.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2059c73e8415d0790dbeedb3a83a9a37d6763d4c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/952223db8cc461037d5f071925e1d6143dc76083.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57217dcdf3141f28539caa9073f025087816ab56.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/20-mar/",
                    yr: "2020",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bba0c59872186c106c0c0b2e599464fabc79dabc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0231b528fc5a0005a04afdb8057845209068df2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0558b3dede5e7718bcb91c2a347b8f4b1f1accc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c93b5298bb91ba2eaa8f35a5e07ee2b56ec2803.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e23ab088b963b1125841b9deca9f219d27421aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46f818a1460923635cb9050c8e54d5ac98058e37.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d4d0df99a6ea6c3e3b5b9306d06dc12c209e79b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f89c12dde485ff148e44667bef393d1b8fc0cfe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/maths/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6804592ef1f6a29855ca1fd3d5c6b96117acd5f5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a7b4fd1dd92e56dad9c2708907bafe919296576.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a7fbd0993da563686c6ca2c8e2d25eee8a4cdec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99714cdd68605515f499125ae9dc7bae147cc7f2.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/sociology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/sociology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e3fb90db382f5b0e1b110894f10301a5be5ea31.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab307b0eeb753eb01553c47fb29a02549a81c5ba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/sociology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e627db40e40e9212243f9cd057ebae66ed5712b5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e49000fce916aad200b93e2d871a481a33649c3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/sociology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7a4c9d816784b2309373fb45b08ecb10b59010d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cdbdd3c06581fe266303ef6cc2274b93823eadd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/sociology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58aeecfafb258f5fd8a4f976eea7b8c747b7305a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/895140dc9419145405c65905f707d16f6d727788.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/sociology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc50951ac7761902a6cffa8fbb99b7fa1e247822.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9c1c723a7a76333d4384385607d430c24b7c261.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/sociology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6496363273c18192a005c3a2bef39af91e2ceaff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dae2150bf4c621435c1bbcc0929997a9473c9f2f.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/psychology/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/psychology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/442eff6120aaea3f216b59d2b6dda1001f8a6034.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f3d64ec13972d589b6a10c89e8049b7dfd98fb8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/195fe5d932bdb91b313047c8265569b6832dc98f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f96a00869271e13eccca9c8446a7db336d69d26d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/992b99a6e47c1f55f519b383521a7a2a23668b55.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ae736d1c3f6525f68762a68e21734d55cdbd1ae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f74f9d5543bc1cd50283aa9d6c164bcea98e8a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcea731785a84c2ac208f971b47013056b5cff66.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28f882657087ada325fb7024774a14d38e7d05a8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea9f2e6d521de4644a33337c34fd8604b777f44c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a0057f41a553e8283ebdcb221345ff2c7f7a100.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c335e564e4fa6e7e0e7cd0e6347c9b75cab181b3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/psychology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54f7ace9ab80a27fa58f1660dd2bad3e2311d594.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/852a6ec838d30d3997a43030fc0be6ff1ee36563.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cefc77fdffbd4dfefcb5a8087ca6852ea04ab245.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a652505dc6a1d776b261265e278a2a13137d3d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7117c5b0f6213824454a223aec91777f02f254fe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5fcb1ab8ea911d9bc20fdadd14f0f25b149577c4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fb1c57ea297f9e33fa70ae1c44a478089917ed6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6bb214abe8b08a35634c3d9484ca83c80da61f39.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f04c29e93336cbdfc108c311800f6f6e6e0eacb2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c73e71b1848b32bf91e868f9f9ce978c577e1925.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c760f7823788cc86a96c6a65b318262d5b4b0352.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03cfbef88f33b4a836c787d419dec04f420c5b81.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/psychology/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb82ed1a654a7f152dbd000a22eb1e134d6ddf0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb1aafe34a3cd4045b6944d8941c44f594b2a954.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e62849f5a207e9f990bd55b19dd6da158b1c64ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4241d6ebb68416c2f232da968fe972c4d104b243.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9da8925a8f3e1136ef00168b5b7b264b569aca63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7a5b08a857e4c741abd0675ef269adaf572f43c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27866f391c1607b6644433bad72a7aaf63493d4e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af3de35b948a48f5282dcbbbb8d51c31d5f62f61.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/psychology/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f8a6d020b8273666d0c4c326f7f1621dd08d76d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f009724a8dc7fc8dbb8d07cb83549d1d6f04d1c1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf5fee353fa3a4cdc9af2aecf8990c98890649a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5be2be77db5efd4b163f5ddf95c20821eaa94bd.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/psychology/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/psychology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb16670ee98cefe632cf0608d7b1058438a4a345.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cb1ca75666e75b6c65bf95b69c69cf0e2c7e38f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/psychology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed400060706acaf0b10d3b160ae8b0c60f11c70a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51c6eb6e67d59219c8dc7c4a50ef7847af3fd620.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/psychology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2eaf7e713dc5a6b2a98053a30d751911a2e3f029.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2d698b672e1cfc2c9ea40575d8fd1dac306bec4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/psychology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03d5dc72c16a14b4cba2dabc19d56ff8a1550551.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02d2ea597cbe752eb1569a520172b82efedd34ee.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/psychology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7f61fdf91274500cff501aaee8731128dbc2519.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/159b6449427f3d9c48ad034b8191f17a0d66bd58.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/psychology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a32674461330693c3a3c06352dbb97842758968e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f37d7977caa4a85c6ecec0f11d720c61024eabd2.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/chemistry/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/chemistry/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5280f6be23e61dad19bfc37cdea71442d8bdd42b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2d8103f354acf460fdca09391c07bfe689feded.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/778af70e985a8dc62a22416ecb4b1c5ae255d76d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9137a32e751d93eeaf33807a82188b20a5f7cb46.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1a1b8be19b378b6521845756c4d9c1198a7d571.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6577b23857a8cfce9b39fe2655239daa96321faf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/418ebfce61689166422be982a14e6449b547f1cd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a71ac379c8ef0270e043d83a1175675dfa2606da.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/286c4b56f27bd6d92569b84c68eb3a6451a4f8df.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc828b0971a15b333c9d35f7916095505775a560.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/576282600c19995a9835638282914ee8064ac7bb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3aab682ad38009ea8709af8386a7fbaed9e735e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a9b88da4300aa5f4c6517d3fd9098df151aebcdc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a3e2e1e480e270473c0d86c195a4ba1f1a68ed8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cf5a335b59b2a5fe846b78ec439000a02de9707.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65ac7965b38ee9a75f93e4777761979de27f14dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fde996676c82743e5dd6f2b165528a2648b3bd36.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fec275a82b05e12017cada05005c3d05dbce79e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28472dff03cd0a626a31f96602cd8a35b3a8c7cd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3115533128db183c1142805faf5ad6ed2dccbce.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b52441560d78fc5e9a6c461072a96001f49d5195.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/1/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c59fb39b8d0cf7b05778d4cb1db80cc0d49b11a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75941ded6e17964043db5edc093fe76eb4c89bd1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b773b781ef4b7b6228095e9d77f7912138b13b32.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/chemistry/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9dd17162795d37ce30e7142a259e8b1a51fb566d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a1aee23bad121ef953807a88f70b9b52151609a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88cb60ac4953de2e5af913a6161f7b9c6a56a4e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54fa78626e203b11f7e9c7d2826bcc667ae1bfb0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cff8725f662ee43ac0e8f0acb5aaa391a0b91af1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f81dfb051dceec01831af7a6425e8fe4a645ec8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b2416e5f5b95b9098331a9b7ae31214abffa50d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/deda28c4c6e70bbba26e8c4133a6a1ee8612bd88.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d5160d05a4e2d61a09d1cb0e350cd44f9d4122a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1423f0a5f50723d91ee98959dbe71c98d1f6738a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1bd77bb625cfa332ee44cc80f6bd5eb403eb118.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d64d830893c000a539995762d21881f61f5fa2fe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/392015b7e39dff0bc7fe68ee2af63c996573b7a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf058d533fd90afec6dd037e706f2fb69d5568d6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/943ba1001cdb39dcbe0b1074f08e2f47a0cfb73e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/434a4a8ed47f888c88b8fed5545575ec9a09a02b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/255b3a56ae2c68a279d7e4baf38f98d50bc972f3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7aa8d651c69f83521846fd3dcb9d560f02cd4a05.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46bb3544276389c5713a9ffac2f980e9a287f78b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb9e25e99e51b1937dc89697a36b575b86f033e6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb1fc80b35a9ed38ba4dbe9fe8801fa6927d47ac.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/chemistry/aqa/2/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b109928b789328805ed6ecdc1e23aeb334b310c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ab5920f356eeaecf85e2bac6d21a5c2fe7aa706.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce86dc6d6bf2f07d7c1765e41e0601c3767eaab2.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/business/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/business/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3afa738a1a596bdd77e9d6b13f135c2b8f6bf64e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67a15d9a21b1f4066166a3f81cc53fbe46da85ab.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28684f31f1681db1a6d3379f6a5632b3d302bb46.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e15561bec52649239ef1113419dc1595049de82.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97685e308200236a9bc19605e8ab137b75a49036.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07c9a1c9d4dc542d6cc0bf466b0ef8edb8664abf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2db199b8417b908c6df04362372576ad3e48553.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/319aaee6f759e18be0c217e4f78cc4cd7971b8f6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad561d2dba966d0cffeb600830bf010770e16658.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ac31736fe32b4c4470c2be86c8264801ff04544.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1abaa4bbc932ef21d962d09494f93a8be6ebbe97.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3ac0dcc80d906c15fec8e88be991bc957b5c3a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e23f64b96aa39fba6950eb1d13678617eca163a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/business/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79a6becce4784ca8bec88bded27f9e4745ffb3c2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c8b5639de0cfe45686d8da52a8bac60a7d83da9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4fb3dd8c11c5654ed1bed384b0b2ad88fddd0a0b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/056e44016bf3ac5333bf6c019531f45319569d06.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aeca2cc165b944b04b083be6212781e8dfc20af6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7544c7a0d6a9ad7b59a4801520f7c47c61760fec.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ceec3220dfb20e5c8b737a512c584cbce3fa1500.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/260bf513fa96007dacf7beeaaa360395f098e19b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6262c419177ee2094e4231b2ff18865ee97f6870.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a4d3da9bca185b8bb2fcd1a286b47c81b8c8492.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2db1622727ab99c7645c77930bfa85947eb3ecb4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3674e5614d37bc4f08a2e83c6bb20ddcce766273.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9103c98980d04d3588a06b2c67e929eb37c183c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e61b95ac9ee4a2fc697d9ae108ba4f90aaa645e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aedba22590099918af5979ed3011865d59d3718d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6a06f5ca612a131a3a322e82533dcbcf344bcbd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/965a115320604661f041712179e0616dddf381ab.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/135cb4f2c84ac44b0bb0f5b162424f5e4c9855bf.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/business/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0535c7c4e23a7d7325667561874ad829662771a0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/48c7ee035151dc50509fe288b495944a2e540130.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dfa993ce9b65b52539a1bce79f3b82c35d2f8efc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a7fc188ad1ea658692799e758a019e8ad2fdb855.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e85ed657b01ecadb4214f9a41066fbc25d000b10.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1381b47e6788b165735752f957008529a53aa6ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2cb01fd402f7b1b627abb8d4a1130d8c593bb4b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d599db8dff34ec156e887972fdd3274eea1b2698.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9e563d7a7c4fe3ef557f36fb0d29235b44dcd3e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82a73e7d06c4b31d69d5e2ec39bbb4bdd24e3eb4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9565d66aad33232fcf23b754f64bf09e5c24ce8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/business/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8bb3f127a1fdf18816438fa7ab8888de380bc44.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10ceaa1e47bbd5b773b05dd32d044ddadf285435.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/chemistry/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65a20dd7befeb4fc5a07f1a2e609dab6c471f880.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d87e0710fe0a15deaad50558c4371addcf5090ad.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33d432e1f0bb01b79305d179423d3819a772f1cf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7811acee1967d39da0ff3d7694099b2daa3475b0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb4f41053cc30d3344fb63fa273240c653472edb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8a8d74271a84d9059c91bafae6aa26a95439aca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1b7fb6f3bfdaf90ea38f2e66b8093bcb5cc3b56.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46cb6d0859954862a94cc33688b7db45add4c52f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30ac311d30e88abd463f33197d20d6cef868208e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd3f27c361f9b6582217c056eeb8eea14e2ffdef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2af09d67b3c373e5b6081591c1ad1593a4ce4c6b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e08a9a7a7141f3aaa17fb91b127334a9b4ad1e70.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24ac747e2715cc5ca065f4e8148645ed08057d4e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f9e26a7256201b2e23daa90f46ec17a442928fe.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4214f74cc8f55cacdf82d2c3ab9bce0119c23cd6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aff128472e3304e2d292cdc4ffd9723e1ff3c50d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75067749b9e2fc7da100a9ac8211960cb52cf7c9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce515111fff66163dd29acf094fceab267df23e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcc1e2e50744fa08119bc7ac8840fe8f21a2c52a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fecab0395cfc39ab267c83b58cc074fc5490fec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1a410d5a4f0fe34027e71a9f4dcef6ef651e078.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/553f9140bf878699d3e861a3b20c403a510b15f8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80eff02ec0a11cb1e52818f4fe99743c1a338de5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96ef267cd653b043288a38c0fde2af2d1f877b3f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6d7160d3f76d1d06b94055e531340455256fc1f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b32a22d661477dc5e1c079190951afee4dda14d0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cad8d34b4f7150aad81dccaca857a9bc8b0ff4c5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d112794340474367c8fde77393ed706c2a71925.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bc2abdacc407edd9e136ca02a38dd4f6671010a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b189ed40a48c849284ec78abac27087aeed7133.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f9724e409e734879810914b9ee0f68e2674cec5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df645b4605dd689a26133186e5d29b163ba1bb5d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ce33dc7b5eb1e2f0fc0054bc51eea20e76b2962.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fa72f69518ac24ce63737c6d46bdf25747ff91b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/423d4a70d3975c2ae6fffc7f0601f0d07155724f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffcd90ff0d79cb0928203ee5badfa45459e6eac9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20377a87cbb4ac148239bd83b3bc78c5b53ec5ee.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8883a2bf3094d32c382a92bec70b64829d5ac7c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7618a1fe132bc328a2dd8b138ab6075465bfdcb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0e68e518359382e4ef97da88b22b670013b3d01.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5352c1d8336cd61ddacc471d6c7e25a84c5eb909.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43b17cf8e33f688ed0f496a8ad31899c207583a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ae2d7497efdeb19a568e80e94a4931bd53d221e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ba934eab013eb0d0cb91f091279354c1e129156.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05ac1af666dc95f2bb9b8fdc1dc6459c7d9c5a28.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7a4e467f8bc7c6f1524ac09e1bbf63b4f18a1ee.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/957181c39c151bc2f5fc9edeecb2ac71698f59f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd96d78ac5e3b62be02423b7b0dc726ff6e57220.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a616f00837fb708b6d2d6dad3d2e123440501998.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/150513a644ff2006f083fe0b4ffcabb1fcb2e8f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/528f34d6e928b2d94174a33062cb1ce2b8895f79.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abf4b575b96328d7e238ab5413de8cdcddf411e3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c75cd543982a59252c2ca64e5a8d88d650e1a39.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c67b26155948187c078a5b9160642f6c022410c0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a5e161cf518ec57bf45d089cc061273ad1f30b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7a008d8f8edc802a1d7b080130ce978b5e1b74d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f2d40d249554029aa493adc90332c7874c7ae39.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a25c7c4ed192afd070b301bd9a2b8a90c5c92017.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a10b6ecc334164d757686c464b33565cf87f10af.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8356516e99d093eb7434e9114ed3e1ee6010d4a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff8d8e1418b51d8323cbd6176d2b9117ef87fff8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4b4ab5c1f5f75b31b77029ef0d3b6d15f43d24b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1330b842f3ea258ea269dbbeb734327787d6b33.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/676cc567b411ca64e1dd78552ec6d61a2ca8a2a9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73de553a34643744661ff44fd2d4aaca01b8ec83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f6a3b86b5f9c54d2702c8183d9c0fcca0b51712.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6225341c67ae4a523cd0841e1f113f6e1f91497.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/chemistry/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a628d453fa005ffd25da43fb029bf2bd20f1b94.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f22f4b9c77a77240218c5b426fabdfee43f6bc58.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/chemistry/aqa//spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58fd05f3a19be1bc2d57987df41c8d3f82401cb0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c5e523cc26f3c7bcf09fc37afb0b36352c737a1.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/food/aqa",
            pprtypes: [
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/food/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7234d384c003295327d0fd839cf1da009c1d1a96.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c94c555275b53e3e6d8dd75cc8198af744c9b116.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/food/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fdd0658055ebbda3b1e00a316a7378fc19316909.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9067edc94a55b9390435dd2a0c7e691175cad473.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/food/aqa/W/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08462067dd0fab912732d306a10d2a6512b18f44.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ad21c564ef92939436ac30aa338ea8bee27e5ec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04cee90498d58aa5476d10b6c5f2340ca9c5f6b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/food/aqa/W/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d0a3c1457bf178d512c8ee36558ea03f2cad008.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c67533d664dc5b97483039b616fb5a77b8767b8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/food/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b3c034d9b866b85ef3d3db3e8d59338ebbc6d31.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4956618ab241f8aebe4becf2a0e0e911bcb0453.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/engineering/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/engineering/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c05efdba638d6cee9d6910fcee1dd2f1ed21b3d3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/engineering/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcf4d8661230090490f291c616eb94d5e1d99256.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/engineering/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5758a06458e1e620be4cba0fa06321f2681dbd2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f22930fb7613d22a7876adb56a9ca7e21467523d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/engineering/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc368034623a19478c4bffc0cdea20e2bbeea6b5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecf511c2c8d6ec81ba4219933b83ab6329f802c4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/engineering/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82dbf3944c0af1893097a1ec1db9804f51a34b16.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65e87868fff386d4b409b065589e4e4e49e41aec.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/engineering/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e07463b9ae306d638eefe38cbc27ec696c6f120.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/engineering/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39c5051b7b13ed955fd6e4472e9614eca6fc0ec9.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/physics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/physics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8e006bdf65fd31002d4c51946c90bed83a9f67e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/910aa4d9d4856d9b4cc4c19476690835affcf62b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a73d480f8006d86de74398cd7aaf16eb432e7564.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5b18cbf41d74b74193d10071a31a11732d92a7e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d7fc2d8c1b139660930a0623193a6e9e3386a7e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcd19656d048dc16f1635877e2ecd1f23af4e1b8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24c19ea08878c15ca27b050fd219ea95865b0178.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba4e848367ea9ce9fd3c2f61baa8acb95c11e582.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e684dccd49080846f157dd5187c5f9af58d7d976.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13ba785795415e8fb9663e83a2712c0ac9d75909.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5514148c98e11ebc9d7ff6c172d2fd56d237e74.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c44d592b924b3d80bca6bee46cf467d88ab9a5e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06d352a7bf19b169d31a5a80b19d7a2120a0c2fc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbdf4ca03caf7752a6ab67253de38fd7639ede06.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d897b9c9f6ab2b1fb53b4571e8989f7b81619d9c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abd38158d2bcb9bd88a4274dd3569b8989e5364e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81172d45297974aed8a34000aca80c0f9309c388.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f995672c32237212a6b805843a282196cca3528.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b8a56d617cb36743acb02e4d96135931680993b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c655a021d56a00e9fd2413ec5633e3f5230edcf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cba7e763f0907c2ba465e780a1cf469bd506a43c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/1/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ee8ab16fd79cdfa75bc4c009a5148136a15e1af.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad581419619b0b5d61593681a36bf08a14528e19.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97173883273359beb548695032cbabd8fe9f8f64.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/physics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a89e5a868cb652211c86caa44b8c77d4b5414d0e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4924f9cf2c8e6cd917c13e415adf8841128fd93b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c256f57f33df36844e8e9d2dbfc20744b1d827e5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89157744fb00e803474b9c5c58c9a47e3c3cbc66.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76bcd84513241790165e3ad34ef8709926ebc5fb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b999283b5037800181f7300a098e565949e665ec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8484a932f8c1f743936fd27464cae3def89d2c8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6e13930eb11daf27fb3df37164a8e0a0910c533.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a603cdd290c28839ef86e75bd69516b5f3d9dd9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d54a63ee3930c0c5acf6c5ade580b1bbcba66cf2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad9167c7b6feebb4f4f3e9adfd1ab6551bb1dfb6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a430c814da2044bebf819ca24d28c0ebc60349c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4af1b2a8416767106f07c34cf8cda802f2944760.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65c1f080c2b64a3de33fa5bfa904456f6cc36c6f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a04f0a1e4498fd58ac09f3b3b3bbf2226410ea70.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71f54a160d3090347ef83b519a4375185ed2bb1f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3154a21a25a80b50d512a0e9a4373b3b8c4f794.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b3d762243dd00d905cbb9f836e42fa020e3f02c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10c0a6e29938f78a3323af850b7d46fda0ede89d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3ede8694c6f0665212a05835db1c1b6f4b4529b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f59f0779ca51ab6d18ec1dff22c11d429b23d49.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/physics/aqa/2/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0cf775f221975ad66efd4229416386eba645b6e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d185ec57018fb8ddba965f44496ead7bda556ea.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96f60a369559891ffb320a3801f04aa878b56c8d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2832f4e6b02b7cbe6cf4297f006848f9020e9af9.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/chinese/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d702f5f6c32ec1a6f9a72928b076ebbf1e8b3b31.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b85763275f8d46faffa6fdeed98976c2ce5f867.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fd2fb4936e0c472ad1412bb30d4851a37869865.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/727cdb2ec3125ee2dad95e1d4e306b13f89dc18b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21b8ab9631a50692305541fe5466c7369bda7ce5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b354044991acdb41810cdb2408344cc5fd1c499.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf17761bd1d111c7260b392a84c7b6fda0599c83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9030f6ca8caea6172fad50920094ace26f6f8f9e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71dcf5e4c138edc803e0945ef9731498990aaaad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4accf5c55732532346d12368016312aeeade15e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41098e2380a4f7aa2910c491a495d4815a973797.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82f339b08f09ffca19a0dc6ac0cb5a3997ff2116.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3eb4576f687b14f8ef6d5edbc0402d8be9d8bb6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07dda3598ff30e8dc189f795ef5e1dd5a88eb5df.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8350458bee02bff4e495b530ff599886b20dac57.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/978f14a249befb464d854b1b106a69dff51be134.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df909a317943919f327b289918ea0b4ac9955dc4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/881a7323545268ae7b639eac78e3b9840ef42d64.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6698a0ab71eb289fe8e60fe0cfd11ca98c024981.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08c465b8cac221e1b6cfa1f157ea7e968ef0b905.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fc26a92c5d4b06ca1a9a1379952c287f6b77e85.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8aa02c0227b1aee028ef356d44a7db122d80acf3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/125ef7c648ffed39d859e2e1475d86f6484735bd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79fb5c4e03fcb7393adcb801b1749c13c9b48a6b.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e2810ad62387affb2a1f28c0cc618c47cc907a1.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf218a557e8f8941b8277c52ba09d3368461a718.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9984877058ba4d126667a2753ec1d1a26a26d384.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3be91b3fe01383db26ca6493d97474bd7a58a54.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0230f5bbab4def928ec45e80a1b75b95e6028f6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5ec4992f801cfaa701680d3aa2f1f207cd05ab5.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97ca8029f2d2010d6ac90ec8ebc20fc2be2b7ad3.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff6ddfb992eb8602fa27917cd8e6d8a0e0937172.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d094a2296eef93000448d3113a79baa37a6ca46f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6443773953d64289e3764541f83d8c810c831bb6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84fc5541bbfe206241896de34bab454360ffe5f4.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df5c8f8753facf7026ecc66e652bb3fab9ab40af.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5355d21308902b75a92af5a42c53127acef9b01a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07fbfe932cb59813cc0e47b09f190aee6c6d6019.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09c24960382daa3e69d50ef12ddb44c6a43eaad2.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42ad43afa6ee0bf23543771a7476aae341ac2f69.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34436eb74e863379db6a2241b93460e52ac1293b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/522fdd30b2e64a4b3bf0e1cf5310b94bf446a925.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2f24cd17cac394484e4fe304d29b8b8abd25301.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/faa0ae39bfcc0f119e6c7ed74752ecc3ab4405f1.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a70ed3161b063a18ea27a5740caba4c10bc9a97.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1628ba065bce07e7600b9b0f2c8e02f4949a22a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbdb0f92578c606770e0e78e6866c6f6bafd8384.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e6b70fa5b8836d3b23997525bedd767c0a8bc68.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42d3918b943c1ae9a9a9ec50448c26b7a8bb47c8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaea48ae5c6a39bdae6b6c29b4e6be9f1e42cf1d.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1b17e317bcfbdcb5dd0238c22b9541d72766e5e.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b44a65836f8d525a7e54529f03912bc328714da.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52fec8ce94aaf31f1732dce2fce2f1bc4e8df5ba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11fbea5cb7e51605ae642750748f2afa6608d880.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0a111b4f22827f2ffe2a0f452736d3555953fc0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28a7a73143c90a959a9b85f2b49d4abb932e2aae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e6b9c56688ac13899aa43e648fadd4cc4f3c7cc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/222f533e7dbba57abc029ac043e0ecfbba739ec9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cfadf9d9a40b5a6fcc3b5f1286a9d70bec998f7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37d87a8e8c5b6922ff7ae45eaca1eede289b9890.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94ec3493e55fc661554b9045517a08cb16617219.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90a7b8e1b8ce6e78b702f5f3727747fa14bdaf13.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a81c2bd4870bbcfa5d0ccd3fd627d1d021f1160.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e0b2a6580815124aad3a9c480579fa383e68691.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbbfa886f30e4f7d7fe2c5a3b070cdf07bccbc56.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de5591ff755374752051e3cd2269836f23dc77b4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/019fd2d11b7e15956f90f214fb8e6aeb5e9a5e4e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee417a55221ad78a154b0b0d6a836cacf3450c01.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae5c8f591053970e2d5c62cba8dfd7dce3d06a4b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df66abf4dc12db5908d597e3e0010481af644354.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/chinese/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c8fd59e10e254a3333f65811250cd28eb12bcf7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f36066bf9ec2788ddebd76ab722f3dfe44c319d1.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b40fae824498f7d2ef7676452c09bdae8fe423e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7fb387c153516f6eca274cc16c031e7026bfd36.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81fad5499190c06b5a46bb60a627e8ee17955f7c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59f9b7a21eca37f9f8261daa828ae7124e0f0530.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d892b2bdc16875f06bb590daf84b8ab70dbf5f4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/chinese/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e503e9e2166c7b75db83c82cbcd63c83429c5f64.pdf",
                      },
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf0776f2dd02191221c0ed8c5d7149b352ef90ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ecf8631fa0b6c37e6b896431a5a647a97dfb27d.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/economics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/economics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f82d9af3dd0940615eec9278f4ae8df8239ea6e5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3dd32199dc3754c38c6b53c70239d31c99cb3091.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d4b7cd5a83585a255d60be1b7ffd75d822c5a4c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef9d807fdd9e827f7567fb2605f604e1a8b150b8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fda3ce05a88a202b0939c621b68f9ba9bfaf6971.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1763c2c2c50b6fc503ee009a66acb7aca2558fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/300b88ac9494d4a6b3c0e7995c56d068fc916ccf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b83f40f7c1b2a4814b9363270849006cf02303e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bf134ed3255ec9a3ba9f85fc2eef4e6961a5094.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69746b471cb7c151cefd311f4160118ad34e5d96.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/economics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bd7c159454fd8d2c8b30a47d2161d604b2789b1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5eb474bdb9d2a9bc53e3bea84afab03b9deb58f4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/932ae12d3501692b9ac2230cca091ca00f2e3d03.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31b3b4bfbd73cc7ebfa23805e17200feaec3f1b0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93adcb52a716e98d00fa75b52d1c50b636444722.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/927ff1a4a2cd79a33d1571dfe5baa56cec71c5e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/487bf26ea5ea4e756db47f0b47293f56e0ceb38b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7eb0ae8f2da6bd48b4696720a1ef0964c041557.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/442ea87b25b342e59ff8e0ff1b45fe8003ba23db.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fbced7f7e6ada48ede1e9902b2a1b129b18060f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/economics/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d08d21a9e4c1989d148bc4a62bc61d8709be21ff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2948fa325e62d0374f86a076b1f4e3ea83e9b24.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/042dd5ebd247dcdf20df551b48ab206c6512a30f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e6c0fe85e83edaa560f0f5d4f78b5c223e2d9ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee6725c1feeeb23dbe569187a63ce174eb01e80f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bcf86d8fafa9be2ec54d30d3f4d7090744b460f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c085bcb35964f5b4eec44a195853881fa1b08a02.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38b75306c72a62f5b3ba75ecbd57f1f8d485bab0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7e2583464aaa981174ca44b7698e909f3f18852.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b35d2c0a8e186638313484b60b8251571db44f7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2323252a3a10fe32761bace1497d2c835f4bff45.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5883537dc01e3c5d68a93d5aa2545df5e4dee5f8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/economics/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7ede1dde74c7faad92963ab2cb3596f3c9e2427.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/48f7693688a836aa81fa7f2b840bcab3edb66075.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e87ab4aa0cdb91bcbeb91ceb20883305510e8dde.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/design-technology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/design-technology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c3ad1cf55a8f3dfbf471bd50c1d63ad5f6f3647.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c020f3bd1badb947eaaa7e614e108797625a708a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/design-technology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1ed04f6f78a9bd0cfeeca26f44220e1c68100bf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41c5edf1e8f0535d24265e5ad60fe8ca4b195449.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/design-technology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18c688dd18fd2f6d3cbcb591a212239c928ed134.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75a123b5d2427fd142ad76b30a07a24ea6605c29.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/design-technology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b126243fa91069a7b7bd22e3f50a77a1039e80f7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4df0464743c8f177e92c4e30f57abb476307ba63.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/design-technology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37b6bd9c7478c0e276e5193980e73aae3df95951.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0876928222ce53a08a8823ea37b61a49b5c8776d.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/compsci/aqa-8525",
            pprtypes: [
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/78fcc7e4df776f18615f6664028c397690cf63fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/802591934c5ab724411b6a9a723f74fcab057ed7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/042de94967b32b69c22f713c66b13c31d9c4c8d9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52f67d882ddb6f4df1a8fc8f9a9670163bc5242c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/642bc63cc1a2bde5150267668b706cbdaa16b9fc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c915ce11113baa402b7f38a24ed0b28be9bc58e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b2e57d827d5d3ff15b5e6c31d905f35fb822e53.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a69c3e9a4f3f7a93b2ac9f6adc21d93e5291b742.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19d405f57421bf5e1ee4c7110d06f075a444b33b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f178eb20adff3da987d731a14ddbeeedbfe4d15e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7129eee6b76706848b67f12e95eba402fe3755c2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08f5a15be46059e4245197df7b488272a67e0d63.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0f611247ce46f11b0abf881b01671f91abe959a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecef7166544c882ff50bbd1c7c74ff32c1b5c05d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f8ef6acb89893658f609def2feb4a5ce7f6540d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a420a42fa84fcebb5313277db23675e9d1f9ed9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32274745e957ee5ffd37b87622b59da420bee93f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ee4831144c7c571029704711f8f2c6cc7a06d73.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89025a290cf740b9a0e5f2cb60974282246386aa.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-C",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b049707631bc7abc12b7314874e30f9331cd8993.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04f38dfce22862ea87b220fcd63bcff0196da31a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/compsci/aqa-8525/1-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89a84782b1191fd28e380446567f0df57857825f.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/maths/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94cf2fab3abe61527f67a08030a9c170bb831b7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e79e15aa274dc5df317d425a5f0f3f04c5d2c8e4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7de3b66fdc7bd3d3dc5978fd70ec20a5678f01c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/edec1af2325f2f8a182fecc7cceed96ad9306f60.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a5aecb7389b9d68665acb16934011d592e7423e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60ce930e784dee6da9dd96874c5125794d6d56db.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73d2584e55d1633adf1eb77c4a7d9b069bc261f2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ed864317968ec9021e242c0f702ab795a6edb1c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d81ab0495164c7c07a0ec57c54d85f5827de54c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebb952444dffe9e23c7384762017e8421ee8f158.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d223c3abe2ffdb9ad0c5ad2cb62c0d0c873fa02a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/014a24d688cda545a33c06904e141253b3d99c19.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/63bfdc1cf15b7603814d9191b6a9c31ea8dcee71.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce3c89bf0787b2913b49f92d3f9a5b73d4e9c9d6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b7cd6088e92fcd5d2c901ff91dfe52da14b3282.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f5b5c318c90f8c3a654c84317c8f9bcc780430f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ffaf065e1c5e1008671993f6ed645ee4a5df18a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5e664d4122ac275d36033e66fa1db6f5830d7e3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b73d9dab009c08b4027558782ef4f9c52583314.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/827d30259bcc1846c4e45cc9b380bc29e30ff734.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/672a954edc8c8d4dbcf6aa09034d31222739f676.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f62f173576360b83a5c59710962e8372b361ce0f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c59406181acd45cbd0ea0cd9ba685fdc70ce489.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5043726873e1f5b5b443318f94ed6c7dbfba520a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5e7e9cda7b36e64692232dd46e1d67225a0a2b6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b83d7d4faf60cdece789e9f3a30629727a23d3b9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/caf36644f7a9ee71248a26501b534f604f2a4afb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e283b5d871ee181b1006aa0acd7aa7c0d26ba32.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd36abaad14c0555444ba5e4c7cc586691f92f53.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba44da85067b0bb1d130f3313f858c8d29d1a0e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac66e8f9e60fdc77e6aa10e2db5bcf845b16d65c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dfb3ad3702ca5b9644c4f4927603881c7e6b271b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/edbc9daa9d8c7103bab6cb70e294c607a1f99338.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/467d03fb4529104cf7e3f0386e5934fcab852127.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c6e911c6659dccb8db4a3927a4786fbd489ddf5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a77193f2bf491289733ba2288a9713eedc25a15d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe8e625fdd0f72300210b3b48f89f305be7192b6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b78f9ace0cbf5a643137c63e685dff786faa367f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5e620bbcaaeb5f4066d0e20d00f0beef8bc420d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb006580f16c4d07ec9791f77b611e6fcc65b7c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee4559eb02fb0540016cc8b5bc24975d6897f714.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afd033a2409b164cd8ed05df2241a5f782d80c25.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a46cc8140b07f5e9596b9362a49349506d3ed112.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f266e9f580bfa7f7948cc8a91c8e7f903559af8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cf53301f080d4eaea968d8ae1df40960b5a20cb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fef5ac3cebf04361f864e879ce037b748e5f3438.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3255c07281e781ee87f30fe83750f2abce9871e9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e815a331e84c8ecef73530b411ee29a0fd84ed31.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0297a1e78fa1f6620989502773fce32f589d181.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a7965583f76d32ac4ff0724da79a8296eeba6a1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ff5c8970b7077091de6485452f2136d59dfc83d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b9abf1e6965db9d9ec1b926272058fc6e82ef24.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/845dcae55f400eb8b21dd12ae41b67b9899e1759.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/01f47192e32f3afe44f073f4a6ae8b567334c4c9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5bf4fdcc7eb87822cd4b056d709d7220611afd2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e8de8b78f71b8ec0d2cb86e0c92c7d2ed6cf8c0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cf9cbd7a760229cc7370922821410560886f432.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5dd0f2d4da07ccc3569329aa5222c7d716e5537.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d133c39cb921cb42f5a824cc62a140ae7b8c47d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05eda9932b4d3598a8ab3bdb220517b2741a9ee2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bde213c5400c3b97b773cef3c0a1a7ef8b13275.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19931d9c18c052b93a164f8d0d340205072f2d6e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a65d09d8aac7e26e620f2937232ef1493eed6dc4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b415da65a1b7e1e959c737151707ef7d7e74600.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b01b72e5e16abb2e45cd15ef4d1c78a4ef713c7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e780b44d4b4e39395a9cf27a94adb9b27a92b4b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-M",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f07a858f14b63cd901517161027973253d3a1c76.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c275a420915cd466ae7218c33a45210b7273e5a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6e78701e9dc2e41d22642700f2761f16a5884f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/926f4767e20ad4175cae5961af5c759c1bf3ba9d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1a1c42b804df6c091e2fbc0dd3f80e6ce5ca2f1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/406acf18b7511171a152f8bb34018edb0a43a3b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c18dd62cae3ad13964b223d2d24c8a351cc1d73d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8440391d1f7e9fa3bac8e4ae169ab2b65d65dc93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d3018376e5558941557fbd43692553a801e47d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92856808ec134392b8bd66304c53008264b7b7ff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-M/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca3ddbc3d88b7c6c0439ca242920d427de45efe2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa08d45fc8d47b57820b69a1b4cf4980908f0fdf.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-D",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/984b92460815dfb3e36405296f66849932d680fa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/100dbf604c650633b282e5bff111f7015db1671c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/240a31d5673b3fbd9cac3e734e2c1961ec13db6d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2a9c34c189c5d47ae53fe2781a8b2ef232fe59d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9074e65ce739a30b143594d7d0e20564ae1acbfe.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0592906c9eb9317f28a9adeaeffc8bafe38a1707.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c683d03e4e52878855b06bca49e4eab505bd73fb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3299512cdb688ff1dc1896c7ed80f791ec74e68e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67c90e52ae0d2b512edc731d16468fc650c8b37f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b3e9864aa1f3b40fbd3acffda3ddc5788984c83.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d73ba803a525781b09eca3f72653dd76386f98db.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/543d8179dfd7d3df64c27db33e82545097b24ef0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-S",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1344ec3836868fe8d45b017e3d5df964ee7fa354.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad22cc0955d5bd9eb801afcfaa4a5780ded95789.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13ee19d9974110127c36173634f08698fee27339.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/721cf1d3b7a48ddf71d0fec8c1c64dbf8df222a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1a28de0f384d5e20b8d35ea886ac3913dd81da9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ade048c3185a76f9d41a90971e979862d8933551.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2e818c6737ebb363bd79232f83c0fde5f0d03c4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41d9a1c43ddcb0d197942f6f23c8eac6d8cf44a9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e234b48c3d84c0f19e45a6f4154b387508c2bc0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa7987df2202c46880cc869b48cb6be3c60753a4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/maths/aqa/3-S/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea1eb676f1eab639b34371d127084fa6e3c97656.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8556527e2653238fb795d122f1f09d746e44cde8.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/english-lit/aqa-a",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d53e99bdd288ad15921ecfad989f8b80799ff94f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/63e71586af258e386f23533d992866f8b79412ad.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca2133af9a3413714253f253b14be60a3688f174.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5313b804190a089af98127b261b6738f2d8eba18.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e439a09e6f93008b604d8c917f75ea478371b737.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71514db9eec5d0d821b7d928801d601b4ff2f59f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d101bbcf944203b51a1a4f50db64c29c94af5163.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5524fc8881117b88b13369829232364d8a407f8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/098e15498678a5eb0a860e7497104f89af07cf2e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffab7cfe4a6938df85ce57d4906ead3a0ba148eb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35a6f26191be66f8fd36a3101f152ad1c1f271c2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/881d5327a1f960e96f7f32324fef479c07c454d6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb0850b748d89d787330ae970b85b1fdaecb2652.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ccf864de103861d773e41fe22bdb9b6e47fd424.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/272248ff7a04a46aa8fbc2876361920525182f93.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15e507814f6b347c38ce1cda03c7e5dfb1e0be55.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a6b5dca448ae1ab52b7280b141a310e1360a381.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/596c88e54c92bd90690f05e2cb7e50314b077c7c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/900d7b3bf13c7a3041474ee0be85c77950aa18a1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/217462107b1622b2284ec58b9eafcfff6beca40a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37b80a5a9f7d88b22f46443af5101979f9c911ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1eaf68ff683c9ce44de7263bd85deafa4b55a6dd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34a49032ab2e1c5bb8a2a7296ca8869e5024a7de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3329311ca5f1f6febbc10b199841b030fe937c87.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b8b76b08b0379752754a7dd0a590e3c58d5aa1c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e109abf0a545040c34d9e36cf4e6684fb420688.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5f5fadc1ae20b9c632827fbd5d4af8e1fee4c11.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f88a8cf83ef4493fcb5e81a619f55df7e2852eee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f37d17f0ed20b53712a7e8bfdbcd12c9e499181c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b28c72520761708f7e58c76f3f04c2cbe6986a79.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/480c692ac86d4a874f404084fbfc0f4408f6d10f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d744aec5b6107d90284726d94c40b12011a4762a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3afb970681c2e3b1fd96b6872bcdc7459e95c9d6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e7a36d0282b0b4e10961de0fbacdc2d5f9656cf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f89657f95e7f1889810c4a345c3a22f6282c138e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/363d91b7d8dc245ebaee78d6e720fb60da33d1d1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74cf78d77ff9e877d6f910e8894ea0ffb00425c1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18f1236327605f0034dd25c236fc755c63c28916.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e81564c293a16c8559d1c2cd36c2d9df3d1f4a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/739936820310aebb1a43d4f1c2ce9143b6618244.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6f18cc36b487d0d9195e55ccd446faf3cc6d671.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/185778d81dfa0e6500b5e067d8e50cd4a03c37f2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1774d1030b685330f063fb147bdad014e1446bab.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51eb62d0360a0e8bb7baeeaab2ba723cb578a6ab.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c479f4fb23c9d74dd2fe6c22b520ee150ab751a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db089bea9551e5010c925a398f27c67e03f7bfd1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcd6f84cb6c92968a0ec4f950421ff30b9d8109f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbc1c4b6ff316f84a3dc702cd5db2670c4ba821b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a9eba9d05f03214e094ab79f761cecbf4bcd4a6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cad1ee2174390bd95cd73683beed3436b988e48.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37685454edfb75b190d4318995118ca329a111d7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff153d97979224e8f4d2c75b6ca3c6693ca6bf31.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b2fc2f951a3b3547c628f46a3122a6ff6359c19.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f04ed00a470019fa421ba20be31eb3fd44cbeb76.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7de80a332aaca5c152d856c7cf7793b959cdfeed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0098082eebf8827f58f937d8e3a22092def9a172.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9bb63ecd8eff0a7c937cfff8cec7cb623462dfb0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e682cb309404f16062686f9ce1d7da5b721fa4dd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c8114524a0f0e2d8ba0c38daf9686f5566188787.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c41724d99a36b4bbf2f60fbc032314972e54d4d9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f101cf32dcbdf693450fed864c35c8fe5df429f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbcb282b971fb4e1107166c665e651d9536e86f5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d03f4b5ac6242587cd31581d73b48e48a8b3c05.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e287779f3a8b0e2cff137f08fd8fb861afb31cfd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/583201a6db58a7b2e579e265bd8dad16eb1f23d8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3cf0bb1d4094270aca83b37332b51b7cc600da4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ce231715cc5af1528ae7a0a94b521bf41b0651d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbf46bc847edfaced2fa2d35b27f0bc598a84d7c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e4626be206811ee2a7b082d2c7007cb0b1e0ff8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25d97e5624f3b666c168b90b6c790c94628488bb.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98178a7a73535c5be41cbf38cbbcc761f736942c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b84abaa6c9f21ba187f3cc930df6a805d333d7a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c31c59b9afd43306a44a2cb891ed549be5cb4285.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbf2ac570726308ee01637c4ee473b2f724915d5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb5fa9c9eabe7b6ca29fb6df2563bd31089c2df1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f821330acb4cbfdb035be7e3a23238e97624690.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2878e89f010b726bdad1a5b16d788794fa5d9d7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed6bba69d184a85540426752c3202e5a73aa9c9b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79480b30824172ed4143249483ea3f86c0186576.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fdd00d6864efd53dd924b4963458cbcc1a56538.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d3a2c8473a0c1b78fae400754eab598d7353d47.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58190bc00229f085b5e610e0a34d5d0421a17b18.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9efee0615e28c9625c74427af8a087be8a7d91c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99ad0828ae72a9336e9639dbd2142872cad4de7f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d83b3c0a0be18d259c43c5f44a3c3c6c4dcf77d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39c66e5294dc85abb96e358e669b1736a55c96fe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc6bb54091f4d72189b370b8843879c474332df2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3aa4be56506d8618513b131933c42bdebce8960.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a2a19ba074c83314f022da0526513bbcbc29eb0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c4547cffe5515ccea595a752342a4705ffdcea6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/653068b6c131651412d0f5c2286d92fff63128f9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/920c9cb5927ea225c9ac02ff02eb79d2b04dcbfa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/583ff7cf4ebe721eec04d2009b055468a27de14b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0548fa8dda21cb272f512c96fcfe7e93fddd734.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/042ae38a8ec766adae2283dba7718ba3cdb3d485.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/925ceaf6405400805d75a8281996d33bc4e5dd2e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f8a3911a07fc0f6b2a847d4be955ca5b130fd35.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3c486d26f228863f4c81525df35dd7f123e61c2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47bad714b3526f702aabcca0963453e46c3f9a8b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5976ba3790f94d792940be8b155ee7d042f52cf8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf5de99341894e93ce4f2cdb32ba8f55fc5d33df.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75d33b7578e25600da02ebdd2544958413fb369b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41608824c97b21b2389d4ee57e8f82f6d857e32a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c4c509d4d773a47a446ca371610e3e92106865a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83e489c60fc9862e9bb75a4b5f319adc61aa07ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94127d3a43eb8d625b527e54dcc41193ce8f55e7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee3989aa817e609ed68eaf95460be13b0abee4bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a9dddc5d4053a42ed457d298c6d99118aca1873d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82174170e0e028233a3a624512a34dfc2a4474d7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25769e6c1b084077cb2098e8b39aefc48e28ca59.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbd66dcb8e84642c135f6dda61efa21fcda1774c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2d3f7ec8d4fa969775ec8f5f6cbd76f2af9ff09.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe296e24da4ea9b5971e1a860b45e33d0329ab7b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/933985e8d0dd0d7393608085c78bcace2f89d003.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/831eedc9c995c7806ec8559ae4fe93d0a65fd75f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f70a97b667a37c4fe67817dc962a1d27232bf728.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9ca47ce25e5713da7ae4c4ade93d608828af710.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44d20b5f452a1b29fc7b90c3f2146d4dcaeaef79.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1de42c2fe56f4c04e9673c08a87133532cdf3b4e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/278bdb06eca7023b45424b48538c643bf8a23a95.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee8e0c277bc4b029ff50f5b05c97a5dc5b0027b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7dbdb4764f2ad5bdf80a0499a473caac0b48e7a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1417d0a5c37fddb8ca4cfa25003b9f03d7687fd5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d56c8d0e5f1329674168ab5e854963def904dc32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/736d43a58b41279b666a7bb3db2e09a122b41f8c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee406e2c9b9737da06949a6ad73f6222f9839789.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3615c7e32b0afb04c502b1a21fb1e6d869d3b770.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/english-lit/aqa-a/1-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/351cd4e51cf9611021d5d45537b1a6415da0d721.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2aa8156eb67c4d13bf03f7baf7c69914578223a6.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/law/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/law/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81303c2ee00d8d782028d8d194e89dfd17a8f1b6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3af6ecbc589f1d14096c909faea8b9e2bd7f645.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8c57098ff5a2b83d6ab032fc6710c590cf98677.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/544e9a0390cabf6e022d3b3cd77f0aaa4e021a6f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a627b3604297677cb897837602189ff109cb37d8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca87f98ddfdac4172e38172914891100048db397.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/633d53a7c79c2b6d2c1cc81698a66d416a36f926.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4a24a437450716e91541beba27ee67900d656c8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b01d9e3c75808d9db86e3487a1f5ad9a52789986.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70a413a00e081ffd9a9a7a958d2ded888a5913f8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/law/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c549fdbc0652d9649c7cbf8ff2b06718ed479633.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/560e0d8a9b53429548d30673e1276d9694c0a939.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7008ceffe3c003f83453a0433fad95218aee677f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c727e383a59a6ee8922aaffd524e61ba417b6097.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2109d201e760c0655a465204f7c7903f458f9b80.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09406ec07eaac1027c5d2dd6c328aef959673889.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/126d7107233786780afc0508f2600daa28450586.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bc97c6e7652850b7dc34f13a74874c9dc02e032.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7aaf3578e00b3b0b1c499ba0f3facad0ea68b310.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59f032be2422ea8ccd72a900b50dcf08b4e86f22.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/law/aqa/3-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0308b5368a22e679b523e7458e0c87e70fd7c6c2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c86146872269b13a686fc61b4f56e4f57820c712.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/546a847324c9f43219e28656bc8231923d19a6d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae698afe3a869514f7492c4641b9b55202dcafae.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4efc8cb6ab861b57484cf29d383b07dc8ec294aa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f59eb981f3741159a590dfda7fb2d7965a750cdb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6dd7e9c96661755a3b8437a263daa1a02547cd01.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c06e838b3756c8582ce2252157faf04c55a75c50.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39c5aa8b8b76b5f7ecba1974a4b3d7cb326a5cf5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65fe7c18c30c2bff83e81ca4837b6a878c636c80.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/law/aqa/3-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d5f8806203120b18f9e4d838645debe27c0fa4a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/466426b412919709e1d0389411f88a80c90e738b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37990dbb3557ce77e8ddfb7da7e2e44275cd1ccd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9043636d81609d168945479fcc1e2fd7f7ab246.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42df02563f77f73e5311bbcb1f6fd2a3c94e7eee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61dc4fd442b7657b2a2b013159d2f0745a16b2ac.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/456b08c7b3f2987cfcb71c65eba28a5afc7e6b15.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/720885b75830d60f55b6e7fc8545cd669607d4bd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/law/aqa/3-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d26aa8af6fc1db5c9b1d468368c0c61472f76f7b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04c772f8c910b692468d84f37a9c455b96b36cd9.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/level-three/maths/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26c376e03975e18c6406b05d4f6029cea9abc213.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/245cf95db0926ef5033cced5ab42143d517703a9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7f5198d702ee2dcc2736b8f564bdc54e122a9a4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ef66817d96c156ac0a431ae7ad0d586e47929e6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe7818ff2c33ee804af8b10a8ad92413923a978c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/620a9a8464f79fa2fc0af103d55fe49311360e74.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac199d85bece79379c630ff77b625cf5ddd26deb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b09cbe547ee9acb6194ce5c4158ba61a0fb1f49f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b31b1f8c7aae592431081eeb9fcf990b84dd3b09.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11321dcc8a22468f231e98e4e113d70cc1581724.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f32297b3acfc64f88b2c8921ebba5b9d7b557d83.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e129c7a40a6bd900d365d170cd768a144f66bc85.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abf970e8c6c5ed9addb1efa669099493af425d47.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61f95a377babe3447b209b92c761399f46af8aea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f87f8f75cccf47d74be94870488cd132fea8ea5a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acfbcc102592d42c0d8903b2772ecc7ee5940172.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4048bad85588274deee6a13bcb4c025109f168b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8eb3c2a7bcd1c88b07a5c9a1a6d5f47ace92ba57.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43eadbf36e0442fab953c899b8dc9ea1ffd76597.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6d8d3dc9f9751ae243159b708edd5db8097d5be.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83c20f4ee3c3403e0d5b59710c5fafde1edce5d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f05e930a9de47281f4d0b3ef228f906e77536d4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d937511679c672ea53edfa6e66daa916c61b749f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3c6cf5a618f6d9c9cdf75b8145fb9e324e743f62.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e724a08d7610240093d64fbd7353aa9d583c0480.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/748ea9840ae1e7f457ea0252eade9e2b9c595dcd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef2856793e250e2ee2cf59386d753897db702784.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6696e21546fe30679fc23c6f503a679bbce663e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f5a35a16ee20dac91f463688c72510692690345.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ad7098dcc7262d0b887167718dc7482753c8d8e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba745c736675ebb646e2d81d0aaab4b98652d751.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89824a96eab816426aa1385f619bf3ecaae94f9e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b32fb474d950ddd04eb383833ae655bbee0d5e60.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad30d0dda65adb3db67bd4867d5a1f009d5a0aea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/348419a4992da04adb5ae238ae89817d64afe2b9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/269a683c55fd84e83246134ab996cbe602470a58.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1f7d85dbb04ed82b3222eda114cd87034138f64.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7dc9c6b7757220c1f9f04ba8537c88c534ec936.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58c0c56a4eb094da19826041f168a7bac3d976de.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e71715f0ecc6101d88c20c046204e6d5fe34cea8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0619cedee0e39209c3744c2ec4cad45bcd35a42c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4bae7763afaacdffcf0cb7ba5d679405dbf821d3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e865d4d994436d69be74f18f5633669649a28684.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69ab88dee6a849ef05f7b3bb74b5f8d2d431c1c8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1bd61254c97c17df64b437b34351e3e60470dac.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f20e940720a88200160ac399021d96a47295db7b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2; 13502A; 13502B; 13502-C",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/2; 13502A; 13502B; 13502-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37fc738f6b4501af655190617c41502e2d319d32.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2; 13502A; 13502B; 13502-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51c2654fd848db18f946382cc8925063e97090bb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2; 13502A; 13502B; 13502-C/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3005ca7b451e520341559cc458c5a41333fd7581.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df4d45393ae45d9f5944d8a35568589c97549e8e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81d2c3d825a559500e46c18eaa5aa95d5ae590bf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2131b5490360d69d39b15e7e5abe785cc596900c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28c60624db047210ac1b6ee3d93a97cdb6c56c5a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2b67357713eea111f058d7f3876a0f5540ccf7f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0454a00fbdd4a64f47d10a858cb134c45c8c98ff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/510a2918761a586be977e440103d1e1bb32e4e8f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/297494e42ed20302a7c21229c5e43e4d9c6f5b7b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/285f072225e482ff4c3dbb98cebf488500afaf1b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18b21f97ebc514fcaff04ec45cd4ba0d408054f7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09891e66f6ce70161a0243ebb3a1789c5485b699.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cc819ed1622c0918160f8f30ac2d49217e75e981.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d34902af266d86b4153251d9e8aae712c682aab9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0aebd519172be57814da04bb7ce0dc1787d99c4c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d86f6f19ba7f87898647880f6a0be0004b35a480.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a28cfcb9dec994138d818b257266da9841fa683.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0511dd5754a126f606a0d753714a76e87f0a6b7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-C",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/316aacf59f315559d4ca96aadbd202c878814b8c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d6054fc53b4c4396b8f4326e35efdc2b5866de8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43764329deca8b6ba8b408c1aeceba0977ced0d7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60ba455c9fb03169da06ddabb74608f1ce1ac743.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0fdc5d5530e2b13cf63aa9a4a422be9709971e23.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3293fc9d4c03e100b6d49dd55e7a49285e1d5f41.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dab47a4e928979c6c845ff974e318d369ef5c22c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1bc5a2c774b39837c830101d1c43e4b6dc8b6ec2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39db54a6ee6f7900d72a0381641b61d28a9cb9fc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c31d6201b69f7783d3724206fdc764149e885e62.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/942dbd4890a14d84e1594d79bef90f58fac0724f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b541c1119aa3d8389073bd4f96a018078844adb3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8ebb003dd0c0044ab99856cf2a87c759714f482.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/816bb87f12976490fa56b472f1bede419634631b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b82061a4f465e71b7cb86ab2e1dca76a7bf12b7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/2-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33b7440e8bae166d3c34e2d94ac0ca718f22ae83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9164447fc634a3a4bafba23cf4dce917238cee1d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1; 13502; 13502A; 13502B; 13502-C",
                "yr-months": [
                  {
                    id: "papers/uk/level-three/maths/aqa/1; 13502; 13502A; 13502B; 13502-C/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4604f14d8f8c80fcb00be835cb00edb5a3ac1763.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1; 13502; 13502A; 13502B; 13502-C/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30e4e8ea93f689745d37fcec011aa8e697195d74.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/level-three/maths/aqa/1; 13502; 13502A; 13502B; 13502-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ac8e411696ebf6a8cda5ae19250044a33b29afa.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/biology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/biology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab986e78804a78b0bb2ebf8805d2fd8a6ab45d51.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c25479b08798b134ac73f228398b9cde49d50555.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/834cb515aef72480d4e3e708a43a8dc93b9f9aba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cb18b1577c3a68737742f0fc171ad140f07c32e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43e403f81f98126a00879ccd3fcdaafbf8d97a1e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fae1bb3a76f8549fcb5b612b1a5fa3e4f9ed53b0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/456d89965847d848bada81556334289d10f7e684.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7611e464f81042f1aa5320f2b281bcc84c1ee020.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a8ed1aeb2ab67cbdb852616b81c5041e1559462.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e1c67f838b3a56b9604a33fc23196c9106a1585.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/biology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd83b477a7a6e5b3f96412e7c088dc20a7e8f02e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed1d21daa575c41c7ab05c0fb7614668ffc7a968.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3e81bab7e9d8c6c8990ae174e85221615a2815a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fa69aeada9c43365b2b040673cf2c1028e860642.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d27eb3053110af21b067506deafc043397441660.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8c0caa00498729c70414d9b6f05022fbddd8a9a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05740f5d4223a2a2854ca3795281b68bf5d41d83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/715e63d87124b700414b56eac30cd85e343fe3f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/740bc5113c9106153e1c87a14571f91d238a8c65.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96ed109eb5f0953e5a58f27b2576bd8f7700f3f1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/biology/aqa/2/16-jun/",
                    yr: "2016",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/367f0dc726e1fb13a2723550523620eaec489c3b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca9b92e3b12018526b34903b58ddd536ccd32b49.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/drama/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/drama/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cfa62d739220f1961a09b40006426827995f011.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0fae85eafecd6120296b19dac046c283e7a6f152.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/drama/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e64bdfea0002c7ac4dd1589a8b80bfde81415a15.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f65acac2848edde29f3f5f78ac1f66ad5272de9f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/drama/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70c1dfb17bf7cb6eef23a375b5b706e6f64ed45a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec792a0459717c58405c947eb6de50ff31eb1771.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/drama/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8f4bca0258f7d74c7306a77464f8ea90d17563a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b40c5adca8d951ad4d9d99d51b72333b2aacbcaf.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/citizenship/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/citizenship/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4d6f02a8516a2ab6767f04c4fb2642c25f02a36.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaeeeb34433e369c42989ca62747236ecf02ddd9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d82115163d8624f4eed51533606b91fd7695ace.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce9e6b5b0d3a0e4065cdecab043b1c4bf34e9b2b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b84ad3f97ba26f712365ed388e8021ca95fdb94.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1347e3b236cabf490df8bf894f88f0e7c92fe824.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef7544ff324bd5140838b11b129bc5b52b12d9d4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5b7ba2e287a006d65f3287ff1ff2dff806889a0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb04b927971faef6639b63af0c7073ab55453017.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7cfef7ffe4d855aa19b822e9d471e73a2a7310f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/citizenship/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/838c57582f6babfe27caa3b7edd3c44348fe0f5b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b62d769743eab0350779559e0cbd4c364a3944e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a1038fb7b1442c8ca1b0b1b4f5083c10e19ee166.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f617b2520f3288a917c478d3a7a743866ee1937.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2133c0ff8684a9eba583d29015d69aee1871c443.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4da1b53ee139f3bda1cb7a1d5039b7dab5037003.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d42dd7d8be43801602a835d3947387749bca91ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b2b222c3e6c8ad942334f94a66ab7705b42d67e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/citizenship/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85aed4e27afa5234ea5cc1fdf3efd0d934c13eba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbf0b377acfd24903089357f419da593e4c75130.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/economics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/economics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4dcde46f3c120a4ec72ff000db4d1b823537c280.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7bc83b5c3d942ee0b500eb308c0d58f2ec93b39.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16871f4e51a00bddfadf93eeeaddd49fcf56166b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/economics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5b96c466da9132f6b4da40c075f464d2846cd45.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bafab201201160d9250b85d15ffd6b5769335c5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2e81f264551a11fab5572870a859e44a8579793.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/economics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ee3c70c873dbad70807e93f36197dbaa978a0f5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39b244baabfd557f269a7684ad006d40257d3855.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b3362941e1581e4827f11ef1569e88997f6d9e0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/economics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ffb3944a798f08cfa22656851b8b319e103cb8f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c92a05a298a11d18284dd4d8400395fc1627e1f6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e998ad057941439831ac32bf966bbe9ad44f35cd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/economics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54110ec2eedfe79c04f1a76d23c60692bc421271.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db1e76835e195caa5ef49f4470ab72f506c4ce98.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f8402b0761a489635381fac071342ec2a070e29.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/economics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6eeb0352c565ce6f60e6ca102e95e129ebd28cb5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6f81f6510b8fc27af8b929c14a3bcc33c923e64.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/020080bd1c457486b077554eb21448e1e75e5042.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/dance/aqa",
            pprtypes: [
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/dance/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f48dd7b77f1b7dd772a60cba7f375bd8296ee1c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3eea259b0f851cfea3f058355204062c9862449.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/dance/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/855c3fd1ca16c45d675da2c7eae3bbf5d0701b3b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50a46af3444c01e631a375b0f0ee7d0790f12ec2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/dance/aqa/W/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f03753084073d4bec8336756a58c8237aba18070.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a063be3a3e92f49798c32748ce2ecd782a34e99.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/dance/aqa/W/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c81eb490100491587a1a84f94350f261e772b0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/447a8f308b1a2959a73c829e383787753dde7649.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/dance/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/400e49375991bec682ecd1549af48300b2655665.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/dance/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cf320ee2c9541c9bc6060366d3d650db0e41461.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1406c61d60d0791c3bdf28d1ceee7c7dfd61d3e.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/polish/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30d70203f62fccf66698078783c01372b8eb6860.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/034dc10902fb3dcc967453b433be5d077d72844b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8e8df81952e891fcdd5573c2fed2e2fdbfb86a06.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cca0f2930f5cf3faab4eafd1b738ae446e6d694.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1f17bde52e1d3a7001bb527b030568c46ac6305.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b5ba0022775c0c17065a899ff163019605c88df.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ae55e07cd1f4c26fbb8f0ef8f345b5060eaafbf.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af18d076d50d33d55a67b946c87e84eb027072f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32a69d83f2e64a7969e40c426253d86178eebaaf.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3c0f3760f23e3ac0035d80c9a1d837139ec666f.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75605f3352c35cf860bbc7422ef6a588fec9a90e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a27c2292efd128691f45a4dd7f11bdbab93c673.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e801711e25b3291949e11489a2c7a8f114979bc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1055f2a37d86a84888aba322da81de4d1beeedb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/337bc1c1a93e2703acb510442540652bd65fb3f6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/732f4b68e1b5832712a44d0f1cb0535bae5af85f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6be4efc454bf85dc881b36d51e626f0dc98518a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e17e5b656e33def4bf8ba02db1157639093754e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca786a7da443c894faf44ca9a909e84d1a1107fd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d714d430ec55a177468187f7e0905bba7c9e336.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4334f4da388c5edddbc91ada9c66778743c65d3.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d95a33ef61323bed156de41a0a8d9b302b7eb119.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/333cf67d83315cbb81214e56c04e18c4f98c677a.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee64c53a9c7589df9c9a8788b669f52a3b42ee56.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/618018b4ea2a22e798a8ddf4988168ef3f7995d0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e168be8a57df09ce858956660ea7eda6a40d0fc9.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/752018ae8bec0a9d25e1db93e1035360725dc437.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72a0c3598be04dffabb21d8a2e4b93fdddaa8a2a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9adadb27dbc2e3ef1a2d78d92738e8e3e49fe7a9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec41f1080bc49f530793ebbdef4889e89bdfcc35.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/628d31c4235b39200bced8b8161d3343743810f6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0d110276443049d2fc0841f35b43f7e2a63bb8d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/787dcba0f43917bc3a994872730942c05b2dc494.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17722f05812c098146633ce263c911899d298ef6.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a75688d419654e3403f216c5b6bae14a73720a25.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2d96dbafb9aa704f36b5b1ea6c2603db3fcb1ff.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/974bbc4347f381340b152c21c525978cd787bf53.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75c0732b65ebfab6a1c5d1c36c28aaf0c01d484e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3dd0683886b7dbfd994dab67d1bcd20764feaed8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93caa053c992b4ee8e5ee29aa9b6decd9964d567.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/71c921a9e68242fea24dde529d883a406030d538.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba155372feeef301e23f35b26a3a6581cfd0e645.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a956106b61625c4a0df366449b2c0df68a916ed7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a0947c706559ab8bb4261eefd8e8f2419850d60.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca643ad1144fbb9f233343393d71b1acf831eec0.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/119b84a771ee8ebbf1905a9f3bf52fa321235535.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ded1ece32850c9188570bf1338b67fd1a458441.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3333dc9a41fdcd4d576d02ed0c7ee60e52f919a.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcc00f647399f617b9280c5caf0ea3907bcc2e6f.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2253ae663992ed958a7a681b14a6fa39b6335b4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d81f040d357d97edd1d2ea7c2a0444906c42dd07.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4553608f6e9ab57cd28ac7461e67af2874ed83ca.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e8bab837839bc381e560e06532e1f69d1b5e322.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fdd7767e5a1a01e073550f31bdf767e90f61883.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d53a836377443f89d7b07de380639ee95d28a5f1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51e3eb98cb55b13abfa1f1ab50b19f4be18cb00b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c917d6d3cc606973cdc776b1474781092282338.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2dd87141b6ec0547ee990f571faceb6fd6936bb3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d87953372f9e779bd156ca60422e6dd973cddb5e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/057cc020a485dab07210f8dfa8d40880a6cd0f29.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74f0b3ffa0d8966f67339db9bb70e7c7b2827a3d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17d024f1aae0808d61fb966d8e83b4c5f5dba9e1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ab52a4cb0c20bbe511616231f8df37d9f22a992.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12cb5525cbe194bd5c566738dcc0b7990881c010.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc6d73cc9f3de6ae06d425b3fe124b607ee1d86c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/945ab87d4df2901a89ecb80728a6b3fbd46dff34.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2f8a99ca0645a922059025bbbe929f8d675c5fa.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3bcc0c1106219469005d36af74bd5c47a14c94c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84572967ed3d1294882b2f202ad47f926b4af426.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd3b2f2551918d2a99eecd2a2fceaf898bac0076.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8d4449464e76d5c58fc4766efd33a212103f6d1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/551693563ff98e9249bd23caa9b688959df35ecc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb1bf34ad2566203a6efcd9fde50c93c9720522f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/703230b8d940a640d61a71d44b697fec23fcb17c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/polish/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2923763aed04ebe2f4917759829e81f22a13c84.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aac4335b8833897549bef8eb788adbb01b87407d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7214991612080922dd03963f6f8c8ab6e12f18f7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9834150022d8a9c0fd7388a87865dbe8df1b1710.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90b6eb0e6ecbabb03f74dd3f0b9c87d4ce117972.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9db4d33e80dffc44a1ec4872dbe35a8add10246.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/118eae4bef47a8d43b832dafb8f5b1c926a29258.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/polish/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b47ecf9be89358d3816010842346f938497a02ca.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0b20e9125d15fc5201405aa269a9058271ffa87.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0708ce9e7a3c6b035b0f326589e531ff6719c463.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/politics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/politics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b16678c0884b1b0d6d572810f4800d36f08d4e4e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf8e47b3e4f923210181d5f1f785293eac3d2395.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c834de1aea700cecebb9fc66dd2513bf99da5b20.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4d470031a5f9d343b84e122fbfe4e08b581228b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22e282b515eeea572f275e8b029c4b60798372c5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98937d72b7eed29604fc1177d4e9e96323026820.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c300954c2314107995ab822959c0aa5f70e4766.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4a3a316c37c550f5ccf4c76abeef5827fab2e00.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5fbd2428abb31f0c7b2c1c090c6e21d0765a4f0a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a87f7a6c82da5f39ef3376cb538cc085556061cc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/politics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7ec59b11d69463419ed15dcd8b17766b5f4fcb2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f2748c6b3e11fc0b3512953e067d8fa2aad3e73.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ce2293a17dd52ec267d58e67d7133c42ef69dfb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da1e88a450d30ddef4d630c99aab7e0e9b67b5ea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cc5d9172f1e38269ea7932ff9773fe549dee0e05.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0818eda432f6e2b1ab2dca392af223907d3b44c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8072f4fc86be562736215a93fc4e8397811268dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6bdb0135f5e25979e8a0b92a95c60a3c5cbfec07.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23711c6abe154f8ea95dfd5c04917c3f9ce5ea97.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f3cfa0d302171517292450d43e26b337eb8069e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/politics/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8eefce7df2b1498ea48850e978c24fcceac9d245.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b0e67e64d80fc3b51e04741230b301f82d79054.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e1b3b959cab749aa2e52438eaa73344bfe17efd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1949649d7e8049b80f318407846c84003b48158b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/436ea90b03be13c0e305bdfb9fadc0576ba430f3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6727692be59f5066ea8441e2b605796dcaea1f07.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a279ce6e5cc4fcbe0c9865ea86e84f399906a109.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af56fb75586653ff387473222e404779f7bd3426.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/politics/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0355ddec886de1139b5bbb13378cac2a617fe01d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0a287c624289ef4534e6a3dcce5380c6a9508d3.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/media/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/media/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c0f0178e22952ac767499b1c0b51beb2d855bf9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/901cada1c64cbfba54b77d481e2bcce4a7990f27.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae1967c4529261f61db20728f787908ddc4fba3c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0407cbd072d42d55f06e51379883a2c7e73d347.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e9b8efa0f3b00fda15f69b90e84277cb4a3b8d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61383518d4194e1441855606e0cb068a9c0881ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e729af4844354b3a4cd96390e7bf9bc8bb16c6cc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c7f5e893f46818c1046ade3faaa9232bc6d6dba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67c1b6637f8b6ba6ad96fc854d0b15153f9fbf23.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/988172f1900cac4717b4217a96546aee264f2734.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/media/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5dcadff238581a29e892fe2cad577b6acdea6a73.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/459a8705cbdfc960fab83ff62b84a4442bcea323.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20fec3437043f87a810293ebe48f5f9f71a17cff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbb1f2b11259d51614b990249b3f1dfff7b2d31c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f206c3f142c4ef59a515e973f7526a93ce57da0d.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c44acdcf2d01255951e91ad585392f39ea8e916a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35a87f967d9104ea634a57b842158bf4c610c152.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/207b41d86affcc2a3b576843e765d12928b76d82.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43e980dc5c1861dc45b2d51015aeca37dbf5710a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c194200f06789e3b6cb5c961c5f5555338276e1.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a4dc9126027b4a658f265a32a48a51b72db7afe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/media/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9600be999fe81ce34703323d012a6f5bfea72790.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b78726dfa58198a5c8c9f838df8079501f0e556c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/functional-skills/english-lit/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/070108e969494585ca40fdb60d085056f46c0cc5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4118e9fe8b46cf25561267320ce12c10ed4c7b40.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/593546d64e8532a96ea34c9429de095197651b68.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c338a7dae022602ae3e61bc631c4cbe813913739.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abc71409e4fe5acc4e61183cf2ad83a9fda3b8cc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7f8f7e65c4df3a5bf11aeec0269cbebe51ecdc1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/feb6b77b87d93bfaa7606f2c219ff62125936d9b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7acab723ddba19872a4da07412b0255453b7039e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/798cf8a9ac498085855ec95513c3f39338cfa4dc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed28e1556b663eac68016fb931470c02a9c36d11.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/472937d162dbed1b5d86cdd7c0da00e4780b1ac0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5177451817525acd7b2945d6c468f1b87f32822.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38d980b083acdd335eaba91d58aa94e1fc0a3d9a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f411be8f5da7dc22e546bd8c67cb445377d7c5f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5304b402d3e9cf04970195334e75d2ae52e808b2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba2b26b73ec40545e99eafe15bc50bef25e4e690.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/00c9f3c59c3164c20d5b1a13b1260f06685711b7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e8e665422a3bd743fae8b74dd0bf9ece3c196d0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d58c360328f406903779d053a5ad906908ece4b7.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e25f13346207155380018e0e67cb8369f28d504.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/528d7e26f9ec6ec7dab69f33fe10b8cb4ac3f791.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2790d68a61e61c5ec5fff433ad61815e9a55824.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/20-mar/",
                    yr: "2020",
                    month: "March",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9228e7e8eef070efd257694e94108466cc387687.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f22cc234c3c9422252e148910e114fc56eecd871.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5b0fe03cd3edbd8569779ddc09e6e2d0484abc8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dda717344584835c2ecc5c9197a8ef09df8d4da6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/adaabb5a8244e769bc0f71e59093238c9b5c2823.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2cc2af6142cc3bd422fd924c280578265f7d5102.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b22b72f9ee0f87513366e6b6013eb148c9d2f88d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e063ec4523759d972e1fad4082174d54c0674616.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d59fc71d52ff988d534e873c790ef1d2824a965.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e537553fd5b90c5337851bbdce1eb7887705ac49.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ac1bc9b8d9a01fba96de7fe5784bd51f1ff1edf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaad09688c7a48679ad061b55ef41ee1a2e97cba.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3699c06d171cd7ad131216e16b71dbdfa4cadf85.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/401a96eb55ebcd470fe5ae2f092ea3aa691cdcb6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a15bbff107c7367c12e81aa5f008eab9798fb89.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/329b3a90bc6d529915c939d24c56d818ba261f96.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e55b2b4e084f6c7eae3e4e6bb32a6684040bf32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c4d2dd61c3613951e3c59f06c624adfc483f14f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d8d3c85720fe295307e47159090570ae8599609.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51f016bbea0662902a0d6c5da290638522356025.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/23-mar/",
                    yr: "2023",
                    month: "March",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb5643cf3a1e76191c24b61fb0b547da8e81e92b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75d09eb47629832006a6ddf016a5f69bf2d86ad4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20349cb8d32bf74dc1da6aea144b43e8fe40355f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fffdcfbf3fa04205e35ba9a69de52659920c238b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/741ca0c2da3b5985a3a8310a94afd3825ef34a07.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca1fa3e60252ed5db924e012c32aa709617bcc92.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7cc64038e426213052698b7ec58dacc794f72548.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13a4d347f1c063f71d85e5a6270543eec90092af.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e6879e738f2d7f9afaf390ecbd332d8352db85b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b080717479905417d86c143f348d6ad13ebbf7fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/22-mar/",
                    yr: "2022",
                    month: "March",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e9b4c3f5679d84a298107a0ec601b24640b61d9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dc4ae53c85195dd3eb41a68f81ec94a8e79535a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5adc562420cde942b812bde690036c54d999364.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11968cdc2c948e919afeaf8591521d31fb7e994c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80fd07e9efcd8d5808d2be1864fefe3a4ebf5243.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/677772348fc28287fa67e2570f4d0ded99c707e6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bdd272a7a77567f3fabb6b7fe6860dc4eb0fdf46.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5fdeef8949160d383d1539a7bf925992e7ab27e1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92ccd9e71179982689fed8f75c93cd91070b9528.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5b661a47166489b6fb0c6e8f6d3c95e8ff8321c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c3ab38d7c66497185e9dc2e0fc0cd14d8b4c1dc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca1a6dfab05efba5da7f996b2ebf2dc47de177ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/R/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ec48bc83ab1fad9a602cc7adc9e6ee1a3d57f8e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89229dd817bdd8eee1315485d81f215e05e5aab4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b47745a11e2102e52cfa5c985b1a91c928ab9fa9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fff55a165268ef86beea8ae6f86d65a918fbdd9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85dbea75822221b9d99ccd9f98b2a4aea67879ce.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a83db94cc65e90bb00d8b4e6b60f403056db672e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddc2c8ccf27725a92ac57370b3af4ff2ac72f0c7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44755432ff3cf978c458d10803055f6270835152.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efd297e15e164d349d1231c6828dae4e5aff208a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/717157a5a08ab53a663e0c2fb04c340cb1c0809d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/20-mar/",
                    yr: "2020",
                    month: "March",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6934ab3ad99d05bd0f4168755d0b161780cb3809.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cc9a3c8c80139e87d53158f1e203a1e6c3702850.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11404d83902fa7c72d76a9f1da54cdaa25a0d512.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/697547a6d5817ce3c9455c4d939f7b35fd7b1419.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/20-jan/",
                    yr: "2020",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24f6b279011acfaa3dd6b301643f6011414d2e3c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4db8e798d4acefd5a3089e6fdb924d7e73b736e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ecd9fb3229c047b89d33506b9f7fa17ad8fbe83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e085d0e24cba3be2d4d2544f10e8c4a94938d4fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46c790796d6e476185b9b23c9192c8338b3f4f74.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13136d97558cf54f72676b876fab02d1ca7d1f41.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b41361f73653e5b04f0e304ad2a8b877677551f9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f2322082b0473d6c7b4f8cfe28e41f2f3da8727.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3fd3a8cf268f9e7c922761004097c6daf928abc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a9b508f5a9fb1bbf048e5bacb7de0467018bdfc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/23-mar/",
                    yr: "2023",
                    month: "March",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10f8308f7e63b30399d59e421af6ee5916437ce4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba4e773d699e98f16802eb0a0e42f6686976db44.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b130df5cbbb57a6e0a66d6fa28e60ac4191646a5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef62e421a0b825ad8a605f26f53413b8dc53fd21.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/23-jan/",
                    yr: "2023",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc9531bfab5b17e1ce118d7d7f1841d074a4174a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05b0733545e087cd6135901aaa68699e4e01fd34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb0f2e6fff00117cd395a2695b60533d7e2354bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d06e66cf26aab40e3f93d30ceda8bca8b6aa49dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/22-nov/",
                    yr: "2022",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35badb3c46195f3d01cbda37fbc2eaeac567aa12.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4bbb8692ab8c4a4f86fe67eb7725c5e0f6defc6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e493a1361bb3303fb122c00fbf5cc563b7ea4192.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ea2276f51318011e87eb4d49ec883fa81050851.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/22-mar/",
                    yr: "2022",
                    month: "March",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ab8c93c24e894294fa6beca6781df9e6fce39ce.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/730a172951ae9fc7c9d87706b9310f618f9784a9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da219d9db360b4984ae24caa9121059b91b4ca43.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad55883f17be3f8a84308a060ff85032bf7f560e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/22-jan/",
                    yr: "2022",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6b579eb1b6274125e46cde5b4362aeb19a112ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e257dd89b3b9021d54349e0ee9e0d458d7ee1b0e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/303034edb33d570325e303df16177f58e8769410.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d328e37945ccee6d1935463828fac5cff358d9e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/functional-skills/english-lit/aqa/W/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3870ce584ed272f39e12f6ca8082abf47ff81c66.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc4b9b7aa1855824738c41e8977101f1df6db40a.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/english-lit/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccbbd1c738d076ab1251931fb9890bb1090b1b0b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98901258d2a51fb95a6886b118ece869d795fb51.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ffb3b3eb74657771cd218dccacd8e6d1dee457c3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be72d4e2b8c0624a88c80b885e42dae10ecdc7b8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e4a697b5abd8ee065e862f97c377162d07c0e91.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22b49d9c82126c702d44ed7a9adde1d48ef86540.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/365e271fd85bdaf8dd7dd43f25056c313c62ec91.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acd4ae43ca580db823db7c484b1e63503c42361e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/482829cb7b1376fe972c250679ee76f3ad7e4c3d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c02bda8f007ae0865d60aec862172063dd1b5493.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1682c34c522e8e1494e3295b981d5abc661bc3b3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/992957249b336e3df62d3f3d70dac7f21060bb36.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5f9e6ffcfb04fa2f0b930fa1312d393b7a5f6cf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7470c6fcb873467f390f5bd1a82d4343634670fd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddc3f9c9a6fbb7335cdc1e8d998ede75ba4bc4a0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08b1ca39bf0687df9c60212eda6d5688b98f8ce9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0885482dea0a6f6e82cd12185c3e29ff218c0dea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/717782b6ee6188518546ca5b3e45321eea02e034.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66ce5baf460bf92894bf768e5adb4d6612ec3c48.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f98d0415e8a694f9967f11c9a85c736bc7dbd86.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b61d927a535c6cee82dc2ae757edaccdd418ab60.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1eb7a901900f53ab66530939a23caf5fc09bab1c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30ed8eb603df0034195d6b78d62c2b3e398bea31.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f15cd2e6e12409d0687ffd80004caf69960ac237.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4445d0d366bf671386560379a79efff6c292808.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30e4c965592681e1953359b0b88427f168038f0c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0b6b25b41fcef8639a33424795ea1e9437c9687.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d98dd07630159f96a368abcbfffd89ac2be0440d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b922122ff27f6765b5690da8f58ef27b1332be27.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8adcf428eb6e97511c6af09a7125caafd9167f6f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16a809cf0021b9154097a42e144579a1665321a9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/1-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35678e663dc1826c90febe165dc210a648de46f7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a902e87dd59e764d5d739c12c4abda08ee8d8b3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/1-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a4dba44d06daf6c0a23e16c1d1a80d7cbe0a6ae.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35944d6ed80c160b6ace4db42482359323687c2b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/1-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ea9dd24309d93f7a202b4cf0699b15606d4d9fa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20ca74aa94291f5af8a71fe4d81ffba9bf3e7a7c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c8f20188b45a26b12963a5f5407e52d88a68fb7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0ee722d708b36dc0ffee04742e43e2ae4db28f62.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4bf875150f8291e89979a698dbf949ac24f56fe4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aec8c2569ddef2ea3e4ecc72cc4b2f378759b35b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0289e98ed2097b0e3d81c20825dcb2e17f4bc61.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1689c04940b52864d4ceafff345f31ee7015b5fd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/as/english-lit/aqa/1-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/beebec92183992e6c56198199afe6696775519b7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e6ffeeeec8f838e1490c2aef6ca7feca1398c2e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/english-lit/aqa/1-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e75ea03212c4b68bace3b5b434a573ffabc42a51.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a3e2045f87c2a9f34c55fe7caf57b681901e604.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/rs/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ee95eeb2d5d3e4e64401d9fa9fb631485ff8e02.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9def506f9a86b3d99670ddf5ca01bb6bb7d9ed9f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/98a7220e63d31bdc75f341dd1a24662ab31f1068.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0adfe648e09fa63c01401c45eb43493ce8ad401.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/509799ec9394e5a3f3a1ce9908733e5907d94a8b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3846f6fc6a7a137d475af01fcfd0d12d7ca4429d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e52c9bcb55fe82bea1723bc4db20b0388e39d919.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cd60295a10a4cea5a5be0b4b9b0b7ea9aed580a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a12c210ce814d1f8425110ec6c4b53f8507f50de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3345696a1550de8724b14d6f651f4427ec6201a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f646e4e95cd028593df48ae43b32418a5b0339ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acfa897af6ac1cc9701d73aadeecbeba0e194559.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2283869d7a5664f0ce2d3a5fa9b2c730ff06aa4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88599e212a4558e67152795babb16c8f6e4c8601.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-B/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f6fe244d92a7ac9748c3823702f757648f4ffe37.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e10a5c87b12dcadd226588e960e0e1f98d687da.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ac8f53c114fe1b759a80c4e4c101edd820dd32c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79cebdb7d187f62a42f5e3bd079dcafceb4fe574.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fb1d7ce44011622c96e95fa41000807de41a584.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3053c5647a30bf0cefb2ef9840135aedf72fcf23.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-D",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/2-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4106579534c56ce640742d09bea421f3bbc89fee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ba87d41a59be235369aff5080882a7ddd33aac0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b89903fa6fa444911f48d6fb6617fc2b7cd6442d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e1b06dd0d8a543563b9e07fa624fe4a454f005f7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-D/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2e1317199721325210de44271878db6dea3e391.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5de5833f6633e3d0a30992d7124f06e169c2265.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a09bb5d7d341d969b83950d3aa18ddabdcf29c82.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56a71b568aaf84caa11849bb23fb52ac06c9ebad.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b58ef2eb000721c0fd7262b4e4a6065cdda73be.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e254c5852b8ac081e97b892e78ca4512b34d7db.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad1c50878f18301665f3b8792ffec66fcb0b2bcd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f4ac5052bc93c6ad1152b2f8aadf40cf6e8a8ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e4acf9da027507b3b8c5e0a8f4225ba07a18397.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/016f0a7d0a3feefc7c3a91c466c0cec12236e922.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d2214997d313d7cea0bb23114bf804300414ef0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/818d1798bbbb987e6394e9b7a2cf7c6f7822beed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4976cd6f52d72912980ef2f54d9310017970ab6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9d645c48f9440a36c415786eb5d62355db68de6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8f9d24ac4741b22ce77586a1c12b259ffdfcc3a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c6ef727906e71f55dded0c11fb041901ae67ca2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-E",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/2-E/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bc3ad99a10c5dbc475baf535f81e7f16616d71b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c21c349b30346936e5e7be8cf52cf82a16444587.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-E/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf8c0abf01129a9d02bf8395df5780427d3682b3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7419d6b7756e6fb9644bd474e56fe7794d0d662f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-E/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7973a91e14a2ebd5467f01b7f98a27f90d91f531.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8fcb323a380dc93498afd2f6a9cb52418cf0131c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-E/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f69a2a47f1a6587658797285f639b2b77140dcff.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e99b79f8e3c64a5876f00e13251542b5abd8b8b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-E/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed34acb390a20befe97dfdb4d5ed0ce5edb54a58.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ded766b88b697aa616cf3b94391069ccabac7546.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-C",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/rs/aqa/2-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee08cf313d39854326372263b5135b7f1ef594d5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c04750f8f13831abbe59d27cb3989c74d532d66.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d180e2e8da57b26a9a8f75382510aac73881238.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3afafd7e22727bcf0a670f5128a29e4e0e427120.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-C/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f629ac787a572e5d1dd45a3f603eba943104a3fc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c756edff307ffa6d2e198555f2ffebecfb924f6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-C/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2c76d5f2bf43cb600bd0a67adeb275146d2b439.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f25b388f11df0b208a92ee72506d97adb3d932ba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/rs/aqa/2-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/238e793a1de185b98413507fa3f3756db488b4bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47d0bc8f86dd359084908920c3207597adf994b4.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/german/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/489f7a139c88a410c08508f9b54b1e69f252bb1e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/901375f6264fac0f34ba02a73ac3c91738a72b64.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/W-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a60ced71de0e3e8e5e386d5484fc6615a604c99c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4190a53aa94db00dc20728dce26fdad7191cf6be.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/378929ab4704f54330df672cb2843447b55f455b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cd98df1ff596b2653b7f524d63efe0d1e8b2c3f2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8cefcb7884b370cca6b2377e8988e96686d6fe7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b1fa263e0d20c6a024fafe0558ae602ceedeb9f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/R-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30bba87cab1690bc6eea6b0fd8921c9d1d31e82e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3ea228ffd82cf0f6fee36ed1986581a44b60ec7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13b2a199199ba88f3ea67bcd1075caafdf6d0a05.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9a2b3bb1784cb8bb0b5681b5d21b618b2d0ea7f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38a2b3d7457d0bf81ec87bbda8249ccaa2347c36.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f79c98cc6ef7cac2658401b0a7463ee94858d847.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d020d3ca1a30d312ff196ed7eeda4299d7f8c30c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/L-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/700d82276226364ecfd296a1ae2b1b3fad0c71ab.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/285f9160a59889a065b92cbece00513b4ef6e1e2.mp3",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccb83847952f490c1e1a96d73d574729c1508f0b.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a76baeb5497c15621071303b08e4877896305953.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/711b12374f48333ba552bbdcdc27ea8ffa17100b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/85118344eee58aed1f3625b83858e4cfb9a88ec1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4453e3f2940c2a0ecb555ed3bb5ef8ad520081a0.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a64e7cc22a934dbdbc3b8dec887a50ea3699a27.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d6087e66535e90ab49bce3748f04f23cf2ab89a.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b590b1ca99cdb6626ce13b9fe38fb46ad689c07d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/621bee943229c69a552b477486fc42b2aa73b78a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/239180c68ba5b4d271b0cb8fc9ec0dc4b1c1f4c3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2136f264c5a186878292b3048666b94770784a19.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/W-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0320f2c0dcf088e51415d2ddf1d8f3a42bba766d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31cb64da1469e0419df64cd4e8710284eea82274.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f8863fdd139c4760a4aebd8316bd78217c4ee54.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16fab7a09b4b894f13646b8e0134e278dc04b37a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8191bcc40929c5d9806729d00a6edb7f35b54726.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c39c0c90d250b5069408adfde5c17ccb5e6ccc83.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/R-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a670256095ec7bcd54287b2eee305d275445d36.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5cad3cc737beb62591a9ad895342743c1ad78d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2727447ee6b030394ca76f8de95ea118fec7b98.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/566733375d0e24f9133b4b0305fd08db31b3707c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f9b908f09213835b4a754ec1be123fd040ace40.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89619483c6a40ffb707e870a7417cbf1a1e650fa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bfca0eda95e302238fb7c0b63f3cede2e9a6154.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/L-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f104cd012a8d8a2414e0e2da06c230cfef6d1df.mp3",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f38cef27f5b7aad860a143e8c9c82c6dcff61a41.mp3",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b70e53ece5b6ab57ba55315b7764175ec33d8f58.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29c991f41458b48dadff420d2aa8eca320403481.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6795b1c5a135844e209ee3f568187d72014ff6d9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a6751ab0bb8920fb3a2fe21ac6ef105ed425c78.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05f28540610612ca707ec1adc96912d9a5534efb.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/704f969af165d438708905361ec6ae2fa4822aaa.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/31e30624fae07c0cf3d6292e73aee5821b646505.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a60837a62f2a9704384509799f1c1cb8ac49925c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69cbfed67eb97550fe3cf6b518209d33358e2523.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d0fc785cc63672e07380f6e4a5d3daeb95edb75.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f05ecaf25affabf40b70964c2d7e30d69c8f7862.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20bfa40690ebc98df497d8f0f6fcfe9529a665d1.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb71cddddcaf7647e679f9302d4be67b5928cce3.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0500c88d76dd240886ecdb61e4d7f1338fa0e05e.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9414dc44a203cf0c5758679535d92482a33bd46a.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6eb7be451c0827ea82d8e35d4a7995766c207e26.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8067b15b8736d5e223aab85cf24844b416ac7dc1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f08232ecbfe51bbd40dedc55ce103a2451fe8a2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12c4029509c86652bfa36b743bb0a52ecced5a04.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38d86dcd69bf5ca6385bdd56900fe098886ce73b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64f1622e716e4ad74333d972630868f7821f833b.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db9c8df8fb161ac019f5d1ffe6f82c19ee020b47.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0f6e4ca81b23092f589dbf9336decd2e84fb23f.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/460f25db47f4814c5bf6124028a0525398d0216f.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e43e696a2cf58a4f0cc09833a1dbb291a514290c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ebb64b1b2cea00b66b6fbbd4d1781a8e8f504c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfb79511da9955c69f69635d0abbb0c7d27825b6.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ec02a70bc01623e0b814b778ae856c6135f9251.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9363d7791898acd9bb600dfc554369899809375.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/076c2f68c3f5c53cbb7528e60101762ab7ebef66.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ac2568dcc751a8d3ca5e9a0b2a8b166d13f67b2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-FH",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/S-FH/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b260b5c07ccef15420a267062b90bfc2a26454f6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/152be26d7063e2fd633289bb076db02bce20f3a6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbe368e397772a0883dda55431de8483f827910d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6db0779ffde5656e8ef6500d87a2b27e6642c2b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7cebcfd24a911772b33ec402a6a16941a6486a0f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1157a2fefaed18565627bdbbe980e77e32167966.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb7fddb7c6c114275e0f71a1df837f0b1a547365.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b9d277d0a895e71811f14d963eb96ba35259aa1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36febc6b9283387c834caebf7286ab324f5f219a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08ce4021d186a4c32e00d1e7d62ed33356180bf5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51b4c1b554b4fb4c1cf489bce9859efe59636ff7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97db7f306a3230239386deaf04e1cc6d48c10df2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0e9abf5590238f74d93d1be349b377c38321707.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a990a60a26acfbde23b8054e20223fd0fd22a473.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e7f04f1cf4e230bb2228ce8e58e12cb398b1c15.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b6f39d85489d865dbc8166c60419165c727e4e6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/754cce2b6111757d00d550af78b9c10fe64b78d0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a32f8084658e1727674b4727066c371df7753d6a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6f61d0d72f41dae30738a96450d014a7fe6ba1e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39c98cc67a0e4c91411502360b864dd54690f609.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce786a4deb68c9b55e8118a81d547251b3954945.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4383bd15ef34659a8bd2b07199b2f5c33eeea46a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/german/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41b6308dbe7d2c57603b4f66c5e7ce5c9b8b390b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef7938c8d3762f5843cba8cdb1e420bb85939922.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ad4aeb2b1f89f13d1fdafdc14014abb4105bc97.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1efd5774f3be79b64418d9232533887631ecf913.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b79db978c5e1fd266fbe5f8d7ae31fb179fe28cd.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/2-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6293744f51097aecfd2a636d1f469745c40361b1.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc55fd2fee4357aa8e444235340eb22e5ad46d9f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/11a5417280825e20257bce8b8cc727e4c2bdfdf2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/813eaa118c621d2a9e7ec86cb0a35c19e46e7a3d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61696dc698022615e397eedbd8af722f40f99804.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e3707f845a2e85bd03d0923002757375ede887a4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0ba0ec3a44f0b0dbb84d5ea2657f21ed9410ad0.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/618240109d62ec521633a93df029215c3e5ba7e9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc87a271b7833e48efd89639e8dd35bd862b1998.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2cc9cdaa9369d3ed512d431cb81c2c8e2770f8c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e8aff570965d9789600f963e95e015fcdf39577.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74ddda191363e6efb057121df86d55474868cf91.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/996ff1b840354ba5d49203ed8c0a178c0a89d2af.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc24e1d072de0d1efd07aec0f54688980e774c60.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e650049e86f350d14ac35702fe2e0b85e8827d3a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b06d5808f3c7d57de5f5819376a1d664a06df852.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b36a9d12a88c986f297e422b9db0b4b48d277fa.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06f12d77b0cb1a292a2662a5d0b5574ecbaca8e9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/german/aqa/2-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66476655f7050c9d05e6620490241fcde863d5f2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f03254ee3188a06bd6fb3055d33b49b51fbc5e8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cdb32616bc45369febf989b733db9a94043e0b4b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4ee6d9f97a19cf8722b125b3dc128b874eaf24b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e89c6f0b90ac277383ccc0554dd33db8dadfed8f.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/962797c9a5cee5989370783430edf50060b2736c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ead6cfb66cf3cfff016ec373f1a04b63e097c915.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0676fa140e15d248ccbd9f9a7fcd6599c00b912.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fd3d7dbb0ac209c6e246075248e8df65947cb89.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/00dee63b2b5532a5cdef3430118b10c04f1f1622.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2a8b8b303400c95148f2d93178cf505bbfa8705.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/954ee79e50a5ba7f77cea54571bb5e9fbbd9d0c4.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/157c178e3de1f244d3a23cd232d406aba943ac42.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4cd792326dd1e60bf48d728c8d4a5a42aa94ac8.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/070007b7b53a26b22d85ebe64e3a85d932a12b4d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f0557ec4b5015ac132e72d9493c65ac2af548a9.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfe3d0d82d8941f075feb3fd25bad1d7b07e65dd.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12de1b97cff75d2f77990862eac83204e983b6f3.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/philosophy/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/philosophy/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bdb66f3f0ab747a8f5008f1923b655bfdda68981.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50c75d3e1a93341fbb3eee444740a700b7933618.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2969366960f05e0ee31952a0f51761bbe644188.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b4f3d565fd0d5b1b6a789796cbbac1865a5ad51.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f53b34228683324034ee0ed93a117e5f815ee2a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39f934804bb8480bd4ebe669a878e430f3c67a18.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/912e31522fdad20be2f36cc8cff66d1fca8ec6f7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dbc7a1c7700c6521eb412a5223a963b58bece48.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1974f86934f7aa7119c19540721c1707a55299c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6f7c2ee5c6909a95bb045d9aa21d87bac364596.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/philosophy/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c3eb2910c3ee26603f04f3866b877407c053fbb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06aab841b03d9a786b529e2e65600b8d01477c9d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/268a46913501f49b18ca1e87cc1813facc1fcf86.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/14b5be690f17534d56193260f19db0cb1fff20ce.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86c4881cf0a4906c09b805a4d4996c4dbdd86587.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef8032b57506590a25a7a18329d02289ff4e9cfb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51681751fc7a7ff3ef98d9a4095fbec33f74a586.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e416f1ecc78647a9b9a6d5f28e49fa542b0ebcc9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/philosophy/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6f4f41e7eaf777020162d19fb84c8909bc569d9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c94e953ecb144636d315d766a588a68b25bc7aa9.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/pe/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/pe/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d09fefe8c7271047fbb390479ef2ca5152c67a80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2f03cd99530c5614a8d8cbf67e89410f55d03a3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b94489abf287d86358759dc0ea7a0a98c196b9b9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d50bb038b0dfd8603534bd2db4a11c2a5c5135c6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a8254dad9d66610ca633f5278d2193f737c3af7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec315fff7c78eda459a014dbaf456a8667662916.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef4b4f2650805de1bc8b4cd85c214963d4f81c17.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e475a44d8ade545ea4e327be9d244ce1ac965e02.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4428f31ff06deb03987d786139716db4f7fd968.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55aed9552487d70e849bb08348f9f3b1e2571e95.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/pe/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2dd5ec40e7dbd97b82a94233930870bc28104a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f5ebed310a4fc5f99830e41078d42e5ce38cce1f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e52e7c832d39b06fec7e707dbe580680ad210e63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3536d27d11426149baec2529308848f6116c5d94.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a5016af560a2340436f5079fbdd0189005d8a68.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44ad90a76430deaa5bcf98bfc1233f10c634d3a2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66a0278328812b1d41b7e044c671a5bf38418dcd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/933a857d13dfd1502e0e54a4d2d1722edff70d0b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/pe/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d912b309f612e2f194144f4a11ddfd17dd1c7726.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15ae633a32d484e20c572aeca7590562e15328b8.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/design-technology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/design-technology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a4b945a8f5363ba6f6626dfa1af99d655c7ac93.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5654161c1285b9a45af38757d4dcccc9280fadfd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db94205d8721fbddbca638fd2b402ff8647c7fb1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8a77d1fc57060b63510b7871bbe5b4c31fd0e34.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/479d97c69dc4e34c62c8ccc4eddfee7c87cff820.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/339c0899624004783c4c7fe9b31093a64d710a4b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b87fb21f522a4d896133fc236ed0b0558bf6c8fe.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe2653341480ab6ce2ec0f93c7f4299aea964fbe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87769a53c81c2c51cfc707ce49010ffb4e844335.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8e35dce94bc76aa19613915359be21321f54b96.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ad837226d5c1c2ba767177a9e147567e411d4f0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cea30722b43403de1204c44d3f2d3f87f9e61400.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c52afd8a792d48bb9c7b9f001b0cc2fa90379c8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6adb4ee80b72cdd7d38a6ac2383e4bf67a589f22.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ca46ba387e4f726b03b5e74cd50354a538c8a5d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97c8548da95991ff55595c93ffcc2bf70a2b20db.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24be4078b2daa33aa564efdae3fd56c56e3ef3bc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e1a6fd3284f70cd57bc1fbe8b68b8d249478cc3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50b2c3b27601b575bfec92da1dd2ba27e486960a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45447d686c09332b4a175d5900f5b7c00f365469.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/design-technology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60fa25221cf09c9aca2323cf6b0e4d94a13f6343.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c9162b9c0c0c6a50e4859a561805bac82be36764.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c59d3e6c5b40550617b4ccaef9e6ba8bcc51ccd3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24615679815ffa6c95b5078f02a27e6db929df0d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a74b8d64909cce7a43ecec66330ce0fe19bd66d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d027fe02b4374e06d17cabb35e16619a4792ba0f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e12a8129523cafa539903bcb88aac27dc4155c7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/182d576ed208d5aa08b363b54ab5ec288b7e3277.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/859424782de447be7ed301773f0551f49c2c7d2c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5013329cc7b90062d43c6c514b1077e549d5ce1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c911e09df84025c29414a8087e158b83c5d3ec04.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c45b4f0f4c5cf838d1ff47eb8aaa79ad73d9be6d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0901821537be944e55b4b04a7f5e88bc65fbc4f1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe6c3f06b354c30f77438ea44ad8a954fd08c3f2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92c7d932f0b5f4651d9770bdbb5c360281959ca5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9edef04c29f16b2947dffa95aca79d790ac0ab96.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/design-technology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2db1336b72c7fcbfdffe142747791f1e8300f9c5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5d46a9ebbfea276908b696e336bc738b08be46e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13659385da73361a2ad1da0f84d7c0d9143894ea.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/391432f3cedce73846991daabfce89e133db56b3.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/accounting/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/accounting/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4992f28f25ae952e195efd30589392334650c72.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c82382a60820621906e95b0374341a2ca631c7e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e443cf9d2e2534157e8215a02d33c5cbe898684.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4944256286a92456b1f0a14433b9eea2c0fc9040.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89d4b235bab695eb2413beac383fbffad6479286.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6375cfaa3afeaabe198af0dd085ea78c3e6a8e52.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e5d8fdaf69b07b3357a7dc5b3460ee6cc251b934.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54e85114ee7e4c5603aa35c2f726d2be8b7be644.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56eec7b7e096bff01a322ba915dd380926bf3112.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04654a5884de80e5f03b08db7513fdcebbd01f38.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/accounting/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccf84902fb4112649999812021b2548d0dc98a83.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/522da78e1d731a3eac30b1b17a40f294ba2ea594.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2c2c514b572dc28f35023005f3f414b7453ce0d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a75672b6abae856762a90a9e10f2b70000a2f224.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa32de7d31bc8a92b29e9b0341c9311dc3bf26df.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cfe2a3a4a4d832d41a59b3cb8f5d0f55740064c0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/657963f7f613e78267bd1c68732f7b6037e286eb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e2515f4dee71819d5804e544ccb248ce181e272.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/accounting/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a11b923adda8b0d083f082dd62764df79da9fc6c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34320884c8373deaa0ca3b1e31e54bc1b0d01caf.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/polish/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/polish/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/204ac8e9386236b06e5f6714ed446a23b23685f7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d51a306444c326b4e1346b607da0417e046d106c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23d9c22ca19ef8bad5e571bcdcd2991964bb4f65.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bdab3426a6b2b001200a48513b1026b78296529.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbea9025501d1d86d96f8c51205dd56f0c8d48a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58ca054ae1929ad0df472a0120a975e5d6f496f2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20a59687003aceccf280975933100f6c7e1603b8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2935f786717f45ed316eee48c3c4680da0c0c03e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4cd0f30890dba56f54746cb41457f4a2233c0722.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/515b96e622991e0390404e2d5ff00ca534ec2e75.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/polish/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/141097ebad38ce063424246abe0cdd0589deef65.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90ef90526bcd608cd5fc2dd8f9cabcc2950019b5.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4d5bac9dca135d8236d14ae2b7ba995c7337ebe.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8eccf099aa4aff130f29887ebbaa918b3e61754a.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8aaa674380e37ff3cd4266f250c0467e1b4d8aba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2893b58880de5d94a458d30b0807bcf256396f4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/abd1dca321afa174445f446bfecc16a9ba643b84.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/053def7291c4c21ec4afac9496f0029b223fc5a4.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20cc7f82f1aedc171732914bf7b12d5bccbc18dc.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57451b0aaa0d90c211c0ae6d2ec7c13dca51f72c.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/adcfd4592b472881f18434f9c9acbdbdc486a61d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29594b5644259ce7d86e83ab91e3727c880099f6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9545ba6a540238f7bb76a85c2adae45a54c04cb.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a298df8b0b82be4499d9794e194532aaade4f14.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f23d21286c734b0165158bf8b7811c7d45b4e690.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47a3fef855def028d8fe2b130343ec1c7cb15dcd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b989b361dc22b4a45264f2e86ff6fbba5d09f2fb.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec3912ddd16fff8542dfadf73bafdac8a62c0042.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a9161b51cfad1ffb68981785b352290f1474902.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45fcf748e77e2c03b09e889c369308a60210b55c.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8f1164d2db378b835ce3261c79c1a102f7cf222.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4abff8576cfddc60a14f2851eedc4f9a3d5e04ef.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9cf21bd72f514b35240444a252005f2f53693181.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9cca301f909f4ac6d9c70db14f66153b35c8d7df.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/polish/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da864c994a00ddc51416cc2504869e679db9e414.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd9e1c5bf7a4d657927aecac1046e790d640340e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e08bc570858a26865f9e3856d11fb5c5ffe6307b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/37bdc304a7e36f7c9f9e71d5e61efcf6b9c02637.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/516a2a3adb46c2ca7c4b7a8a0340d7f7ca685bb4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4eff7d16e569b996899c3081124648cb476b24c5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16479680b371d17bfd59ac87e622335aa5795a31.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e47942b2d79e84df31e9fc901c23fc45b5bdf313.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/polish/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1079099edd728259da8427efa9cecdc5f19cdd0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cc33e085ed805db2febfb7abf5e38ea774b2af0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf524464dbde85b5435fe00d4e806553e4d42fea.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/env-science/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/env-science/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a88dfc70ad6f724c06cd61d1798ab788a03900d5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b604a38517e8eb43e0244d1b6ec46883421a039.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cc3c6b551bab79d2e6084d8edb4e5e6a7ec94588.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d3501aabe8f67523abb14faaf9b4b8e406e10d1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7155a147c9f7de3d03ad3e1c1cec21369b766048.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cded5c1134788c6bf8ed5c535f06fa0551cd5ee.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9ac37d5b2dfb5316e875da40fcd60c1058ec6e1c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5cb94e87a99449ebea024ad9b58dc6fe1112dd7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a46ea3f2d1db49c7f23b470b6381897f1faf4ee.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8006bf9a09fff0bd7063513cbac34f78865668b2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/env-science/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a599e258782a846abae324a0f0691702a4d3ee0c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/087782ec99f1d675086979087be5f7117abefbb4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60cc4217d9b982b41d1089b3db0f489b2e343f90.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4363c9e7fc43d3709c444ecf7b3cba07ace04763.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dfeefde1b6499b90491717a397272624541be826.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f0edc587fd30fa3074c4a103e4b45c2617c0255.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbb25868f22553a72493bd742d812b4eb25d71d1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/058211eeafca51c3614d82df6afe5914cd038ebb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/env-science/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88ecd24c71f468fe9091a7cf31f3c41102705e81.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bdcbd63898837e2d08c46c4d5da2c2f3e0574a7.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/biology/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/biology/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1cafdb1910459514697cb4be836a8880aa33af64.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/21bd8032de54852a99cd6e118c09f0849f7a196b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/862f6b3cbbb61b0d7eaabcb5b28e336bdff93e5e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f987acd70736cc1cd34e5d07baf0786e28a0908e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32ff0fd0a62e2c651d71fe845843643d7b327ec5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55160e8cdbd0875b7345de2fdb27e0ed698c6fe8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b545daf848e33f6129ed8b5dfe254f1894c3ba4a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ac3a80ac3ea8b8b5773cb57cd3590804676633f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bd03d882d7f20e002de603cb20bc8b0d89473c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51b894653e3a5c407b99c38b1078a53527edbac2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/biology/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddc6fce4c01715873805d6118a1cc0b29af71db6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8313ba556e79d6002b8485ec7d5d32fc59f3b322.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09f75a71090d00d15997488a4d27a09ed62c3ecb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/706eb80f5423cf879efe426a3bcfaf6792deb41f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/608d3684331e60f6c32ed8c8e128e3d8e8c471c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4879141b6e4e0322c8cdd9c56b021a0a7402bc6c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50b3fd4233e55c5ae613968641ef5dceb7bd82a6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70b57d8771e829d7c502180fa9e3f9e8cc5d13b1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f6486a51b649ee283710963921548e4f46b69e7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f962d50a19a51eea4218b86eaa5a616d42f473e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9006666902b221a84a55de961a3edade56cbf64b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6740261209dfa61e015f112ca6b1d7ed1dccbf56.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/687d97259b80a90309b9f9206ac1c606f1cf5365.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07b2bbf5263a7ac0536b74c0259b3ad03ad85ed5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/biology/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca5274886c44fae6f69179fa3fc59708b966a255.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66f03ab4c730c859a93f9d2a50f53c2d001111a9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a1631452263a13897b5fdc45419e9925dbe6561.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c70d86fafe6e330469e345b45eed176790016b23.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c1f78318524c61debad2041d316dc90d3b3f354.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afd9052e71d6f681b62b2cdebe171adb76825291.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74916418e3db25403a38503a8ff4e5c92d52f2ed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1fc741df62ee288536921e8d7d82e617f175cd3f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55eb959418e3772aa3053238e05e8ce35e0f3e01.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/908a63ac593f919d234ac2fd5bffc91cf974964b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e930f465a6ddafad3b7f190eff904375b0d5a17.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad02f966f7c3c094bdbce285ef3a3d6f49c143ee.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88aa5e4eed79366261e07c862c3d70d800c98e69.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4235e1401b041bcb3c191eace986e79c5415a11b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/biology/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6daccbb80fc4d072f7b4bdb2aa07aaa704c70697.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcb39349e885695e74048dddfd76108825249750.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/music/aqa",
            pprtypes: [
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/music/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec735ca04f0a3f8c2546d3077fa145f48190fd7b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1b1524376ea327e5ed015514713619774905792.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/music/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45a8b92e77bce7eed8b36043c8a7d92bd0644edf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4a8799424a343b71ab6aa72221c5e5736c867c1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/music/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e07b64c2b252fafd8a5809377eeef71bff49e13.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75685f31d7c86ff1ac0eaf469d29796277c1a912.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e7889a7a62d23b7eed488e4890bd276c8406bba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/music/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7906a601b8e85f11e2823752ad95e2247fe7fdc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f126ca1e6758b329445ac57bcf936b4c74c3827.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8406859187894b34e482b89f2c6f9cbd587fc850.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9f1d59f730b9f2124a549477d702e7bc32f7cc9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/music/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed24e00ffc276e1127fdba57007480f2f4aed851.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/economics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/economics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f921f15de4af4b5e4af80cc168834c7f7ebe98ba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2c009deeeb002509a05ede8785604fe42b19685.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc4bcdce1ee2247c3bc947c2f3f4a85816a227a6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82a75538c5ca906836f8bc4a94f2ca053bd218ca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa1ffcbff0b23fd45e1f89faff1834e38b0862de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bce5f4df0e71e53aca1e9b9d16297f3695048e0a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a0b3d645479e3ae8e4c1b996e0dcc699e7693c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6afcd00fbc872d71b800e8c60b83ce5bffd6546c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7237e998f1a7265d7290aec2c00de3f4ca5c42e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1971c71494d2ca7034cfff95fe953cf7f4b766c0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/economics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/43bfd46ae93e91cb88b692d93c7299810be99276.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b75fcbc33a684a7648ff6634dc65a7f5408d79b0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c444223d61fc81eedf04b7d5906d32817f3a46f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8257cdfc8e8329a12308df162c8c1d55deab6e29.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/424bbd5b044c17b1c60169ac1c9f8cde5b484120.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff58c5b712ac436166024f4309e5fecad7ddb2da.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61442c80a366c30c18629c04dad9cad164773cd0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a08d6c09a450c74a3fb53e20d2b32372c48b8829.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/economics/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b9de2b294d4a2648aed3d7fc45e3a6ef68d9ec5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12f23403f1dcb504aac49f89ed698bcf45e8884a.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/history/aqa",
            pprtypes: [
              {
                pprtype: "1-C",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-C/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88c422c46f3224acebb77236a0501578ac84c19e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dc0db93dc9d127f931aca4840b5cc574f16de7c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-C/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09ba499216471737c363f906ab0cfb3ebdf86979.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3561e517bd5a0fe73a452824e58b523b50d68c59.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-C/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23174d1208f8310e65a018f78461e6c1ebd7d209.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca8c9d0cdc5148222262081a6dc20b96df45a4ef.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90ac10c881c4090ec3a9eb37f853f35b84715825.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dff30fc17db14c90f8ce397d78a802f3d9a8d717.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24cc0c40640dc568c65e75333d85b02adfed9446.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/add43f58a44a2306e7a3a564f40894949f1f961d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-O",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-O/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cea35e38fc4350ae984d8c8ede1c5bbc78456188.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fc143f272186b9099553162b6375d1df08c2232.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-O/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e68537cb4cd469785352b9d4f049fd520c8ba6a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2b129f394ec2d281982c56556e95ee9755cb9f4b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-O/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2de34c696ada395062a824a6bb00903be179bcf6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aed0009ba6975e08dbe88d9f193c697eac0251b5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-R",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-R/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/880ec3a05ef066ac8332a2897668e726237f579e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8bc56eff080cb960875829b7d4a3a81d41c5919a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-R/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e31aee5224388ed91fc535b680faa89b57604739.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f3e5b9b6a16a97615aff0b94e6b00a9af8ea831.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-R/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7c46e4832610d5cd93e0019a1d84d5d20336b90.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/111a4672908d03048d4f8ce0c4cc27da4f4a8d16.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-E",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-E/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cd26fc6ab16411ab5c83f0b2eaa263f49c4950f2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/609cee7a0ac84f6d7d184c8b6f1166778cd4f5f0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-E/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df95c60e2de16e5ce0b9acf11e506625862d3d20.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b973e462b0018f235587fb04af3bfff22faad301.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-E/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bc850899fd473b4ece12c91ab64b531c6d80a6f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/924920386ab6b63bd7784cc9f843d49000574d30.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-Q",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-Q/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d18ebf4f24f68ab4957686ccb26a9a7a751cce2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f04755127a21861ae25f6b44fddf2e4c3dc662f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-Q/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b765b3c3313d1289b166491e15869caf1ac6772.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e2c770e05feeeaf99aa9984e6bbd79a1b431361d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-Q/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/266cd4b52aa6eb66aa2650cf60743e8b6b213399.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e5e4a50321d1b779dfc81042a9d4e8dbdc6fe59.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-K",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-K/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/27127279fdcb22734340353096055545b6408931.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e9fa0cdb65ebb249a41dfe511c41918240837c3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-K/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1882908f115ab164bb2bc3f09c2917e0d3b579b6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f3e60d478a56ea4f09e7cfe4d18f69090dbd5e78.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-K/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b68ee78a0dde8ea3f8a40e92fa6db518b89a5ece.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72cfd95110244bed909904cecb4a1ff618a005eb.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-N",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-N/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c7781be3efbd067fc0537d0398f2b5979fc8a2e4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9156735e8262d8672a38cbafb00fea59f28ad168.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-N/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ce508034f0ef7cfa777e50c703f28b1782bfe40.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e83bfef1762870bea7c93ad866b14b5fc158578.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-N/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d72bb06eb1ddbb6071c0d13b00c7d4a420734b75.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dda76964c79b7bc4c71d085e3c5c7f80f7aa0fdb.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-D",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a48a19584a216858941bc98c72766e7651a4802.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80e2ce18431298a5c43bd0bed9f3d0ddbf0c5883.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94e415f82ab9cfc1416f9241fa8908935556e4f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f0b7c4210a248d3964ec369eebc1b98258e62e3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3a57764a2460116e6f51e9d6e79b7eed33cfbc9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c613417fd1520418bef6dfc3fc0fd51a298dd125.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-S",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-S/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ab0af48ce5f62c8715929e075b7af141c9c5a08.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c3bb35ca015200defbb71f04e845b909f2e69b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-S/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55d5815d6bb97118898ea79b9ef2a368dbaded60.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cd7987756d0099f91ee03e2be73e90a3232b4cc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-S/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e07f10dda9a4556e026c16637a1e9201ad71479.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c24592be74999232a62b9631c42555daf7a73b3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8504b62bf85f51aa2b4165b17023ec6c90ae21dd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef909b48740cf2f965dcc2bd329d43fce22f9083.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bdc294c79d4b0b1f93d050902c9bbf1a8034aefa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32476fcea390ed8f84df2a2880b4c4420ede3a78.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f50ca6b00db8177c1ab1bb92c7ca6d441e02c435.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1fa1375b80d1e303f61a8cf5f33e0a6e29ad957.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-J",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-J/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efc77abc463bf471366b4d5c546a9ffa7c190a34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3cbec0d17c309b83e8ce97ecb3b2cd5e7f4bd09.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-J/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff32111fee6e416a9f9c5ab9e1586a812d5dae79.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4138e9393144f5d013452218f667caaf65a9ef40.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-J/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ce0b04eb2a9cdaf1acf35a5f065a5bb321926ce.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bc995aefb65a2e44988c3a6e5205f8b964dd052.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-J",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-J/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e95d77cd2f8de7f6ade32e8a3ee5d3c554ec8413.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/622de7de06ff24d92d939c70e5194c40943ee7a7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-J/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e65da968a0c0ef55facaf1995fefa25e3a64ed04.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02693232735aa3f5cc7fdeb1a0467c974705f8d6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/835d3f52667245072b4544b472d238fa54ebf8fa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c030a28bad1dd2559ccf2868dcbc701a589d5cbc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a90f9088d941d7094a0a4c04b6b3ba340fe4823c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83b2920fd464148099d1e61436cb079ba3b62813.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-P",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-P/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/47ac96c31c92374acb87c674f5ac3fc63120c147.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0436d2f1b4b5532f532686ac0479b0d0661f854.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-P/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/90b9133501046a12ebc3ff383ba8b104d3f2e19c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72c9ea74292cb8323c99ba9ebd57ee994802c0e2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-P/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b8cc42059414f67aeaeb6cb18e7e5f46fb61cd4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2888ecb24325cdbc3e9e45091ebad63fa14d6a64.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-L",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-L/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6316d7a69521365462502426adf1a18ec7717190.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72ac415311a79f3b3cf40c68640583ac7ec017aa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-L/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6cd829b4ea153e2513f9c56f840bc53561094a4c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08a38787de1e0874efdd8b562e9059ae5774bc63.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-L/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24b4457ad80cdf8e16a352a00fcf9edb150cd5ed.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec66d6d54417767cad89f8f0a8699594c4005c1e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-G",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-G/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/646ceaf90b50c83acd1fa3ffe6cf8fbb8cb05828.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/445ef5b10a9b3e5f306637a0247ce5b4eb385636.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-G/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9524dddd748e63c07033e3ea9fc77a6975f204fd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c5c40d7f8242b6db217248613938edc4f1a71f2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-G/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aa02ae94f825dbec76621b3ef3592b89e3b57620.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b58c47c6925779de5b095ffd6e4567fb6cde012c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-D",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8c288e48b7bcd2b0b1757f1644e6a7650533213.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4113eb5fe8992c1e7482099638a093d78f91d8d7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/1-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fcf6a46d2346efe13e58b75b0372710c95ed92e8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05057753945dce775bd5a7876bf230fb4dfe012c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81df3e15832886075f4d9c4228a37caceba1be88.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58797f684aea34059bade5094935b673995b61ef.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/1-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e644431134d62bb80cd775cedf366a3f6e40415.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b3ec1d5270300cda2b1922b3399a8ea6b037f1b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-M",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-M/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e66480009ebf5acc559d5b550307a5e0bcfcd7cc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a712a54ef88166b95705e6ec7ff8f2d90629e24c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-M/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f77c2cdd484aaa349f343cc007d5f40e3b6d4b80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/593c59f435f097cfaac386868c5763a98fb9ca79.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-M/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35012a549f1b40a2872b6d6b6cdf71892c2039eb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6079049f522ca6aa6420ed5402907950670ab60.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-G",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-G/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd687b283000a4663a7be7cc1c9bef9eb401d266.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/86d9e10b7e3e5e89ceb4327c72c172b6f1110b12.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-G/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c12e5164b0efd649ff43cdf242994ab6f120c7ce.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0416d87b6ca55ed53a7fb55d72783f923de831e4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-L",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-L/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8de7886964042c67346a9f9c512cc2b99386d2b4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc38d567047fe37e72afbe8c82ea929c014c06f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-L/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ac6cca0ca613db97cf3c65f26d46e222cb6a0c6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/509bcc7d22ca1d64ccebd9615974ad2df4848dde.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/as/history/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae05bc917a15f41df54e59ffa0ca6c11dfecc313.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/412ad54960028b69b2c6a76555663355d7c97eca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/history/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82067a49455a1ffff6247092dc057e99606f1e68.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96e8d23b1acfa388d0da8b4367fb2a50b109b5e2.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/media/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/media/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4c6a7112ee3ba2026ed6dae6ceea4bcb78f03b8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a631e84f734597e25ca709bbc758964a1b333164.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ca135e45e1eb6de4733217690312ba6a89f9f11.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/846a7b2927b0a474a8b7513507a57c03918074a4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f924a9f2c1934c2952e448f083000f9a9ec265f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7dbf23e4be379f1046c7f7b5df2d7ef48e1a2b6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8a582d3e4a911d6fa267de9fdf74d6271265ea9c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8492ff72e23756e1054f31e01f87b297353dbbb6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c10a2cd755c5cbd27c4f2a1abe5962bd4555d98a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a29b801d8e85cb6c963446ec5a1d327cb7d60ad.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/78990611436887739c5b05eea646d78c93de1c33.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/35dd251b87a27c6650153a1658e6bcbcb86a0bc4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/media/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b9dcf62086bacc75a6f31c7ed06ec89fc831801f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f6c5a5b56704c9b75fd125ba4f51dfc76477277.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/38bbfd8669c4d4ac204666e6d962b4dcd2d57ad9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5bfea3ddaca07ba374c2c326b0cb9994c7f304f2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/948c0c79380fcab468add57d3349588d599a7316.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d92742fb8c99ff6451122307f8790c6c58e3c2df.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23103ba151ff16a3b8715102cdb9943d72af287c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34e2ab3c524ecbbaa06ce12aafa72ce2d1f3ebe0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f996426e75b34f2e2423bf498b1f7cc1515e99d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ebbeb13cdb28929c82a6dcb52484140fe220cec.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/media/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec2eb27f94b23d2d8674704471146a01a63be7c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4097ae9cbafe557ea5adb467201a2208aa226985.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/italian/aqa",
            pprtypes: [
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92997602c19e698983e7bb49e0ec4ede2997de72.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99112ac7c0e0da0aa6dd7c0ef1d07ddfb987b1d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/844aa81ac000493eeb62f85b4c918f7aae7d5f12.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/451bc7c11be284e3fd5a7ab3dfcd1da32789c115.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/22e5f894bb6a0db9b3e0d1fd370f85f5eea6567c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a93d230afd9d6cd84e831f8238672de7e7d2f1e2.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b9936eab20d5bdc41f53b687415b13849ad17ca.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60be690bd1aaf8eea1f99e0f003839dbccfe4dc1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fa19383c983cf25da518c01ef4bdb16496bcfe4.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ea666d397026d6201d506b27e7f3e0bf7955024.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58755287aa5831fa38346a66c82af4efdc6be86d.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08bed6f40a4a540d44c7a58feb64626252e60efa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c03f5d79a53aaaed4a35ad1d9e0691d6c5da2ad4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/799dc27ad48748b9917c3d98d3bee498258b0a57.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4112635e60abaf20c55c5a518930df9b87fe9665.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a455cf8f9bb8fea47704087725da6e55744087a9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5118ceb8a434303869341a963bb41a7aac7b24c3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a22e3ad60bf02bb636a5c1d7d6f010981e0d8dfc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3dfa5e2b0aeca2a6dd47de76ef9672a3b61d33f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46bbbdbc3b434170edc890210cdd9298c6bda4ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce8b02092186d88673bed1d5260da3280802f331.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4e0bbf0fa7cfea7850890bb6e4852064622260c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80749c78cc81f8e232899c3fd8cbcb61c1f39c54.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9557437b1eaebe9ff5d009efc88896bee223999.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9632aea5d256d90152356d39fd1040b99af07f15.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be4d7eee3f4d7fb85c8b48df3050b046a952bdcc.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/deef25ca2802afbe3911482d8fec2bb2af4b8056.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a66a8d593121713e0e9703d0266cd97019b3ed14.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4dd133a19e5369e3eef34003a6af401119643a12.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d3a054362774bd62408c4a2eba876aab04391fd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c8d8448a25e4575d05ccb3f2084d148af71655f.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6060e2e67a2ecb3108dd7ebd9bda84303e5c095.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de4fe2b349e7772d139b60953ee11550cf346248.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09863ae48f5175c06c74022a1cbd59ce255f9d7e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89d41f05d41c2465e769b8613c712ce05ab3f534.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6742db9412a0c8fa38a9a5fd202cfc091ed32f4a.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fdfd816a9d52f8ecef4cb9cc2e5a703f7e72164.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f277a7f0c4a3f532e3f82834730bc93bbe305a95.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/595087d611008ad2b176e64d54d83ecb6922e222.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ab1f831ee2f469db4d20798a54428143fdf41557.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f1154ae85374cac77e2586d9e9170085f48f575.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ed0ea9ac83ff625cce0a7be1e94674363165eb8.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8d58170157b6b754b43de37b15fcd4bd523a5d5a.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/af6cfa06bc1e1ccc0e3af4634916b0a6e41ca0dc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9cfa78b4c6bd881281eab8dc610ed2bb7a1f8ee9.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76a97af25fb8fc3d288b11b820cbbdeeb371f4c6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/623053a8d9e46802523e727987cb87e68bed76d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f32f0d98bf5e3069d085bd0dd46191e333e80f34.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5d90c0b250d37382a12189d23051d389cee3480.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2149078e76e6da927ca4bd0cb1241aada7bf7375.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/39d9415bf133e80a68c5b1c77a1789163e3864a9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0113e9f8aabce6d0302ac53726dd75898a48833c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ea61c7bed8d643b544e03604faa7f25b330d2de.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/53b760dba79c0abbb976bd52b3d8703dbf5067ab.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/976712c0696af4245b78f8d2b2cf51caf1b2ed88.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d39a72bda0c5a3b8344290b7b3281f47be51f5c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9a8cba27c4eff72e9b52941fa6f3adeea12e126f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a78759ebde600d1ecd358f8d319cdf2214f960a8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efcb2d894d2b69448fd38b63fff219bd5192a62c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3c58ca45354f3e1dcbfec2f34b4e9a0110d2c8c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ab2f22f987ecbdeb119c0e9b32c00c2a2a70bdc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/538f156ec251868a66fc825483c9c99414e9e8e5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf5b82fd92c67088990e6b07b99170e7070fe430.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ce74f737baff8a4efb64f0883b1c5e45dd952c40.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72eb0f49244c8a6491308fb2ec788bd00fbf618d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70acbd2f88853d32ed5ee0a14edd2ae1d7a9d82f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75e7156bf6640625081af00b12e96a0773e3e0f3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b840fc2205e548e79a9c2f18c8845fbe25838b38.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e910e73416232184e2ae2eaf0db24a8c3a99adb0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ff837360583083429cdf0691bd37a91a51f5bba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2e3758d59888a0c3bbd7b81874690231d75f038.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1eb7c725e723ce44e630ce69e4658562071b4eb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2bcadc7e45d5b16432eadc8e56e991acb126f3fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/italian/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9859ef5c5f41e53616be2e0fa3fc84284edbf5e2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30ec85f3814b7f2aec14c0f0cd7de9c0a89adffa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6d4bf74932cf91e84aa85fc29cc1e6c114eee54.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2b625b675c9be2fd31a086680dd45411a2d716e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d779aa6b7ea25ffc05f2e998d2d49a51159da357.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d9181f4f7672e66b3ec6e4ce0d499823411d13c.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ef24b01efbe54a467b87964f462d2bdbdf1c38a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/italian/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/293f1a817c1f16fee5d9db0b727530ad8ca47e9e.pdf",
                      },
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66cf043a13198b66d122108d52f8cd28bf0740c9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3bb6115517dd797f6630e0e5e0d8a796fd52a66.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/music/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/music/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef1333eff6fefe0c803f4d3a807b73198785ef7c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a8d45fe4ca6d78510a5684e2ca150abdf24e524.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b77b928b4d0590d981a38e040984deb42d2ffc5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/music/aqa/1/18-spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5ca5dc73cde0c17263cd56539a82b59ba7b0765e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9583f85bebcb8a5b207ec0e3635925fbb95fa385.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/music/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e31690cf1a4a81be535e0783ac36a548aa42790e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc23afd2cfa8a9d2df8f3a05657a30801d0e35e4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/music/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4fb56b67404110e8080bba96cad6adbacfb26f33.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/800037ededb5848b8768b9d384eda5e5e8e996bb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/music/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4373b9c2a5d01baad0b8f6216cde1bf8136ec9f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25ed5fc5673ad528645665a9916bd697d0de34d2.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/music/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/614334ae06dcb2ef7082f57ab6751e81f1037522.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/music/aqa//spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e27429125e75530f5245c63508cb73c323668c4.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/music/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7803023f98e7953b4d7c5dfa0e683eb6373760c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/physics/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1611b2c27d7508c9ad5012c1875cfdfbcb63f8be.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92460ad8f1c05b840c15b2c51a7700384e03a963.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/accbe341f5510206fdeeebbe0e46611ff51e0e56.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e67a74d943c37ee2f18a1a4e925f878fd6cb076e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e01cb5353f99432c067d6586e637df25be93308.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d65388aff12445553caa4c19e87a21b29de0385.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b22f0e7093df10379d191ff4c21e37497cabaa53.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e9f178c555812e94eb1b7d0ce9506c8e0d4e466e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4b5aa9d947f2206fd3fb2cc1f9c95f957621b28.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c6fa317889b3eaed4bc93dcdae9a6ca6f7f61ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e586d3a8a1c6442001a4b72a4f2c0ee89d51d774.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/328b41b85f3abd19d2af3a921054e74d810b1e3e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07f62d9b811738e3a0065664aa8a12e43a2d3239.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ecabe169ecaa0a0822224207800f3c779cb3a1e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b1952aadd2b09a8ff636381f4fcc05359fb9ab6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a4ecae3e50433fbf0a28bc6d5038ba55ce79576.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2949238e0496a8bb57b71f5ed7f1cbc934928fc6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a08febc2c04eeea636fb1a408285be966044d09.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d21d1ddd0de5def1f13a9629b515f5e295be41e9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb1ee05ff083d036ef975c490cf382f75bb3dc96.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0d9c35e86571a3f7a5fabca0d2d1979919b85ca7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d68601ffbd50cfd7c6ec1978db12a9bd6ab966fe.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f12ea83159ebe726f43761a0cbc5d3757567d60.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73fd5fa4dbb1d7d8b61dd696036df6037c55338a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81df97e04dbf59669d3c32e6c175eccd8615d68e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/caa7fc9e14f449d8e83f913aaa258f389fb30a6a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/09975693b5dd8ea2228f3ef27453f5d93e7a9737.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d5e279c8b418eb968d73f7edc9977fc9a50ff3ee.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6561f9135fc2b924080da997ae8b00ad096fe661.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ebbe08a773240ac0d578a637927bf3cd65ae784e.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8112d1274ecbf530136d16dbc96b6eb9613b0c40.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96817820efa89da4e9abd4fd639f51cb2cf725e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f5484130edc0eb6db623067d0cec9be90a97d19.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ed3d7d3b98a78791ee7bb944e2d90537264aece.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ead562a81d65b1fc11b3ed4f90bc68665208f008.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79f917a73669af0a02523f03087d1861468fdd71.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6936cd2167f0b40cf82a3aa65359d792ef243a95.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6d62583ee3c17d1c9796b97161ea99ecbc92be9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/976c79a20c12c6d173ff6953ff8a4a2b92a0bd8c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/42f8a07fcea4e155207b1cd52e5258f2043dd003.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ed6fa00d0509ff2251b0a08272316e08877ea7a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e1cb9f971561d82628d65f8b6e443708d0ad283.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96b7a52a75a6bc8ef7e00b3dd5578a602b636c4a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/812638f13b9ae1ad0c20dcc1b961d1dcd9c5f1fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a23249fb65a7a81962604b6ef3ec7dcce57412dc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b1e1a251edd1d0a51700d1a74f4c0206f9dca7c5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/beefa58af25035e134647468530b68ad924f552e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e036ede1517fa92fc1fb066a4865c5b284ed91f4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61ef92efc2c5457b831ec982d512d9ea5bfa2a3a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a1fbfcbaef4c0afa5ff46d7353e308b07d252a8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5cc19c4a81752610096f98070249907ec2a38bb9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79506e84bb3f05f74ec5adfa9a642126881282e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d130addba59da09c1204aa2f164c2b2e643aff2e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b392d8be84a1574aed881b4b3b5df257291e5704.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/320d392566307d56122fe49ebdb6fd72e6565f20.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/89e8be34a9e43e222d584651245b002f07ca0938.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45164149ab9bb197952610828b5669a987633d4c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a855418440874a7b70751940e979f33956a46d34.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/127f0921e96c90f642314440e3ca83bd252756d3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d099cea61c7ea228e76fded835e6f627ad790ce.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6c5bedf0cf9dfa3097e92362ceb267811a426fd4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d29282ecc20d5620de10361012510395998a70a2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c2f7be7d98dd37a6071cf74672cb7f857b90759.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-BD",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bf887d3a028cf2cbfcd33720dadac9f5f4f0b61.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe136473e9adeb51b6bd892a753f8b580190d8e8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/530a2538d223982a7999e26a1a7ca4aa06ee675e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbfb49fbd022679e850c04326761b080a332d554.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0addcfd63138b32166aab2022ea558ad7813dbd7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1aee8092963348001552085ff9b965a329d22f72.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69c8bc5f84ab1ce73998c77f3a8c0ce08fc7f054.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0bae6ea4313ec1d09d3303861ddaf4c18f2452f6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/608f03e245b90ae48d8b2b1b65f3b09d86e3cbbd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3eee26a492cf42367e534404b828c0bd4aace7ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccda50c1c5ddf9967fb488b1c93ac202a6cba17e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8ef43b167c974d242754b13be0d284cdf9b9525d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd4e7fb52d1418bc52abee8ee87b94d4cb84c899.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1de4b264a31a86b711249cdc90966064ccadae32.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BD/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17d905f060fcca07e22bc48fe7b5c37e11d05981.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d28f12155d1510f5e8ba2d476d4da3ebc827a7e8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-BE",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52731771d92bfbfd37b7501b901686a3c01e9d3e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5964fa6f811f57aa3105894c643441599786ece9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76467019ca95905bc5d8afadba70e9ea8168092c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0b974940020d47364dd9adf4ffa8d14b7b9e6758.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c513bf5290b8852269bd3032b5086809478a7326.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/684f28d5191b812923b399f61f790b252a5ee132.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd812e5163903a2288d1d8d3f3e87fa8619bb8ec.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b925b321bb7e74d01dc7263eae0aa6dc780797d9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f39f93bfc85cee6bd7cef03c561c9ec2021d231b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c2fcb669caa283b57dfaf661a64f62045252fc8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a631bba1dc10e57073c94ba1d4f32f8be93fbe37.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/87f0e990817680e099e0b99dd503f8bbb184414f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a953ca8789a40a4800aa82517b56d692f5eff0a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3a2afa32f45a2f38c512ddebdb0e769d5733c9c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BE/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13471d14032dd086ea577d467aa25b0907a1bd09.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57342befc66d45223d72078807a978c2843d8837.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-BA",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04109be254a709390bb197c42f6ce8fd13ec0e26.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e9ef3a1d4e70bd7298f01f67fe9b41e00fc4ba3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10e96877c4ce93433c23248f1ec839cb37176f15.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1f35945f610510b12251c844aff5839219b2148c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccef3e6cee4e7e1cbd8fcd6b7d34d7449a3db068.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9dfba775b73503a07925a2359903e3d9bfd9fb9b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33c85fb9412cbc830a9ae2063ff4c6b0622c0d99.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9e3438a37602a2b381fc698587517a58e0fb004a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d2d147103bd47317e856634a8cb81517ddb8017.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a18e223012cf66884d3178b47ee48b25d88022b7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6edf9745b5bc7134a945de0ba0d61e17f1ad9522.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d7c009a43b0aacdb5ef940407e378e34b7f352e2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/88bd1ed853b1bc5035bb54075fefcc8a6bae2392.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b192c9855a30093a1e9d9a7833d668782d1e31d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BA/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7a4e4413e49194f3ac3c71e7994f62929814880.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2fa08f39fdfbfd51479434cb32d9169b838ddfa5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-BC",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c72c0dde16b1d763936250e358e573cfc648b98.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a60980b8f05e5c30259a56b80c039192514063e0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3737d40da05c204e4e08b876014caa93befafc95.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fba275a2a43a7ac125b9ecde6675fd3eea31e7dd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6e549b6851d644ef40c6f1fb83b1e04a3f7044b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb06747dcd4a04399632bef80335a58ac010ad6a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7e3951ff0832f4e917ad126eda0ff65a5d50ca6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd79a0ede009fef71518fb6c35a9fc4b61b13aa0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b31ffddce79e10bb90fa9a91829a6270b1aec4f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/927a6583d4106f5800ab3d32945fc3582af8f77b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b71a0034d30c51de6f51e9de9d68ef6f038935c7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da4ee84e603c2dac1bc4c0b2b7d05f390724e1ea.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3a98b011911f0a4e6bed3c8ef4868b6c06e96755.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cb1b0821896dbb300f1b806e3778f8fd16d66e87.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4d81bb9f101d3d56df009309b6431c5c39e1bfd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/79fbf6cfd5afb8e162a6eb6f1dac0477e2b38856.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-BB",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32120439ab2f629563d5cd6b99385bfb6f4d38f1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5068514a65374c55193cf110a003dbcabe0288dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0fe500d096dea02c7ec2f4f8cfa8ada9fbd60ab8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b6c124dba74cedb5e095e2721f53d0ba73472c9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/064ab1b38c17479ed4b6e34816033cebe52dce8a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3925b94348663ae56cbf812064cf8fd07ad12fb5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16c8376d4f406634d6ba29713f14e2f3b992fb91.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9aa8ac74b34c315ea3d9a7ca96be3e2f1d472130.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ec375f2c885284c930e5912d912258187d1c25a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc6a346e090d63907d62f1528652e1ace5df4a24.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4366615713a2bcb1ed321d2dfc1ea2ee8ca8b73e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d6d08a8f847ac19f58329f238ca64e94c3c8296.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/17-jun/",
                    yr: "2017",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07b36bdc1938c1bcccc9747ccea6bed4434914ce.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6198f0d20269004cf541204d54a3e478bd8bb9d1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3-BB/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b7e3e5b1d85fcf5c18d1c96ae80f13f2bb3b8516.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cda550c24e4b44080876d339de02c800743668bc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype:
                  "3; 74083A; 74083BA; 74083BB; 74083BC; 74083BD; 74083-BE",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3; 74083A; 74083BA; 74083BB; 74083BC; 74083BD; 74083-BE/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8b1b7e17e3167303fb388f78adfa000b5b862b22.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3; 74083A; 74083BA; 74083BB; 74083BC; 74083BD; 74083-BE/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef76c08fa1891694dbf4542348b337af0949e981.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/physics/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2dc472d80162232cff3427f736ee59e253e618a3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7befa17b1940a494f748fad571aa610900b7804.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/99b4ed2e8b6662243cc31788ed3d2b8ad01c91dc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/physics/aqa/3/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2725d4dc6756bb986e5576d7525650346051e207.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/dance/aqa",
            pprtypes: [
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/dance/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fb620927bd51c6edf642c26f5e1d37c4e89a987.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3269ec87bcc6728b31adb6484ad00ed523177f85.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/dance/aqa/W/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae94cfd8a5fd9fedcd8c979bc17e511d60649cda.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75573253f5aa2081c53d2acc18cc19720ad799b6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/dance/aqa/W/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c518c439e92b1345d427feb263779069465bed5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59139fb4f6f3df8cc0a867762ac135e604b79902.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "X",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/dance/aqa/X/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e75c235f7aa442b49c6256b85b76c074b608b041.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/dance/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da5f8e7aac162547d14e8d994d315b34fbd89213.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d1d8ed24a159fbe34153f430dd312c4ba9e6c5ca.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/dance/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d8383ae53559e71145ddd078d6bc7539610525e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c94ff0f25edb028c1a98eca475b865f4b6ac6215.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/maths/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/maths/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/522477bc2fc5fce56d0426c7dd5dfa1416017166.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/28c5fb592e99937884f171877c4c92f2f4196e0b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da1cbaf82cee519ac5f24d25a694c51f985b8fcc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e8510ee90fc646b34543f8384c0195e9abdbe3e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7662c6deaa380ed5acbc4ec056d38c9b218f5a63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f81d50570dfefcb1eccf8dabe2f4213cef43a262.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/114089d9a925de0b73d9c11d6ad6e825d439bbe2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d8220485453ed7f52cf92af2fed7d8363a5122c1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed05a523626a561d5b827e2e45a638deafbe876d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/245f9567af752fea9c21861ce03aa6a60c92e00f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8176e98749858bc8a7d8e657f97cb04d2f88459d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a3fcffa077d8e8574dea0ae91371c1f95c03dbe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed0642438318be164d4f1f6bfe234a93e4e58fb4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/430f333e2910946581eb74cce61114f835fede41.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/df755ba85e204677249687e0d4d0e144614aa3f2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f94471c3c7ef1ab3a32581c7eee74de8f6253d73.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/222a46d6eabd638af35ec1b23ae91b7a92a369be.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca1ad82ba82e9afaa25adaf439e142f80d138902.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e81db82a4d510b12b2ed454f74c306fed43ae92.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17bba7b919ec5128ede7c527682c9d718aae58d5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/45c33d858436ca6868beaeca3a0f63e3ce8c9ecf.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c9e794a33b1a7817b3d735a9c0983d0b96ae97f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4533a95750b58283346c5fd7da684eca26cec48.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4310e69712e881a2a335569099d0b3cbc067e892.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd092d0ba21607203f6a699512f0a17173ef599a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbadfa95a71fa53782d550da25721698ee4917d8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bb735da2698e96d9d43fb42f03f312ab34f6182e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/67bff7534035110a432d31ef93f70b28a062cecb.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/maths/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/60b863dbce60c59201f0997061b47da2690918a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b68feaf4f3a8cf7a8e5937f1a5a2bb71eb03c29.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bf5aad2d0f844441a600fe60a2b878a2dea6e25.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c800a9d13ffbaf3779f36a815100886a39fb30e7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/48ee25e4978e8f2951e02676aa18c9c680f56623.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f8e6f08b4328982b22ddc0b6a1df1adab940b57.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9deee9fcf426ce80c7cf78cc4044eecb6e77204f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2f9a0c50c6540e5854458129ec67a3aed9207ff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77ddbc79c0a0a5771c5a4a73865af950fa5dc4f6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/68a0718bff02ef5d269b9b3062a8cf6f58460a51.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1be48e8a675ec30224cbb76a5c09ee557f1cf3a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba02b617b9c6f40f3f19c0ca1110d8233678e133.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/345f1b03e48b0c73925fad4d028a8f43d78657a9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e035fe72899167322ad1c5fdb290a5f154370dce.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-D",
                "yr-months": [
                  {
                    id: "papers/uk/as/maths/aqa/2-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/64c2e03163bf9fedc3ced10926042979439a5115.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/00e7ac8634ee1d3a7b4f3a6b7d4751a2ac31e9d6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e803ec3189d6c55e62d01ba77fe51e051519941d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c8d0a4252ae2535a7a0bd4a0d5a40fdb2b6b470.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f9c03d3c88b41da8775ed7871c780b7beb690bd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16f05203016f3f87bc98239288a3277124018b58.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d253b5c8f71c44e8cb618aadcc9e6c5f09c67d6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94c8cc824517c5047ba0bc809fd684ca948a64b2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8a157259c92cfd7cde5327eeaa980af8a6af1e1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2d91cc9347dd7f1053357a5628c4722f5ea5585b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33518c5409b2d37d4fe8f1989f7b41c9ab7bf41b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94f460f7529bbc8e28817db8e09a44474956b81a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d78005816e75ebd062c034f082f261eba15ffb2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/19acb5840d2a97ee4e918758b2953003f6a1a9e9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-M",
                "yr-months": [
                  {
                    id: "papers/uk/as/maths/aqa/2-M/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f712245f43aed05c3ca7593d380a771536624951.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c4c3e1aa91d557727e18916e8de4f6b21a4e68c2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8656e5a47646aae731bdfe84421d54d17a6b702.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a45c3094f1407533fd6bf795b8a8fd2ca128a041.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f6189e4133b18a9b76d2f4b51c12f4f09b97f04.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36203dbd87a549e68b2bb910e8e3f7c35ef2cab6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/748ca3a8bee644d9ea52659ad9adebaacc6506d1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd4f4b79101774050128c8c3e3db550398156881.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/430d1aa3369ff7e0adc4f26ddc25c1db9b90829e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bf43efe1cbc31054c719fc728d27bd854b88772.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/641dcc2c74bbb26d70d375f6f7ff0399f0295109.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/638448cc2fe54fac80b2d180227d7116b751e59f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-M/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20e783f076e3afb644fbe5ebdf637928f935f62e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/979774b0ea3dce78c5a4e4c5ebff167ec5530506.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-S",
                "yr-months": [
                  {
                    id: "papers/uk/as/maths/aqa/2-S/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76df7e4a1ee89a580013186c39bdc969ba3f7cef.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0ecfa8c5a691e7cc23c1c500d808cad7ad70987.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/998c801b08e6e5db57a675ac4a6b6781c8aadc36.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9df5912e0726be8885861f2faf9a411666d7c563.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a68d28afff028e31ffc1597991c551083e7f65d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/360679a03fe32c60d1f90b716ce2696a7928033e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/66446c72800d992c2c7f80c03bd879642cdc1d2c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcee3aea56ea5896d79f0c7350cf258bb67ef32e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c5f9ceefd8a676fb2dae2c0e1489ae5dc818d90.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/25a6d143b56e0344b9d0ae18bd42363186c0c075.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/18-jun/",
                    yr: "2018",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3bb52f6fbe7e9e50e886cfcbcf48ff8abc52bdc1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d268ccc8b15a4a35f74818a1945b76837eea117.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/maths/aqa/2-S/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0192bbc743fca816e4fc873086233d431c347d0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bc75783bef961182b98edd5f6459e7e4772005d6.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/geography/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/geography/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e2a25ac1ef71816b11353fd2132e2e6b97b1a21.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd3c9e9990521228890d5fd9e0cc9dc11e867884.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d19ce357a68c0d174a522c9cd42d28662d294b7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2eb83d9a84a52bd71a8836b8dd372c83ac0ff04.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2506badf84bf5adc38c7e1e192363697541e88b3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a11dc7bc7b7e38cd3de5f01cdd757bd323b9485.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b466e68249a0be535f9f8b30aca685585ee27de.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c7f889e580f624cdcf1429c62e2b61f7e7ed39f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/geography/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6085aa71b970cc10ceb391e67b0170f7e7fec862.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a4d02ff7651ca13355d6b916bb0275dabd4ebbf9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/012e6855ac377358a5e4599a0472a5107622aa4f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3c1fff688785ca0195a79387671733693647696.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5a5cbe949f2a3bf13c3fc05e5a68309865ce2a5e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7347657170fce7a8bcb94a44e21ceadf09ed7f62.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/geography/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecf8c15006b5d4a958ce5df41e47e443f1be842b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49d18e488db432eaaa2fe1b6a5e946ad05a68c8c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/urdu/aqa",
            pprtypes: [
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc4a753e2c17d80562119687f24c110312478057.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3cd0dd36915054515baa54d7c1f6af0bd7dbd711.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59c14863564815fc1a9c69383187aab384f7bfeb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/61056b39dd4a64feab8e4f015afbdd01494e6d4f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/92cd4f6ee444c70c2a483dbfa8c2fc1e2accab32.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4dfd1675dfea09e8bc39e551566780721224cab2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3fed3c71f3551d41b563a98aef4e15295f248116.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2785233001232c2867725fcd322c2214458550d3.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbe4d94d66807b0d977d6987821e5608eff64e2e.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e646ddb94ca93ffdb5d70d3c6df0de59697df485.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/972ca3c3114b6c3f96d77ee3f6092ac7ec9fad26.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/52a6366661766572f7d605bace5ebe56c208b37b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70b2bb1dca50983f0eb55281442448843f287466.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a08862e53b12d7d56b795b772123f59a1a127ca2.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aaf4d70e2e4d12fbcc297d1183e8e732ce764acb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/23a28cddb0e46b255c0b27032cb2676ff56d27a1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/01290bc25c635b588efd0a4756141839cad2e9c9.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d5b19b9f80ee6e63ee64c35225d14db3e550e7b.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f43b27918fb42be49e8edc961524c92195973ec.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1262c387139d2b76f5823a400923e9a85aa3a202.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fdf2302e72e55c9d270b88f1be57ccdd9b846db7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5035585a3080c560b508875ce49827b67ef08548.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e22ec9ac07ae6348c60d62381b057ebd739f75d1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1c672e9126fc2ad698e9086dc1ebc29d611f3caf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aadc1901c786779ce7313361f43148c172e6e3cb.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a19d92b40022e1595e4ecfec5a1ee797c0f0ada8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7fc9204cbeb7b87f9c762699518d776fdd148e2b.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10a5e695188ed5626562d111f78f1cf4b4e7fbc9.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/84811a075036c1bf4d1050083cd9bdeedf5889ff.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1034a39332add35da3326fd1cb139db06c20f26c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f38427742772ec8cc1a1876b94e60b752016fc8d.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c522c03c3406e45be1f27e4d8d52ef10d3acd69b.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/93484e0e0fc5cb4e5c6ea81523e6de168a8affd7.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c65be8ffcaff147a9ba6e920c333ca80307a601.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4fcc6f05ba065a6bf4fe37d69d30990adb194b12.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4b974a9212ea16e228319afc722dae456ac840e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fb3fb15125aad2d742d2380ee64cf3af4336576.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/573a3fa13d4ea57653d7289bb849903214f724bf.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de4cd650337d8032e4e17b39e3764b43343753f0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0bc25e7e1af08f08e5f66acdd6d6ea2ba4411ef.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3a31ca9bb3b9cf90e23f251190d50dd94af3f5a.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccb0466e5ae7c49912b68d587f78b86d53ebb604.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/73fe79d8df4d02f34dc58b4b48789634b9a3f5a0.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fecd10666897a470b30491dba9bdf40239c5ef41.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f2335e071bcead3b19f126159332460916ae9fc9.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/20c2912e8f39892f669614def77005c95c0f2cd0.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a9e93fb8b96ebd9b06e68ae4e5a8734a538188f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54425194e9d4d842c8119389fb81fc8e8e939043.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0e834b693c07b59d6c91c8e832bd5c04e8bb6ed9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/066f8994c591805b05cf94a342b49e7184d09465.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e930e6f647dd9a87771d7b73c940bec5337d81c0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/907a1fdcb240bd12c5143024b87123aed7003be8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aca55bde7f1dd3b7c566b47e76cbdf9d2b37447a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c46d65679143b55fb56c455b7612f0ef02f8fd17.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3dd3e9b58fedbed43db410c9a3a4544bf15225f5.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b7699299b1dcae0ab9e764b2e12c3c864b2574d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/aeb5ae9af39f780407747f3a0e75d26d17bb0fce.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9c454e57c8bf0f7692c0aa10a3c79000f09fc1a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c319cca9ee87384f9e18b27ec8e32ee577430fc.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd8c43945df2ebdafa6aa8edd2696664177e4c2f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91d0ad81225a45827f59b4154af3966bffb388c0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbadb793edeab6937517ae7c31d309d76754fa03.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bff439c1b5c1b23e129ffcd417a7efe4efca3ceb.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/40b2e865d834bb6cb8228f5a266141ec4896eaae.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efb00da652800fe8e082d2a72cea642ee5631e6d.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cf2eea0fa6b03b87e9a6258bf11257c82319770b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a93ea11a7e1d712ea30c99c951f948d16a1b605.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c425e4fc1e7cfbcf19b92c4e842d25f9aa98eee3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ddab806007f6be5dee26230d91289fcb8a047acf.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca583eb7f87dc343518c39eca95e818055b7c8a6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e422a53f9712485283a26e76c009400908ff5e7e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3526ba56ba824ccde1c15caa924973448e39b405.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/urdu/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4d905f95bf66dea028ff9935fa32887dd666c8e0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb62cfb5d1f5ad6b3f658cb2eef659a7c843c50a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/urdu/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7c7ba70f120d3a71587b6dee20474c13c4a1bbfd.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/164efa91226f181fa5628b088ab4046833ed1fc1.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/drama/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/drama/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/293c2fb6e0a468fc7039d9e579d61df22fb3af5d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad330492b7a2dbc110ae6e939ec30898eb46d3d6.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51914e7fb0a6fa0e46117e40d15deafe616db653.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/drama/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfcb89e7f753ff3605c6931d2dc1aea46ae949ad.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6a3dacc2ff63ab72c79c2d8548a7c314874e9721.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ecbc90e63100cfec2342fc6f7382ed3c756736da.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/drama/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb2d4d1f4a454b02f861d6af3101ef3c1f2f2787.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13ddb821e2b14730efabd738c620b2a133c6c16d.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24e7e518b478ce656604e538586888df9db77296.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/drama/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e961b91f28e70e090840378cd4b50d124e43ff8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/76b2844a764c0196f00bf670a99abcf2013a861c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0248780137494d9240e5f6a3214966a3437777f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/drama/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/da3c346b03cef0b813dfcc41fdaf0950f0e4d44c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c65d8205a6289331b5e7569a5d04aa07c2f56df3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ed3b439606111525df3398c1261987f26dea50bf.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/drama/aqa/W/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34502834d8bddf95b12b18438add6d0315529921.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/compsci/aqa-8525",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/54bbae3bc56bd039a746fa08b711be5262080481.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7a36caff503ea59434a17237febd772b1ee776fe.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e2a002061390548f3993d620a9c4af87b25650a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afce2295b1f8e834c6ddf7de2ec6d21b3874db1f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5c0595360e4275f41a38a436670443e262c5c80a.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e899ae4698f19f7c047669df37fb1d1ac443e2b6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac773d9fc9b4cf94e89f2efb8180fa7ea561b36d.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/be0f8436a6c4ab8e7fb2eef165a9a555f95777a7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eb82017d405ffa8d3560820eb25c64c0402d92f5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7b1096dcd8fac808f67ff4dc494a2aa3c74bbaf7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c55995729340aed79354f38449d7c9c6dd182af3.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b6d52a8965f45d89866abb950b1b199dabb8f538.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/710faca972b9788daefabaf75583b48dec0ddc86.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/030dd044e6c4c98edc901930d4b6b9759c65d108.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c07d47ff3e5fa889f386627403b82b873af9cd1.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8fa75a55c6d969c4e05d51845de63f3bccaa8b4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24085888a1e931525b70eca8436f83e043a5975f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ede99a9de096f7f7a96f78d2c951eacf554570f8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/59f4fbe4ec010d8d1d14b4d592d3a8b137cf958f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8eae146c01359796f9cbd91d430a678f1a1d09a3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/beac98f0eb539131985f8bfa7cb80416e2e3f1bd.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75f3401c29254c88283129b50fd08fb5bedd57a8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4a150810a811867838012286c88de97a59a9e7b9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/958d8caef57fdc4be3bc93975a5677d2ef1b91f6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4e77ced33456b81789f55fb44aae48920097cd01.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0958d63829d9907680d82806a7ace1f43817ba9c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/822f9e9ae5790c92d89f675e247bb23f79510bff.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0a5e412046c269c843b3ed67a1d33ee03dee48aa.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6b076837128af67c0d0adbeb43eac34934e737de.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0adfb762c54f9f6146dff80e1388f3c67034023.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8622ef4d1dcaaa179f84bf912f6a3adadd33e962.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-D",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0074d12dc3c400c50f0db6775b5bd41d1426857.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc412e0059ae4c939b51708379f4347ef42b1670.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/78e35d7ddbc9be9b96871d2fd6e3ad0f50c7d1af.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-C",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f515891fcb37ecabc8f35708bacde33b61415051.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-E",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/compsci/aqa-8525/1-E/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/08efce26a6126baaef9260dc33c835f698accf00.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/compsci/aqa-8525",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/compsci/aqa-8525/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/daf5fda20d9e3cfe41b2bcc509e5b7800b7ac876.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1617b95fb38a747b1981978a75c7c16c94dbe86.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/compsci/aqa-8525/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8381b1349c65bd32ba9896bb9613d8d5ebb2df34.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bac94931bfeaf79a050e50935cf3a4b9807586f9.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2f95be60046e27ee69d3f14e91c799fc09a2f885.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/compsci/aqa-8525/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56782afe44a0bef463601caedcd7885c815db9cd.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b969ada0a85e57a0b1299dbf62a8299625b6d6c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b61a7143c9058c5e8913c223749736fbbec4813f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/as/compsci/aqa-8525/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/548625dadf05ad7c90a7bbf5789990c86182cae4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b2dd5c6d6e8b7536a1722807226f24baaef9a6f9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/compsci/aqa-8525/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb29d6d79bec252b081f1e6fd8468b75bc990ca3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c157c7cb92781cb55d3004f446a448583fed669.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/compsci/aqa-8525/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/102c95eeedca4aafc6ba07da2ddd0b5146f7da76.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/519cc3abdd76e3ed45bad914acd561a544883c9c.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/mod-hebrew/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2802c7368c27aa5fa5e2d0d794ba38ee2d61b84f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/938b7a014280bac11d810844a6d1167885253609.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b52816991246a7e44add5d790c48ab034816b91a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a0badc4e922e8a681ada13994de6ac92a216eb4c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a473293f48b16106b3e16841cffb7ef1efc9dcc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f1e526e04b10d9de7381018c120e01ac72889233.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8476629620579636152e937fb019769f718fbd8a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e30165bcacf9e148f9bb1021e9f11c506f3bd10b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d246b19660101eb53e45a266c90605d17b728acf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5381198acd7acabd3741e9301f9d63e989237c47.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3454bbcab2102f1978c0ad0b584fc485a895dcd9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c50f32fd7db10121f9ef5fa240e8ca56ee827382.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0c3265f92f78821c4fbcbd509e38bc71746963d5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/30d16eb3d169311467e754536c0fb0b6e1aa1656.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a080d61c80b9ae71a1f5907718b2f2cf15899ceb.zip",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/223b7ebbc74f023d7eead6a5f7f3e02f27bb92a7.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7937dcdb097a54528453facefbec0d621a1b647d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bcdc3dd221d41904ccde3130a8a7e9f3182cda98.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c388fd09ccae90f767a69684f7021b1a3fe7499.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/022776f2095cbe87ecf9f2bde3727c5c66b41ec1.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e989fdcfb753707bf233a065e17d2af27d071fb6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82a4dbf4353b2cfb626759258fa6812297f2cf2e.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ca1b915cd0d0225300c0e04f2ac64f4c17abf7d5.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5531235572bb6813fff2baa770c539f489d6560c.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cca906943abd25cf517965de10322036d5c76d05.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e68a36cf2142edaeadcdb05835480d2f470cb4a6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/49366eec0bc4a692bf8e6745a9072f0db4787a3d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/880ae585c1a99aabefaa1e56a92e671f8e95713e.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4639970f1e87fae50ed75856f3356107ea016e47.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a694b39b20e7b7fa387cdce4a17c433bbe3e85bf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/33c302ba5741e9d8bcd597c4e104c9099cb1e7ac.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1a88463c562bb9efddd57c20edbb0256ee775e66.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ff7ae7fc51baf95ffb218109436d87d8225825bb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/29c3fa1d6b81a563e77ace8aae811620763d53e9.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9bb79e198a471eea2994f872e30c9e9ba576dee7.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dee28058c11773a1ab8885fa792d287c9c11f6d1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/04312039c573a83f81e1775dde22bc3e8fd559d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4f3d853937d8592c9402ef47d52c5b9a1eaf31da.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dc5290e0fc2bdc882007ec64c9851fa8bea93e57.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/72fcc52a92581b130cb0d592fec5130c06cd99c1.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/424e2d40ffe55683d3a4df6cccc42c302d5b5e45.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e91b2383d4fbcc745fbe30ed649637e03340510.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d099246a0ef2ab8e8dcee7f3a13ab70a17cce673.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6508165326815e273f38014b2b60dd5323ad8461.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/111d76e45f14cb12eddc7a80f5d1084e2093e163.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea80daafcbd712a8c2a335364fc36865ef5a79e6.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7d7d759e45ab697b8dd0dc253f8ebb40a00537cb.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad6f1ded32d0e9b4803840110456a403ec8c5ff5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/afe6004077e835d122fd67cc90feb3cd60ea5e45.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ea787d547d467705c69350dc0a5297d4758fffc.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5c896b45560bcc813809dcdf4450cb6d0505e87.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8631b5fe3e72ce9047ccf03d56ae4d2a17e0c829.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c0d302b17a56771c287800b35cad71e040d3fef0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0cb5aa72b3d560a06cfd71bc5053bfb6d560cd39.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/400dc88426aed768f704e1f752ec8e31de630ae3.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6757383cd5a05c729e17ded3c4760fb0b181f83.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db29854e1d3e38b45a159c3d6f13fd247356061a.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/36cc35f018c20b84f50a4375d55ba2cace537753.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/32ed0d30aeeeed5cceefa93a0881c78db2bd96f1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3a1cba2181a781c687447c3aa6a47f21897aa07.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4b2b638068b075cf567029bf97cf96d7f9205ea.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d75a62cfbe24719706cae418a76ed109f2ba1610.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/586836eda07f67e0fb0e22c581daf77066f56334.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2ea38f244134aae29f40c4509a4652ded7e09fb.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f814a70c6a254c3d7249e67becdb65f17392874f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a336870eebe993b2a0ed9621ad8e55700c5ab7c7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b19ab066a226acff8dbfc60835a39f9bad872705.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4587e6e45a518b48776c86dae989ce41fd717674.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/854a47b44c5c6d6d483319c8048b399f1e761e15.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8155b90eafaa7bb43ec2e7357d1af1b9f8c02bba.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a8a0486bcf3090b9d85c6cc27fa9efd40cf1cb04.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a5e8b00020ea88b9cacebd1a60b04fe5b43483ab.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0ece8852eb6145a6bd981ec1dddcdc4a3272cb0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/15f0ebc0769b36a235a1e3819fa3a2e79a1eadd5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74c90c06d94269b7a0cf7e96b9b8d57b63881ab7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50a199ff07e31ba5886a33bc08974401ed8bc6ee.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65fab405cec0ed6b0ad9ea219d80b8e5f4e78ea8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1b8ec4d01b12cb38241330ad2170fca5615c94f2.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/812d9423bb66419e06829e549734186a0e735f7f.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fe69e50d62c914f12e50c1255e0868ffc2ea7371.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/mod-hebrew/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9b34c2929f763e0becc67bcabeab95f031bcf95a.pdf",
                      },
                      {
                        name: "cards",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fc4e5d027fc70989f56cffe3849391cd471656b6.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/50fc72b8871b0d59b3a15f4a749c0c6ac5f8af03.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/as/rs/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34e9f499e3268e463b191be55954bdfbe737dceb.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfa4da345a0fa427f51a7db80ed56b0833792b38.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8aaee9083206fdb8447012d74ae4a208e965d8ca.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/407f09398a26df9755383d5d87f1c0227389077a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56bd03ce86a2b89c5e6c4d0fa0b3ff8c3772416f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3d1a8cc155335138b780d8faf4fae5e7950294df.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ec08118822c6136042996b4d89fd03d9d0548cb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07bd3d7c98b6bb3ea04ee12e75deb629fc93b1f8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-B",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/2-B/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/02bbec336e75a2a2411db26eef4922debca9d335.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e4d8047213cba745ee90e6aa9e89b096c2bf394.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-B/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2de2dfba6c9b3f8c31367c27532aeb69c2f1c329.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/324c3b74cb368d8b1cffc782b19cfe43d7b72477.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-B/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d9e5f4fc44753f7678b91fce2c2bc64c5cded1e0.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c8d592b0000699ad3a13e7648041ccb30ecd569.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-B/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06dfbf9d2d03fdf67249f83f3450c090f5590164.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ae029eb716d64fef7b59ce8b62020f51ce0595c8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-A",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/2-A/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/adcd9d87a0c80775cb75b7abb8cf7faf4717615e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cfff90c9e085ac05671263df5d9f7f91be6452d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-A/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2cb4bc8edef116719d268066197380dafa575794.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/222d3abc5c0b0e3c5c3430b6ee9cbb99d037b195.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-A/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d2b6a36a12ea59d96d553a0ca7a1cb781ed203c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c51e09a334f3dd8d71d92a070f1e8475ab83e84a.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-A/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c2d3c6cf6fb82810d85e0f808ce42a2d977d2e03.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3e85b5a03d04468b9b5ba20b3f4c990056055a56.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-D",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/2-D/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cbc25c547b969604836c59c31c5702f25520b0e1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f998c575852a84a3f384cc7ea2813bcc3082025.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-D/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/855ac55662c586669bf42fd8dda4db802458249e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a47d00272b9f6ff5389c48e5b18148bd85b6f083.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-D/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5e40c97328b6b2d3ae8bb68847fb35fe5632305.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/762ad1f8aba9ba7f53bf8b63adfd2ac94231c1f8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/as/rs/aqa/2-D/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b772af7ff6fd246b19a7dada26807b15b6010a35.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d77c2f5bc94254de371415088de5472c2e4eb910.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-E",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/2-E/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de879ef1f53fba100935a658d7824eeb070887e2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c1adb6ff2b0d836796b59b589aceb2bd37f61098.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2-C",
                "yr-months": [
                  {
                    id: "papers/uk/as/rs/aqa/2-C/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4c67cde3d7767ab61e3cee90416ca9e261553857.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cd3209a0d298ab748433cbe9fbcf5485f784e08f.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/bengali/aqa",
            pprtypes: [
              {
                pprtype: "W-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/W-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b4cef52c263a2e44534f7f17f1d48112de26049d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/16ee4da1aec554e40fff569073ac6353aa6b9869.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/W-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7434f089aa009b4a7d93a5449927f5b2ba622c88.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b0b04a98ce2b7841597813b234074ff893b100c0.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/R-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8cc79665a960e9c89ece6e6f104d98756bd8e744.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/R-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/57367eaa77cddcd5e1c7ca4a910c99e572acbae9.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/L-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5d4eb80ffaafc46e6a2bea454d9a104d882dd603.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/L-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/310d8af052c835d016c1cdfb519648ad2f937f0e.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/12e35fdf4898c0b1fe5b37a8aaac4998d3e4049a.zip",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5b3657e95006d32215ffa2fc1d5cfa9a0d5825b7.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3ea8eea0dccc2f30f331fea3400b08391d4d6137.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/S-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ba5c57d2d8f043dce62c3c24f0b3f40f6a6192fa.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/S-H/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1e6baef37cdd528488f7ce1024cb6ac5cddca6d1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/S-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4fadfac5d53747e7aa2595b9e68ff64576d687d5.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/S-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c161cea7f2a94b96791b9f918153ad4f01ea1f66.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "R-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/R-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/631c64b42faea69fab2f23501622f5a466b863b7.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/R-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c2b176e65797add4b1543856066b907b4eda02a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a8a38b18481870a365219eb7fd10e3e848c6e02.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0f3b5f2bd557a9564c3b67d74aa82c0d582574ec.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "W-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/W-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0739077e8440c0bbdd46579a8e63cbfd6825bb5d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6843d254cf37a2a32a4d89641132828d588f9dda.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/W-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dcb4c688a85e654fb5fb6f6c276d5f0caf789fbf.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6d0cf0acc0d03c7fe204edfa469e68aedca2cc67.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "L-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/L-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bee46412d2d671264aeba4a65208d5f1fe8ed10e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/L-F/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/01c413110a8f8c06f8d78654d2c595abfa64dce3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/07d1a4d2d8aa292ceb01b2c23c16b7f96f0e7b1d.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bef28d796712617a044af116f8db6d421341ffc3.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ea747d8f7830dba47345df6c4f9c6952bc39599c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-F/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/887c5a4d0ff253365545ef9677ad9b3aa91faee2.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/83221da1ec6a4d880ba7228cce666d81f75388f6.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/56ee87fdf94cfecf9d0740843716e988e465297b.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6de78863989f9cf522b5a0e274b02e983d51359.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5015f0dfae19c69d18ee73aaee6dfb9683dfc046.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/48d38507f3d76b00cadf261c18d14f7465543e89.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a6e2a9b4387533a9ae3f18068c583f170fde063b.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51f7522ffd7191eddc3b496e9906c092d0d40c03.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/acd1bf54a5d3f8902eacbfeda0b8eefec14e8301.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f96253123d7a127099a1dbffc835e56f12971ff.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-H/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8f3e6eaa5db32d2775a3766c3e05cb3ff41a0811.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7011fc467660724d4ad63f043c4ce24a51fb675a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/123588063cf9e9d2bf9b16a497eec9e7603a5f42.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/139723c695c764e14f8778755bd36fb140405387.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5f3036a19197b40b9e79c726626a6134e29c910c.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/65654cfe8ff6dda286d615c4af296ec838716ac9.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/1-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d32c3b9fae15050ed5526af49cee58a3f624f57f.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4ae1704f3f2bb47a2dc8cdf21bd657bc29ed82e1.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/241ba67bb24a38a0dec82cb4835459a3305c167e.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b976ed7cfdf71a0c88c596422f1ec9dface1231b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ec7c34576c0698b00c1ddb6a596a5c2e748692b4.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fb09704da0b296b9a602dc394bea7d452bb95e36.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/874d92b6167f39f5a04237eaa92b91921e1a9776.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9f87ff9eaf0262f5982ea523f6a81bed3e4ee8d7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a3473a1e2fdbfca9301903ccda99c70d99204094.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/634f8b4f1f49067955ccf3f2e056c93b3d69c829.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e8cda610c774788acc76dae977724786b15cb64c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1943a5731364e6b96494fc619e15c321f89c637f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/efa2a98018d815e03e99d909b45744f3993cc0ed.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f9222a7171b84e9954b7703726fb06391cea242d.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/725a7531ac09413fc0482603b9dacb25935b6123.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a64f9fa8aea7cd1cbb71515ac01e844a3af6c8a1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9978085aa2d6da61f070055cc0602ddf5b4fa448.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/3-H/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbd5249aeefe418ef180186dc2776364df0c415f.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/77ebd4d2ea552c7d425fa5eba774caf21e509951.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-F",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-F/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd754c71ae1d6436debbb9ce459869d91c4bf363.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0895ce3e5373f85a16483b2e2fa1291cf3087063.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-F/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/44b50223995b781fdc4ddcecba2d71f3497b24d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/4-F/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/70e1cdebc682cd2acb858a6dd64cd1de468e18b5.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/4/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5615c5136ab5253a024b826c63a40610d372b3fb.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69a634171ed3b19b0df1101ffb620a3f248dca12.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/bengali/aqa/4/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9dcfa644291685a1cb07607c30caf3961d6669ec.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/183aa4ce73021f8866db4f655b924a00ed5d54d1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bd2afa8eb94496cd6823ea7e7295dcd0aa9f48ce.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ac72cd298f24a989928395902f2c66fb0a54334f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/525ac246d72cade929621cabbedf9286e560d7b6.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/bengali/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/db395c6ff90aebbc6e5e64efc9f9541f6a9aab99.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9c861c3556d41de4f740a1f7159b25b5b1e659e5.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/mod-hebrew/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/81aae2f836ab70105a985a9c635173c647026d12.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/05ddd5ea449a0fe63c44815687eacaf2f5c3b48c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e588905135013a4b5558c0d67b3886078cdee3c8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6f25c4a5842762bd54b3d9a1832ef87327d2e1f1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/2/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3847a71e649b7150b73c63ff1e3b4b5c1a667a2c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/912fd6c4a783b253252fef25c89045dbe83247f2.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/51a2de33a53570037f23f3e5ad326b4bc4d344a4.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/749e288d1c74866b3db8666954e62272ab3e9f33.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/96e035db0d5f9a6ebe0f786ba80950ec0f443aa8.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fe3c2ae477ae645cce3749f7367c4f65ba4412b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/297d55e9382f24dded5a2435fe228255cc058126.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9d4b9f2ec34566ac15c9770e4e61798acbe4f898.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7bca6e2737032d86ebd003d900fbf083579963c2.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55ae0786f249beb530f9e1acc7a86cfc38f6716b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/1/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8302526dac3dec66a4881641a21080e3fe2f1ecc.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b3ea8bbd243ee7d8f0d03747a4bb8e83af59f527.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a17e641d8a5344e21aaec876407be3ce34786c8.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bfd62cfae1403e574ede7a5cdbe367099fc00958.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2c610988b145a72c5dfac73b0d680a267511793b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9aa194b1b138621ca6f5968b8505ad2eddc05144.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/26c613c5b7ddb4b5a9de2f228bc64f12014e7d80.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ead44522108b4d3387b42aea8a71108beccb6d5.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/75922f68c43a4a75d81b1c348767290079718d98.zip",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/46da89ccdcd8deae1256a6308a038a8c577fbd3e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0aba646ca41c2afabce85ee53f8735275726854c.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24735983303c08773265cf1b43cfc6b6186f0efa.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d6828dacd8454b0c3795bed02721ba011612fb68.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d747313d1eccb6f2cdf3026230e5d2e081460533.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/443b22aac245f100f063844f75762dedc432936e.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/3/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3003cba5eb13dc5895b32129d3effb9b922ced1c.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7876eb458f450d69681db155b3b0eacac192ff6a.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fd3f5a5e94fff4a400054ee6ef2576259869df50.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/cfba5647ee7252de72b5a4066a5126d18bef9873.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/91a685badde8a9773086ce831985cb9dd287091c.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/mod-hebrew/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e75fe7aa8b509b1dc16613f4690f1d0d8ed5dee6.zip",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/13d281c1bfd3364a7c5f43c7badf1a80303bc093.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5e0d1dae8df358a53ec0d23209b89dfb19c6a496.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c6953da2fba5f0642999b3b863b4a935e07330c5.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/94474707f848a92ab2315e7ac4c2f7bfd54f8102.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/bib-hebrew/aqa",
            pprtypes: [
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a2d489173e7ea1a01052dfc5e4d6c8c0701a4745.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/408942e103fe0ff82b88ad00d425d6ae5f3d416b.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2ec6ab9248f7b83bdf410d54426fcf7b87466510.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6e1997f223b746f407c769c8571a15bbcda6199a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c5b231400db394e7a59891619383a5df66cf9fd7.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8c5785260eb64f1b25e453c6e19b1752b0e98ed1.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e6062f93b0b1739d4043b4da7e796cb66c2389d9.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c01f2245b829c526c48f541f5a340082035ceea3.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/653d399d4f1bc706f9865ef28b6d9f16b6c17825.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3b10452cae1bc163fceca432eee79e772acf04cf.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f7ce9c2b7191bd036a599826002fbd6dda08c831.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/82044012df53e9b6f92c0412d4174d5fbf6d7708.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/69aebd508cfd43506448144e304956f8cffc5225.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bf234987651e8051ed94604d5ac03b120cee2e32.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/58171329b96a60ff149d6d5903a62b9e70c8571d.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3e8a7b5c25d0f3c1278fd4c1d615024a8f5abf4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b8c82907882d8684e58e0cc4b65c3e6a647676dc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ef910820cad4b3d979010f4214b8b18f2527dc8a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/17f49036aa59c6f5e509d7e18b95ba61e718989c.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e36759701efb94dfab3d15cbdce84b39a4f2f2df.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a94ee46a9544c9d366f51ca94cdb3babfdb36250.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/97e64b40e8a68f8a4cc6cf1db89aba2e4e398899.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1d82a2b0a1b23f937ce53b28405e0533c133bf66.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b235f9e400f0bd92375d5de1af432f25fb7dbb6f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c3bcf0db7e8ca3314a9896b42a7efb9d90cebe9b.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bib-hebrew/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7f558a45e307d2db0de09fb0bcfec0625023f649.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7daf78801a5c79e91733b648b326733c8fd52c66.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/34a1a5310b8d0c42ea15b0463b3f3ef02bd60d5b.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/bengali/aqa",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bengali/aqa/1/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/18bd6dd11ecc0b1feeedaea67821609abed71985.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/1/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f498f0c7e2abe892b51d60d7080f5609becd2449.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/1/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c90bc22f2f38e4839395e3b306877b6b8abea0c2.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0bd8a504d70b58e48c668ea859eeb6f86fe8c15.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10fbd8a7b88bf9146abc6487cee119d9bb712d63.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9afe8e4ef87ffad07914260cb0745a866086062b.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "2",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bengali/aqa/2/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2699b04d884265dd0911de42c5646e25cdfe514e.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/2/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0eef9af84b12edba5495cc22d23444a257fda98c.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/2/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7ddc5788a430d9458dea4ac11dae9a29156b5852.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/808fadc94ed88f6b0337a202e141d16e92381aa4.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/3f756f77b9e70a97dfd1cf5fde5fcdcd9ca11c9a.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f77b533fa4e13b1b116c4fee607d8cc362218359.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/bengali/aqa/3/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a32ec8d3042014f55329d102033a83c21663f0c2.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8778987c6d20f783c289060cb6fff655d641b186.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/3/22-jun/",
                    yr: "2022",
                    month: "June",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a70ab5a98dccb4a052691848a2aa36d1a748926d.pdf",
                      },
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/9fcf676574f5d9ae1ed53a063c8ca529d63f6583.zip",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/3/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dd7f165a96d97336336ddf227b8d943fb6a3ea58.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a20195f6f0d952467d45096cf5b772ecc35c4aae.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/532edab56a0b4cd496e28ca1745da48dcfc312c0.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8dd4974dfc07757b6320d4014ac2c31eebae6217.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/a-level/bengali/aqa/3/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "sf",
                        url: "https://cdn.sanity.io/files/p28bar15/green/10c68bb896db2987dc9cdeef4ffea2fdc4ff9306.zip",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b978873316c04b3baadc546571714adec9d1deb7.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/80448a5db9349d810c2e5e9048ee7d636ed55a45.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/74b78342243c8c0c2ca7cfed4960e0bdd1ab4072.pdf",
                      },
                      {
                        name: "tr",
                        url: "https://cdn.sanity.io/files/p28bar15/green/888ad0a3da533a3f3753cd73da02122d6c1c8220.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/art-design/aqa",
            pprtypes: [
              {
                pprtype: "X",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/art-design/aqa/X/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6bbab09bd28c7bdb9352758c61d98a2c092d190c.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e0c16cf7c751a3d0a63b95d3e5d5fbe9b07a8668.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/55111ae89f6f7f2073162834c87f9ad5645805da.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b687460f0c30ec66b49d662a98b766e44062b27f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2a7db30e86b72baa4ea9ed0d66a210200510f5dd.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2649c33041810dad7f080ee5d385932c0ec21053.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/art-design/aqa/X/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6fb12e649d746c1947b98050b97aee65f95f9338.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/2e796efb7cdb9b2903248870d43f92539b2666d1.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d3e3c3713140dcdeacc5cc2fa9d9905336c6ea9e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e7e54ba1cc0d1745625b040d38ecbc789630a8ec.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/6ff30d16017faf5d4f0194af2a60b8693c9ac34a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1ba98b8530eb3dcb623507886fe0b583ffe371ca.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/gcse/science/aqa-synergy",
            pprtypes: [
              {
                pprtype: "1",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5941cb6ecc1b6c1799dc47ab14226ee08f4b0abc.pdf",
                      },
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/4b6542549371da461849170760c71a9481e01c72.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-A",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1-A/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/eed85f0ca32fe54652b842d77929fa9fee94298a.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/748088ad1afb5e5a2418f895ed6b38cc1df24c19.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-B",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1-B/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/41da96aecfa3c95788d47c8934e66bfc8e30d89f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/bbed3653434cba45b68e066c33938da923c2ad5e.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "1-C",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1-C/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f0b15cd39196642feac9adffbd60061a04ef6f67.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ad2e51010732908931c4a6f93c9d78878e2b49f8.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "3",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/3/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d0b568c5bc96865a96007dd039be5385ced80c57.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/de55e38d0755fde134339dea9744f5c787c5fc7e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/0798140954d8de118b5eafa88de3fc206b8c60a7.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/4/24-jan/",
                    yr: "2024",
                    month: "January",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/a38150578744cbb17bc6332545c53c03a4576496.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/8088938143fbe6b90febe449457cfb246b7ee1fc.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype:
                  "1F; 84651H;84652F;84652H;84653F;84653H;84654F;84654-H",
                "yr-months": [
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1F; 84651H;84652F;84652H;84653F;84653H;84654F;84654-H/21-nov/",
                    yr: "2021",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbfe7fa40c62d799e32a8ef8fc2d9bc013eaa742.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1F; 84651H;84652F;84652H;84653F;84653H;84654F;84654-H/20-nov/",
                    yr: "2020",
                    month: "November",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b5cde7803397525a43f696644a7c2b9e11ee92d8.pdf",
                      },
                    ],
                  },
                  {
                    id: "papers/uk/gcse/science/aqa-synergy/1F; 84651H;84652F;84652H;84653F;84653H;84654F;84654-H/19-jun/",
                    yr: "2019",
                    month: "June",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/5dbf932a859f5ff1ff58698201f2bf349f86409e.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/fcse/german/aqa",
            pprtypes: [
              {
                pprtype: "4-RC",
                "yr-months": [
                  {
                    id: "papers/uk/fcse/german/aqa/4-RC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/40732533911f3780c29ed5c5b1a123d7447a08b3.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ccf99cc8e0e3adae7aeabe7f6545ef616a7fc5af.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/fcse/french/aqa",
            pprtypes: [
              {
                pprtype: "4; 89684; 89984",
                "yr-months": [
                  {
                    id: "papers/uk/fcse/french/aqa/4; 89684; 89984/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/915a6d17c80da2c77dc17cd98c38d06d8841e76f.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4; 89684; 89984; 89734",
                "yr-months": [
                  {
                    id: "papers/uk/fcse/french/aqa/4; 89684; 89984; 89734/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ins",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f8bc38ede0cef0cbb494f254474792100fdcaafc.pdf",
                      },
                      {
                        name: "tn",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b85a386cb4f26a5f57d80d31dec25d89d8433b1d.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "4-RC",
                "yr-months": [
                  {
                    id: "papers/uk/fcse/french/aqa/4-RC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/b835225808d9e597785e8e66889917cf10d1c5ba.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/24f1d38693e343bd15f7a843b65dba13077d377a.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/fcse/spanish/aqa",
            pprtypes: [
              {
                pprtype: "4-RC",
                "yr-months": [
                  {
                    id: "papers/uk/fcse/spanish/aqa/4-RC/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/c49c30508a0c9a13abd1dfde7afa873359669a5c.pdf",
                      },
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/646d7247f6a77a61c14f84cb21c4eb5f529afc9f.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/elc/english-lit/aqa",
            pprtypes: [
              {
                pprtype: "S1",
                "yr-months": [
                  {
                    id: "papers/uk/elc/english-lit/aqa/S1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/7e4a7d6e8959a0227fa7530d42cfeb6ca8f661c1.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "S2",
                "yr-months": [
                  {
                    id: "papers/uk/elc/english-lit/aqa/S2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/f4b6dad0933d78c209dc2bc23902b0417de47056.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "G1",
                "yr-months": [
                  {
                    id: "papers/uk/elc/english-lit/aqa/G1/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/d4dfe8911da5e1ce5172052464c1b9667ff55145.pdf",
                      },
                    ],
                  },
                ],
              },
              {
                pprtype: "G2",
                "yr-months": [
                  {
                    id: "papers/uk/elc/english-lit/aqa/G2/spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/06bb9556ca07642d8e8e87cf1698b056cabebe60.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/elc/maths/aqa",
            pprtypes: [
              {
                pprtype: "",
                "yr-months": [
                  {
                    id: "papers/uk/elc/maths/aqa//spec/",
                    yr: "2018",
                    month: "Specimen",
                    papers: [
                      {
                        name: "ms",
                        url: "https://cdn.sanity.io/files/p28bar15/green/fbcd027fe53e9a5ac3d1af37c19a76d5c5ac186f.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: "papers/uk/a-level/art-design/aqa",
            pprtypes: [
              {
                pprtype: "X",
                "yr-months": [
                  {
                    id: "papers/uk/a-level/art-design/aqa/X/23-jun/",
                    yr: "2023",
                    month: "June",
                    papers: [
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/ee07c55b6cfef983bc223879984f689df38a791b.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/1334367b92394acac7d35e66706357a6936c113f.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/dbc555d76d96c7f727512f4c9537575960c3792e.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e4950c8ab1f2c4a24095c3575e02d3ad53784624.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/03f127ac91139b81889ecab47422010976601941.pdf",
                      },
                      {
                        name: "qp",
                        url: "https://cdn.sanity.io/files/p28bar15/green/e142b6ac3dca74050867d92208b7ce730b2b5498.pdf",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ];

        //const thing = {};
        //thing['papers'] = JSON.parse(str);
        //setPaperData(thing);

        setPaperData({ papers: [...jsonPapersRemoveAqa, ...extraPapers] });

        //console.log('SUCCESS: gz file decompressed');

        //setPaperData(str);

        //return str;
      } catch (err) {
        console.error("unable to decompress gz file", err);
      }
      //console.groupEnd('json file: ', i); // ends the group of info in the console
    }

    async function doit() {
      for (let i in urls) {
        await exec(i);
      }
    }

    doit();

    // just .JSON:
    /*
		fetch('https://examoo.s3.eu-west-2.amazonaws.com/txttest22may3.json').then(response => {
				console.log(response);
				return response.json();
			}).then(data => {
				console.log(data);
			}).catch(err => {
				// Do something for an error here
				console.log("Error Reading data " + err);
			});
		*/

    /*
		let isMounted = true;  
		// note mutable flag
		doit().then(data => {
			if (isMounted) setPaperData(data);    // add conditional check
		})
		return () => { isMounted = false }; 
		*/

    /*
		doit().then(data => {
			setPaperData(data);    // add conditional check
		})
		*/

    //console.log(paperData);

    /*
		fetch('../../eg4.json').then(response => { //2x100 for big
				console.log(response);
				return response.json();
			}).then(data => {
				setPaperData(data);
				console.log(data);
			}).catch(err => {
				// Do something for an error here
				console.log("Error Reading data " + err);
			});
		*/

    /*
		fetch('../../eg2x100.json').then(response => { //2x100 for big
				console.log(response);
				return response.json();
			}).then(data => {
				console.log(data);
			}).catch(err => {
				// Do something for an error here
				console.log("Error Reading data " + err);
			});
		*/

    /*
		axios
		.get('https://examoo.s3.eu-west-2.amazonaws.com/txttest22may3.json')
		.then(function (response) {
			setPaperData(response.data);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		});
		*/

    /*

		axios.get(allPapersURL+"uk/")
		.then(function (response) {
			setAllPaperData(response.data);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
			});

			
		console.log('getting papers (USEEFFECT)...');
		//console.log(props.paperData);

		const fetchData = async () => {
			const result = await axios(
				papersURL+"uk/"+loc_parts[1]+"/"+loc_parts[2]+"/"+loc_parts[3]+"/",
			);
		
			props.setPaperData(result.data);
			console.log('got the papers.');
		};
	
		fetchData();

		*/
  }, []);

  /*
	const handleAcceptCookie = () => {
		//if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
		//  initGA(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
		//}

		ReactGA.initialize("G-YC142WEB05");
		ReactGA.send("pageview"); // can change message to whatever I like (I think)
		
	};
	
	const handleDeclineCookie = () => {
		//remove google analytics cookies
		Cookies.remove("_ga");
		Cookies.remove("_gat");
		Cookies.remove("_gid");
	};

	useEffect(() => {
		const isConsent = getCookieConsentValue();
		if (isConsent === "true") {
			handleAcceptCookie();
		}
	}, []);
	*/

  /*
	console.log("QUAL DATA:")
	console.log(qualData) // works fine
	*/

  // returns null to the entire page! (instead of usual return of JSX code below)
  // when something is returned, rest of code isn't ran.
  if (!qualData || !subjData || !examBoardData || !paperTypeData || !paperData)
    return (
      <>
        {/*
			<Helmet>
				<meta charSet="utf-8" />
				<title>NooOOoOoO</title>
				<!-- <link rel="canonical" href="http://mysite.com/example" /> -->
			</Helmet>
			*/}

        <div className="logo-parent">
          <a href="/">
            {" "}
            {/* Used to be <NavLink>, but need <a> to have total page refresh (so that qual, subj aren't remembered.) */}
            <div className="logo" id="logo-id">
              {/* <img className="spinning" style={{width: '85px', margin: '20px 0 0 0'}} src={logo_svg} alt="Examoo Logo"/> */}
              <svg
                className="spinning"
                style={{ width: "85px", margin: "20px 0 0 0" }}
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 1.9 82.5 63.6"
                xmlSpace="preserve"
              >
                <path
                  fill="#404041"
                  d="M75.3,21l0.3,33.3c0,6.2-5.7,11.2-12.6,11.2H27.5c-7,0-12.6-5-12.6-11.2V23.4c0-6.2,5.7-11.2,12.6-11.2h35.5
							c2.6,0,12.4-1.4,12.4,7.7"
                />
                <path
                  fill="#FFAEEC"
                  d="M59.8,62.9H24.3c-7,0-13.8-5.3-13.8-11.4V20.5c0-6.2,6.9-10.9,13.8-10.9h35.5c2.6,0,22.7-0.7,22.7,7.1
							c-0.4,6.8-5.2,7.3-8.6,5c0,0-2-1.4-1.8,3.6l0.3,26.4C72.4,57.9,66.8,62.9,59.8,62.9z"
                />
                <path
                  fill="#FFAEEC"
                  d="M70.9,30.9v-8.6c0-7-5.7-12.6-12.6-12.6H22.8c-2.6,0-22.7-0.8-22.7,8c0.5,6.6,6.9,6,10.3,3.4
							c0,0,0.3,0.7,0.1,6.3l0,4.2L70.9,30.9z"
                />
                <path
                  fill="#FFFFFF"
                  d="M56.6,60H21.1c-7,0-12.6-5-12.6-11.2V18c0-6.2,5.7-11.2,12.6-11.2h35.5c2.6,0,28.9-0.1,25.6,11.9
							c1.6-5.9-13.2-6.8-13.2,3.8l0.3,26.4C69.2,55,63.6,60,56.6,60z"
                />
                <path
                  fill="none"
                  stroke="#404041"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  d="M49.4,29.9
							c0-3.4,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1"
                />
                <path
                  fill="none"
                  stroke="#404041"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  d="M17.3,29.7
							c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1"
                />
                <path
                  fill="#58595B"
                  d="M42.3,60l14,0.1c7.3,0,12.9-4.5,12.9-11.4c0-6.3-0.1-8.1-0.1-8.1C61.6,40.6,42.3,52.2,42.3,60z"
                />
                <path
                  fill="#404041"
                  d="M21.6,6.7c-10,0-22.6,4-21.5,11.5c-0.3-2.7,8.4-6.7,8.4,0.2l0,5.6c3.5,3.1,3.8-4.4,11.8-6.1
							c8.1-1.6,9,3.3,18.8,3.3C52.1,21.2,51,8.7,45,6.7"
                />
                <path
                  fill="#FFAEEC"
                  d="M29.5,54.6h19.1c5.1,0,9.3-4.2,9.3-9.3v0c0-5.1-4.2-9.3-9.3-9.3H29.5c-5.1,0-9.3,4.2-9.3,9.3v0
							C20.2,50.4,24.4,54.6,29.5,54.6z"
                />
                <circle fill="#404041" cx="29.7" cy="41.6" r="2.3" />
                <circle fill="#404041" cx="49.4" cy="41.7" r="2.3" />
                <path
                  fill="#404041"
                  d="M75.4,22.5c-0.2,0-2.1-1.8-2.1-1.8s-1.1,0.4-1.1,2.3c0,1.9,0.1,5.5,0.1,5.5c0,0.8,0.7,1.4,1.5,1.4H74
							c0.8,0,1.4-0.6,1.4-1.4c0,0,0-0.6,0-3.4C75.3,22.2,75.4,22.5,75.4,22.5z"
                />
                <path
                  fill="#404041"
                  d="M58.9,7.2c-0.1,1.5,1.7,2.9,4.1,3c2.3,0.1,4.3-1,4.4-2.6S65.7,2,63.4,1.9C61.1,1.8,59,5.7,58.9,7.2z"
                />
                <path
                  fill="#404041"
                  d="M11.1,8.2c0.2,1.5,2.2,2.6,4.5,2.4c2.3-0.2,4.1-1.7,3.9-3.2c-0.2-1.5-2.5-5.6-4.8-5.4S10.9,6.6,11.1,8.2z"
                />
              </svg>
              <h1
                className="title-loading"
                style={{
                  margin: "-10px 5px 5px 5px",
                  fontWeight: "600",
                  fontSize: "25px",
                  color: "black",
                  position: "relative",
                  zIndex: 1000,
                }}
              >
                examoo
              </h1>
            </div>
          </a>
        </div>
        {/*  <div className="loading">Loading...</div> */}

        {/*
			<CookieConsent style={{zIndex: '9999'}}
				enableDeclineButton
				onAccept={handleAcceptCookie}
				onDecline={handleDeclineCookie}
			>
				This website uses cookies to enhance the user experience.
			</CookieConsent>
			*/}

        <CookieBanner
          message="This website uses cookies in order to work as intended 🍪"
          styles={{
            dialog: {
              display: "block",
              position: "fixed",
              bottom: "15px",
              background: "#000000c0",
              opacity: "1",
              width: "80%",
              borderRadius: "30px",
              padding: "20px",
              paddingTop: "15px",
              left: "0",
              right: "0",
              marginLeft: "auto",
              marginRight: "auto",
              zIndex: "10001",
              webkitBackdropFilter: "blur(10px) !important",
              backdropFilter: "blur(10px) !important",
              filter: "drop-shadow(0px -5px 13px #00000035)",
            },

            message: {
              color: "white",
              fontSize: "28px",
              lineHeight: "30px",
              fontWeight: "bold",
              margin: "10px",
              marginBottom: "20px",
            },

            policy: {
              color: "#bbb",
              fontSize: "16px",
              display: "flex",
              justifyContent: "center",
            },

            buttonWrapper: {
              display: "flex",
              justifyContent: "center",
            },

            selectPane: {
              padding: "3px 0px 35px",
              textAlign: "center !important",
              margin: "0px auto !important",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
            },
          }}
          wholeDomain={true}
          managePreferencesButtonText={"Manage cookies"}
          policyLink={"/cookies"}
          privacyPolicyLinkText={"Cookie Policy"}
          onAccept={() => {}} // necessary cookies here
          onAcceptPreferences={() => {}}
          onAcceptStatistics={() => {
            ReactGA.initialize("G-YC142WEB05");
          }}
          onAcceptMarketing={() => {}}
        />

        <p
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            marginTop: "100px",
            color: "#bfbfbf",
            fontSize: "24px",
            lineHeight: "29px",
          }}
        >
          Loading <br />
          past papers...
        </p>
      </>
    );

  return (
    <>
      {/* <div
        style={{
          width: "calc(100vw-16px)",
          backgroundColor: "#F4C12F",
          padding: "6px 8px",
          borderBottom: "1px solid black",
          textAlign: "center",
          lineHeight: "22px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        All AQA papers are now back, and up to date for 2025! 🥳
      </div> */}

      {/*
		<CookieConsent style={{zIndex: '9999'}}
			enableDeclineButton
			onAccept={handleAcceptCookie}
			onDecline={handleDeclineCookie}
      	>
			This website uses cookies to enhance the user experience.
		</CookieConsent>
		*/}

      <CookieBanner
        message="This website uses cookies in order to work as intended 🍪"
        styles={{
          dialog: {
            display: "block",
            position: "fixed",
            bottom: "15px",
            background: "#000000c0",
            opacity: "1",
            width: "80%",
            borderRadius: "30px",
            padding: "20px",
            paddingTop: "15px",
            left: "0",
            right: "0",
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: "10001",
            webkitBackdropFilter: "blur(10px) !important",
            backdropFilter: "blur(10px) !important",
            filter: "drop-shadow(0px -5px 13px #00000035)",
          },

          message: {
            color: "white",
            fontSize: "28px",
            lineHeight: "30px",
            fontWeight: "bold",
            margin: "10px",
            marginBottom: "20px",
          },

          policy: {
            color: "#bbb",
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
          },

          buttonWrapper: {
            display: "flex",
            justifyContent: "center",
          },

          selectPane: {
            padding: "3px 0px 35px",
            textAlign: "center !important",
            margin: "0px auto !important",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
          },
        }}
        wholeDomain={true}
        managePreferencesButtonText={"Manage cookies"}
        policyLink={"/cookies"}
        privacyPolicyLinkText={"Cookie Policy"}
        onAccept={() => {}}
        onAcceptPreferences={() => {}}
        onAcceptStatistics={() => {
          ReactGA.initialize("G-YC142WEB05");
        }}
        onAcceptMarketing={() => {}}
      />

      {/*
		<Helmet>
			<meta charSet="utf-8" />
			<title>yeAH EYAEHA </title>
		</Helmet>
		*/}

      <Inbetween
        pathNavBar={pathNavBar}
        setPathNavBar={setPathNavBar}
        qualData={qualData}
        setQualData={setQualData} // probs don't need?
        colourData={colourData}
        setColourData={setColourData} // probs don't need?
        subjData={subjData}
        setSubjData={setSubjData} // etc.
        examBoardData={examBoardData}
        setExamBoardData={setExamBoardData}
        paperTypeData={paperTypeData}
        setPaperTypeData={setPaperTypeData}
        testData={testData}
        setTestData={setTestData}
        paperData={paperData}
        //setPaperData={setPaperData}
      />
    </>
  );
}

export default Main;
